/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AHJ
 */
export interface AHJ {
    /**
     * 
     * @type {string}
     * @memberof AHJ
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof AHJ
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof AHJ
     */
    'county': string;
    /**
     * 
     * @type {string}
     * @memberof AHJ
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof AHJ
     */
    'adu_checklist'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AHJ
     */
    'adu_ordinance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AHJ
     */
    'adu_regulations'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AHJ
     */
    'adu_website'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AHJ
     */
    'design_match'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AHJ
     */
    'fire_separation'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AHJ
     */
    'gas_ban'?: boolean | null;
    /**
     * 
     * @type {AHJGeometry}
     * @memberof AHJ
     */
    'geometry'?: AHJGeometry | null;
    /**
     * 
     * @type {string}
     * @memberof AHJ
     */
    'impact_fees'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AHJ
     */
    'max_unit_size'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AHJ
     */
    'muni_code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AHJ
     */
    'permit_submittal_instructions'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AHJ
     */
    'zoning_map'?: string | null;
    /**
     * 
     * @type {Array<AHJApprovalRequirement>}
     * @memberof AHJ
     */
    'approval_requirements'?: Array<AHJApprovalRequirement> | null;
    /**
     * 
     * @type {Array<AHJEstimatingRequirement>}
     * @memberof AHJ
     */
    'estimating_requirements'?: Array<AHJEstimatingRequirement> | null;
    /**
     * 
     * @type {string}
     * @memberof AHJ
     */
    'final_requirements'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AHJ
     */
    'issuance_requirements'?: string | null;
    /**
     * 
     * @type {Array<AHJSubmittalRequirement>}
     * @memberof AHJ
     */
    'submittal_requirements'?: Array<AHJSubmittalRequirement> | null;
    /**
     * 
     * @type {number}
     * @memberof AHJ
     */
    'cornerlot_setback_feet_engineering'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AHJ
     */
    'cornerlot_setback_notes'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AHJ
     */
    'front_setback_feet_engineering'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AHJ
     */
    'front_setback_notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AHJ
     */
    'landings_in_setback'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AHJ
     */
    'primary_residence_setback_notes'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AHJ
     */
    'primary_residence_setback_feet_engineering'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AHJ
     */
    'side_and_rear_setbacks_feet_engineering'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AHJ
     */
    'side_and_rear_setbacks_notes'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AHJ
     */
    'structure_setback_feet_engineering'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AHJ
     */
    'structure_setback_notes'?: string | null;
    /**
     * 
     * @type {Array<ElectricDistrictSchema>}
     * @memberof AHJ
     */
    'electric_districts'?: Array<ElectricDistrictSchema> | null;
    /**
     * 
     * @type {Array<FireDistrictSchema>}
     * @memberof AHJ
     */
    'fire_districts'?: Array<FireDistrictSchema> | null;
    /**
     * 
     * @type {Array<SanitationDistrictSchema>}
     * @memberof AHJ
     */
    'sanitation_districts'?: Array<SanitationDistrictSchema> | null;
    /**
     * 
     * @type {Array<SchoolDistrictSchema>}
     * @memberof AHJ
     */
    'school_districts'?: Array<SchoolDistrictSchema> | null;
    /**
     * 
     * @type {Array<WaterDistrictSchema>}
     * @memberof AHJ
     */
    'water_districts'?: Array<WaterDistrictSchema> | null;
    /**
     * 
     * @type {string}
     * @memberof AHJ
     */
    'created_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AHJ
     */
    'updated_at'?: string | null;
}
/**
 * 
 * @export
 * @interface AHJApprovalRequirement
 */
export interface AHJApprovalRequirement {
    /**
     * 
     * @type {string}
     * @memberof AHJApprovalRequirement
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof AHJApprovalRequirement
     */
    'requirement': string;
}
/**
 * 
 * @export
 * @interface AHJEstimatingRequirement
 */
export interface AHJEstimatingRequirement {
    /**
     * 
     * @type {string}
     * @memberof AHJEstimatingRequirement
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof AHJEstimatingRequirement
     */
    'requirement': string;
}
/**
 * 
 * @export
 * @interface AHJGeometry
 */
export interface AHJGeometry {
    /**
     * 
     * @type {string}
     * @memberof AHJGeometry
     */
    'type'?: string | null;
    /**
     * 
     * @type {Array<Array<Array<Array<number>>>>}
     * @memberof AHJGeometry
     */
    'coordinates'?: Array<Array<Array<Array<number>>>> | null;
}
/**
 * 
 * @export
 * @interface AHJSubmittalRequirement
 */
export interface AHJSubmittalRequirement {
    /**
     * 
     * @type {string}
     * @memberof AHJSubmittalRequirement
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof AHJSubmittalRequirement
     */
    'requirement': string;
}
/**
 * 
 * @export
 * @interface AHJWithDistricts
 */
export interface AHJWithDistricts {
    /**
     * 
     * @type {string}
     * @memberof AHJWithDistricts
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof AHJWithDistricts
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof AHJWithDistricts
     */
    'county': string;
    /**
     * 
     * @type {string}
     * @memberof AHJWithDistricts
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof AHJWithDistricts
     */
    'adu_checklist'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AHJWithDistricts
     */
    'adu_ordinance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AHJWithDistricts
     */
    'adu_regulations'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AHJWithDistricts
     */
    'adu_website'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AHJWithDistricts
     */
    'design_match'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AHJWithDistricts
     */
    'fire_separation'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AHJWithDistricts
     */
    'gas_ban'?: boolean | null;
    /**
     * 
     * @type {AHJGeometry}
     * @memberof AHJWithDistricts
     */
    'geometry'?: AHJGeometry | null;
    /**
     * 
     * @type {string}
     * @memberof AHJWithDistricts
     */
    'impact_fees'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AHJWithDistricts
     */
    'max_unit_size'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AHJWithDistricts
     */
    'muni_code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AHJWithDistricts
     */
    'permit_submittal_instructions'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AHJWithDistricts
     */
    'zoning_map'?: string | null;
    /**
     * 
     * @type {Array<AHJApprovalRequirement>}
     * @memberof AHJWithDistricts
     */
    'approval_requirements'?: Array<AHJApprovalRequirement> | null;
    /**
     * 
     * @type {Array<AHJEstimatingRequirement>}
     * @memberof AHJWithDistricts
     */
    'estimating_requirements'?: Array<AHJEstimatingRequirement> | null;
    /**
     * 
     * @type {string}
     * @memberof AHJWithDistricts
     */
    'final_requirements'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AHJWithDistricts
     */
    'issuance_requirements'?: string | null;
    /**
     * 
     * @type {Array<AHJSubmittalRequirement>}
     * @memberof AHJWithDistricts
     */
    'submittal_requirements'?: Array<AHJSubmittalRequirement> | null;
    /**
     * 
     * @type {number}
     * @memberof AHJWithDistricts
     */
    'cornerlot_setback_feet_engineering'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AHJWithDistricts
     */
    'cornerlot_setback_notes'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AHJWithDistricts
     */
    'front_setback_feet_engineering'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AHJWithDistricts
     */
    'front_setback_notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AHJWithDistricts
     */
    'landings_in_setback'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AHJWithDistricts
     */
    'primary_residence_setback_notes'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AHJWithDistricts
     */
    'primary_residence_setback_feet_engineering'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AHJWithDistricts
     */
    'side_and_rear_setbacks_feet_engineering'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AHJWithDistricts
     */
    'side_and_rear_setbacks_notes'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AHJWithDistricts
     */
    'structure_setback_feet_engineering'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AHJWithDistricts
     */
    'structure_setback_notes'?: string | null;
    /**
     * 
     * @type {Array<ElectricDistrictSchema>}
     * @memberof AHJWithDistricts
     */
    'electric_districts'?: Array<ElectricDistrictSchema> | null;
    /**
     * 
     * @type {Array<FireDistrictSchema>}
     * @memberof AHJWithDistricts
     */
    'fire_districts'?: Array<FireDistrictSchema> | null;
    /**
     * 
     * @type {Array<SanitationDistrictSchema>}
     * @memberof AHJWithDistricts
     */
    'sanitation_districts'?: Array<SanitationDistrictSchema> | null;
    /**
     * 
     * @type {Array<SchoolDistrictSchema>}
     * @memberof AHJWithDistricts
     */
    'school_districts'?: Array<SchoolDistrictSchema> | null;
    /**
     * 
     * @type {Array<WaterDistrictSchema>}
     * @memberof AHJWithDistricts
     */
    'water_districts'?: Array<WaterDistrictSchema> | null;
}
/**
 * 
 * @export
 * @interface AddDiscountSchema
 */
export interface AddDiscountSchema {
    /**
     * 
     * @type {string}
     * @memberof AddDiscountSchema
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AddDiscountSchema
     */
    'notes'?: string;
    /**
     * 
     * @type {number}
     * @memberof AddDiscountSchema
     */
    'price_low': number;
    /**
     * 
     * @type {number}
     * @memberof AddDiscountSchema
     */
    'price_high': number;
}
/**
 * The answer to the additional information question
 * @export
 * @interface AdditionalInformationAnswer
 */
export interface AdditionalInformationAnswer {
}
/**
 * The auth user id (From Firebase) of the lead
 * @export
 * @interface AuthUserId
 */
export interface AuthUserId {
}
/**
 * The answer to the budget question
 * @export
 * @interface BudgetAnswer
 */
export interface BudgetAnswer {
}
/**
 * 
 * @export
 * @interface ChatRequest
 */
export interface ChatRequest {
    /**
     * 
     * @type {string}
     * @memberof ChatRequest
     */
    'prompt': string;
    /**
     * 
     * @type {Array<HistoryMessage>}
     * @memberof ChatRequest
     */
    'chat_history'?: Array<HistoryMessage>;
}
/**
 * Address component
 * @export
 * @interface City
 */
export interface City {
}
/**
 * Additional notes about the client that will be pushed to Salesforce
 * @export
 * @interface ClientNotes
 */
export interface ClientNotes {
}
/**
 * Company name
 * @export
 * @interface Company
 */
export interface Company {
}
/**
 * 
 * @export
 * @interface CostCodeRequest
 */
export interface CostCodeRequest {
    /**
     * 
     * @type {string}
     * @memberof CostCodeRequest
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof CostCodeRequest
     */
    'budget_category': string;
    /**
     * 
     * @type {string}
     * @memberof CostCodeRequest
     */
    'additional_details': string;
    /**
     * 
     * @type {number}
     * @memberof CostCodeRequest
     */
    'unit_square_feet': number;
}
/**
 * Schema for cost code response.
 * @export
 * @interface CostCodeResponse
 */
export interface CostCodeResponse {
    /**
     * Unique identifier for the cost code
     * @type {string}
     * @memberof CostCodeResponse
     */
    'uuid': string;
    /**
     * Detail of the cost code
     * @type {string}
     * @memberof CostCodeResponse
     */
    'villa_detail': string;
    /**
     * Full cost code
     * @type {string}
     * @memberof CostCodeResponse
     */
    'cost_code': string;
    /**
     * Compounded nomenclature
     * @type {string}
     * @memberof CostCodeResponse
     */
    'compounded_nomenclature': string;
}
/**
 * Address component
 * @export
 * @interface Country
 */
export interface Country {
}
/**
 * Address component
 * @export
 * @interface County
 */
export interface County {
}
/**
 * 
 * @export
 * @interface CreateAHJRequirement
 */
export interface CreateAHJRequirement {
    /**
     * 
     * @type {string}
     * @memberof CreateAHJRequirement
     */
    'requirement': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateAHJRequirement
     */
    'ahjs'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface CreateAHJSchema
 */
export interface CreateAHJSchema {
    /**
     * 
     * @type {string}
     * @memberof CreateAHJSchema
     */
    'uuid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateAHJSchema
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof CreateAHJSchema
     */
    'county': string;
    /**
     * 
     * @type {string}
     * @memberof CreateAHJSchema
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof CreateAHJSchema
     */
    'adu_checklist'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateAHJSchema
     */
    'adu_ordinance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateAHJSchema
     */
    'adu_regulations'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateAHJSchema
     */
    'adu_website'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateAHJSchema
     */
    'design_match'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CreateAHJSchema
     */
    'fire_separation'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateAHJSchema
     */
    'gas_ban'?: boolean | null;
    /**
     * 
     * @type {AHJGeometry}
     * @memberof CreateAHJSchema
     */
    'geometry'?: AHJGeometry | null;
    /**
     * 
     * @type {string}
     * @memberof CreateAHJSchema
     */
    'impact_fees'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateAHJSchema
     */
    'max_unit_size'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateAHJSchema
     */
    'muni_code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateAHJSchema
     */
    'permit_submittal_instructions'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateAHJSchema
     */
    'zoning_map'?: string | null;
    /**
     * 
     * @type {Array<AHJApprovalRequirement>}
     * @memberof CreateAHJSchema
     */
    'approval_requirements'?: Array<AHJApprovalRequirement> | null;
    /**
     * 
     * @type {Array<AHJEstimatingRequirement>}
     * @memberof CreateAHJSchema
     */
    'estimating_requirements'?: Array<AHJEstimatingRequirement> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateAHJSchema
     */
    'final_requirements'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateAHJSchema
     */
    'issuance_requirements'?: string | null;
    /**
     * 
     * @type {Array<AHJSubmittalRequirement>}
     * @memberof CreateAHJSchema
     */
    'submittal_requirements'?: Array<AHJSubmittalRequirement> | null;
    /**
     * 
     * @type {number}
     * @memberof CreateAHJSchema
     */
    'cornerlot_setback_feet_engineering'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateAHJSchema
     */
    'cornerlot_setback_notes'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateAHJSchema
     */
    'front_setback_feet_engineering'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateAHJSchema
     */
    'front_setback_notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateAHJSchema
     */
    'landings_in_setback'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateAHJSchema
     */
    'primary_residence_setback_notes'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateAHJSchema
     */
    'primary_residence_setback_feet_engineering'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateAHJSchema
     */
    'side_and_rear_setbacks_feet_engineering'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateAHJSchema
     */
    'side_and_rear_setbacks_notes'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateAHJSchema
     */
    'structure_setback_feet_engineering'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateAHJSchema
     */
    'structure_setback_notes'?: string | null;
    /**
     * 
     * @type {Array<ElectricDistrictSchema>}
     * @memberof CreateAHJSchema
     */
    'electric_districts'?: Array<ElectricDistrictSchema> | null;
    /**
     * 
     * @type {Array<FireDistrictSchema>}
     * @memberof CreateAHJSchema
     */
    'fire_districts'?: Array<FireDistrictSchema> | null;
    /**
     * 
     * @type {Array<SanitationDistrictSchema>}
     * @memberof CreateAHJSchema
     */
    'sanitation_districts'?: Array<SanitationDistrictSchema> | null;
    /**
     * 
     * @type {Array<SchoolDistrictSchema>}
     * @memberof CreateAHJSchema
     */
    'school_districts'?: Array<SchoolDistrictSchema> | null;
    /**
     * 
     * @type {Array<WaterDistrictSchema>}
     * @memberof CreateAHJSchema
     */
    'water_districts'?: Array<WaterDistrictSchema> | null;
}
/**
 * Schema for creating a new cost code.
 * @export
 * @interface CreateCostCodeSchema
 */
export interface CreateCostCodeSchema {
    /**
     * Detailed description of the cost code
     * @type {string}
     * @memberof CreateCostCodeSchema
     */
    'villa_detail': string;
    /**
     * UUID of segment 1
     * @type {string}
     * @memberof CreateCostCodeSchema
     */
    'segment_1_id': string;
    /**
     * UUID of segment 2
     * @type {string}
     * @memberof CreateCostCodeSchema
     */
    'segment_2_id': string;
    /**
     * Two-digit scope number
     * @type {string}
     * @memberof CreateCostCodeSchema
     */
    'scope_number': string;
}
/**
 * 
 * @export
 * @interface CreateElectricDistrictSchema
 */
export interface CreateElectricDistrictSchema {
    /**
     * 
     * @type {string}
     * @memberof CreateElectricDistrictSchema
     */
    'uuid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateElectricDistrictSchema
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateElectricDistrictSchema
     */
    'district_type': string;
    /**
     * 
     * @type {string}
     * @memberof CreateElectricDistrictSchema
     */
    'street_address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateElectricDistrictSchema
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateElectricDistrictSchema
     */
    'county'?: string | null;
    /**
     * 
     * @type {StateEnum}
     * @memberof CreateElectricDistrictSchema
     */
    'state'?: StateEnum | null;
    /**
     * 
     * @type {string}
     * @memberof CreateElectricDistrictSchema
     */
    'zip_code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateElectricDistrictSchema
     */
    'email_contact'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateElectricDistrictSchema
     */
    'contact_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateElectricDistrictSchema
     */
    'contact_information'?: string | null;
    /**
     * 
     * @type {OpsTerritoryEnum}
     * @memberof CreateElectricDistrictSchema
     */
    'ops_territory'?: OpsTerritoryEnum | null;
    /**
     * 
     * @type {string}
     * @memberof CreateElectricDistrictSchema
     */
    'service_map_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateElectricDistrictSchema
     */
    'website_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateElectricDistrictSchema
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateElectricDistrictSchema
     */
    'notes_estimating'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateElectricDistrictSchema
     */
    'ahj_uuids'?: Array<string> | null;
}


/**
 * 
 * @export
 * @interface CreateEstimateLineItemSchema
 */
export interface CreateEstimateLineItemSchema {
    /**
     * 
     * @type {string}
     * @memberof CreateEstimateLineItemSchema
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEstimateLineItemSchema
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateEstimateLineItemSchema
     */
    'bucket': string;
    /**
     * 
     * @type {number}
     * @memberof CreateEstimateLineItemSchema
     */
    'price_low': number;
    /**
     * 
     * @type {number}
     * @memberof CreateEstimateLineItemSchema
     */
    'price_high': number;
    /**
     * 
     * @type {number}
     * @memberof CreateEstimateLineItemSchema
     */
    'cost_low': number;
    /**
     * 
     * @type {number}
     * @memberof CreateEstimateLineItemSchema
     */
    'cost_high': number;
}
/**
 * 
 * @export
 * @interface CreateEstimateSchema
 */
export interface CreateEstimateSchema {
    /**
     * 
     * @type {Array<CreateEstimateLineItemSchema>}
     * @memberof CreateEstimateSchema
     */
    'estimate_line_items': Array<CreateEstimateLineItemSchema>;
    /**
     * 
     * @type {Array<OandPPercentageSchema>}
     * @memberof CreateEstimateSchema
     */
    'o_and_p_percentages'?: Array<OandPPercentageSchema> | null;
    /**
     * 
     * @type {SalesTaxModifierSchema}
     * @memberof CreateEstimateSchema
     */
    'sales_tax_modifiers'?: SalesTaxModifierSchema | null;
    /**
     * 
     * @type {string}
     * @memberof CreateEstimateSchema
     */
    'mode'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateEstimateSchema
     */
    'published'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof CreateEstimateSchema
     */
    'phase_1_fee_price'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateEstimateSchema
     */
    'phase_2_fee_price'?: number | null;
}
/**
 * 
 * @export
 * @interface CreateFireDistrictSchema
 */
export interface CreateFireDistrictSchema {
    /**
     * 
     * @type {string}
     * @memberof CreateFireDistrictSchema
     */
    'uuid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFireDistrictSchema
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFireDistrictSchema
     */
    'district_type': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFireDistrictSchema
     */
    'street_address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFireDistrictSchema
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFireDistrictSchema
     */
    'county'?: string | null;
    /**
     * 
     * @type {StateEnum}
     * @memberof CreateFireDistrictSchema
     */
    'state'?: StateEnum | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFireDistrictSchema
     */
    'zip_code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFireDistrictSchema
     */
    'email_contact'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFireDistrictSchema
     */
    'contact_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFireDistrictSchema
     */
    'contact_information'?: string | null;
    /**
     * 
     * @type {OpsTerritoryEnum}
     * @memberof CreateFireDistrictSchema
     */
    'ops_territory'?: OpsTerritoryEnum | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFireDistrictSchema
     */
    'service_map_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFireDistrictSchema
     */
    'website_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFireDistrictSchema
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFireDistrictSchema
     */
    'notes_estimating'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFireDistrictSchema
     */
    'fire_plan_instructions'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFireDistrictSchema
     */
    'fee_notes'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateFireDistrictSchema
     */
    'fee_cents'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFireDistrictSchema
     */
    'fire_access'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFireDistrictSchema
     */
    'hydrant_distance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateFireDistrictSchema
     */
    'fire_sprinklers'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateFireDistrictSchema
     */
    'ahj_uuids'?: Array<string> | null;
}


/**
 * Schema for creating a new Firestore factory ADU.
 * @export
 * @interface CreateFirestoreFactoryADUSchema
 */
export interface CreateFirestoreFactoryADUSchema {
    /**
     * 
     * @type {string}
     * @memberof CreateFirestoreFactoryADUSchema
     */
    'firestore_id': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFirestoreFactoryADUSchema
     */
    'factory_id': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFirestoreFactoryADUSchema
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof CreateFirestoreFactoryADUSchema
     */
    'square_footage': number;
    /**
     * 
     * @type {number}
     * @memberof CreateFirestoreFactoryADUSchema
     */
    'bedrooms': number;
    /**
     * 
     * @type {number}
     * @memberof CreateFirestoreFactoryADUSchema
     */
    'bathrooms': number;
    /**
     * 
     * @type {string}
     * @memberof CreateFirestoreFactoryADUSchema
     */
    'description'?: string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CreateFirestoreFactoryADUSchema
     */
    'features'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CreateFirestoreFactoryADUSchema
     */
    'pricing'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CreateFirestoreFactoryADUSchema
     */
    'images'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CreateFirestoreFactoryADUSchema
     */
    'specifications'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface CreateGroupRequest
 */
export interface CreateGroupRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateGroupRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateGroupRequest
     */
    'description': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateGroupRequest
     */
    'permission_ids'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface CreateInstantQuoteProductPricingItemSchema
 */
export interface CreateInstantQuoteProductPricingItemSchema {
    /**
     * The item slug (underscores and lowercase)
     * @type {string}
     * @memberof CreateInstantQuoteProductPricingItemSchema
     */
    'slug': string;
    /**
     * The price of the item
     * @type {number}
     * @memberof CreateInstantQuoteProductPricingItemSchema
     */
    'price': number;
}
/**
 * 
 * @export
 * @interface CreateLeadSchema
 */
export interface CreateLeadSchema {
    [key: string]: any;

    /**
     * The first name of the lead
     * @type {string}
     * @memberof CreateLeadSchema
     */
    'first_name': string;
    /**
     * The last name of the lead
     * @type {string}
     * @memberof CreateLeadSchema
     */
    'last_name': string;
    /**
     * The email of the lead
     * @type {string}
     * @memberof CreateLeadSchema
     */
    'email': string;
    /**
     * 
     * @type {PhoneNumber}
     * @memberof CreateLeadSchema
     */
    'phone_number'?: PhoneNumber;
    /**
     * 
     * @type {CreatedFrom}
     * @memberof CreateLeadSchema
     */
    'created_from'?: CreatedFrom;
    /**
     * 
     * @type {LeadSegment}
     * @memberof CreateLeadSchema
     */
    'lead_segment'?: LeadSegment;
    /**
     * 
     * @type {LeadSource}
     * @memberof CreateLeadSchema
     */
    'lead_source'?: LeadSource;
    /**
     * 
     * @type {LeadSourceDetail}
     * @memberof CreateLeadSchema
     */
    'lead_source_detail'?: LeadSourceDetail;
    /**
     * 
     * @type {AuthUserId}
     * @memberof CreateLeadSchema
     */
    'auth_user_id'?: AuthUserId;
    /**
     * 
     * @type {Latitude}
     * @memberof CreateLeadSchema
     */
    'latitude'?: Latitude;
    /**
     * 
     * @type {Longitude}
     * @memberof CreateLeadSchema
     */
    'longitude'?: Longitude;
    /**
     * 
     * @type {City}
     * @memberof CreateLeadSchema
     */
    'city'?: City;
    /**
     * 
     * @type {State}
     * @memberof CreateLeadSchema
     */
    'state'?: State;
    /**
     * 
     * @type {County}
     * @memberof CreateLeadSchema
     */
    'county'?: County;
    /**
     * 
     * @type {Country}
     * @memberof CreateLeadSchema
     */
    'country'?: Country;
    /**
     * 
     * @type {PostalCode}
     * @memberof CreateLeadSchema
     */
    'postal_code'?: PostalCode;
    /**
     * 
     * @type {Street}
     * @memberof CreateLeadSchema
     */
    'street'?: Street;
    /**
     * 
     * @type {Company}
     * @memberof CreateLeadSchema
     */
    'company'?: Company;
    /**
     * 
     * @type {MarketingOptIn}
     * @memberof CreateLeadSchema
     */
    'marketing_opt_in'?: MarketingOptIn;
    /**
     * 
     * @type {PropertyType}
     * @memberof CreateLeadSchema
     */
    'property_type'?: PropertyType;
    /**
     * 
     * @type {ClientNotes}
     * @memberof CreateLeadSchema
     */
    'client_notes'?: ClientNotes;
}
/**
 * 
 * @export
 * @interface CreatePermissionRequest
 */
export interface CreatePermissionRequest {
    /**
     * 
     * @type {string}
     * @memberof CreatePermissionRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePermissionRequest
     */
    'description': string;
}
/**
 * Schema for creating a new prefab factory.
 * @export
 * @interface CreatePrefabFactorySchema
 */
export interface CreatePrefabFactorySchema {
    /**
     * 
     * @type {string}
     * @memberof CreatePrefabFactorySchema
     */
    'internal_name': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePrefabFactorySchema
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePrefabFactorySchema
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePrefabFactorySchema
     */
    'country': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePrefabFactorySchema
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePrefabFactorySchema
     */
    'street': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePrefabFactorySchema
     */
    'zip': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePrefabFactorySchema
     */
    'county'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreatePrefabFactorySchema
     */
    'latitude'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreatePrefabFactorySchema
     */
    'longitude'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePrefabFactorySchema
     */
    'street_number'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateSanitationDistrictSchema
 */
export interface CreateSanitationDistrictSchema {
    /**
     * 
     * @type {string}
     * @memberof CreateSanitationDistrictSchema
     */
    'uuid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateSanitationDistrictSchema
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateSanitationDistrictSchema
     */
    'district_type': string;
    /**
     * 
     * @type {string}
     * @memberof CreateSanitationDistrictSchema
     */
    'street_address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateSanitationDistrictSchema
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateSanitationDistrictSchema
     */
    'county'?: string | null;
    /**
     * 
     * @type {StateEnum}
     * @memberof CreateSanitationDistrictSchema
     */
    'state'?: StateEnum | null;
    /**
     * 
     * @type {string}
     * @memberof CreateSanitationDistrictSchema
     */
    'zip_code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateSanitationDistrictSchema
     */
    'email_contact'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateSanitationDistrictSchema
     */
    'contact_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateSanitationDistrictSchema
     */
    'contact_information'?: string | null;
    /**
     * 
     * @type {OpsTerritoryEnum}
     * @memberof CreateSanitationDistrictSchema
     */
    'ops_territory'?: OpsTerritoryEnum | null;
    /**
     * 
     * @type {string}
     * @memberof CreateSanitationDistrictSchema
     */
    'service_map_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateSanitationDistrictSchema
     */
    'website_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateSanitationDistrictSchema
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateSanitationDistrictSchema
     */
    'notes_estimating'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateSanitationDistrictSchema
     */
    'will_serve_letter_instructions'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateSanitationDistrictSchema
     */
    'connection_fee_cents'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateSanitationDistrictSchema
     */
    'connection_fee_instructions'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateSanitationDistrictSchema
     */
    'connection_fee_notes'?: string | null;
    /**
     * 
     * @type {SometimesAlwaysNeverEnum}
     * @memberof CreateSanitationDistrictSchema
     */
    'connection_permit_required'?: SometimesAlwaysNeverEnum | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateSanitationDistrictSchema
     */
    'ahj_uuids'?: Array<string> | null;
}


/**
 * 
 * @export
 * @interface CreateSchoolDistrictSchema
 */
export interface CreateSchoolDistrictSchema {
    /**
     * 
     * @type {string}
     * @memberof CreateSchoolDistrictSchema
     */
    'uuid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateSchoolDistrictSchema
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateSchoolDistrictSchema
     */
    'district_type': string;
    /**
     * 
     * @type {string}
     * @memberof CreateSchoolDistrictSchema
     */
    'street_address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateSchoolDistrictSchema
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateSchoolDistrictSchema
     */
    'county'?: string | null;
    /**
     * 
     * @type {StateEnum}
     * @memberof CreateSchoolDistrictSchema
     */
    'state'?: StateEnum | null;
    /**
     * 
     * @type {string}
     * @memberof CreateSchoolDistrictSchema
     */
    'zip_code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateSchoolDistrictSchema
     */
    'email_contact'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateSchoolDistrictSchema
     */
    'contact_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateSchoolDistrictSchema
     */
    'contact_information'?: string | null;
    /**
     * 
     * @type {OpsTerritoryEnum}
     * @memberof CreateSchoolDistrictSchema
     */
    'ops_territory'?: OpsTerritoryEnum | null;
    /**
     * 
     * @type {string}
     * @memberof CreateSchoolDistrictSchema
     */
    'service_map_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateSchoolDistrictSchema
     */
    'website_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateSchoolDistrictSchema
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateSchoolDistrictSchema
     */
    'notes_estimating'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateSchoolDistrictSchema
     */
    'payment_instructions'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateSchoolDistrictSchema
     */
    'payment_website'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateSchoolDistrictSchema
     */
    'ahj_uuids'?: Array<string> | null;
}


/**
 * Schema for creating a new Segment 1 entry.
 * @export
 * @interface CreateSegment1Schema
 */
export interface CreateSegment1Schema {
    /**
     * Two-digit code
     * @type {string}
     * @memberof CreateSegment1Schema
     */
    'code': string;
    /**
     * Villa name for the segment
     * @type {string}
     * @memberof CreateSegment1Schema
     */
    'villa_name': string;
    /**
     * CSI name for the segment
     * @type {string}
     * @memberof CreateSegment1Schema
     */
    'csi_name': string;
}
/**
 * Schema for creating a new Segment 2 entry.
 * @export
 * @interface CreateSegment2Schema
 */
export interface CreateSegment2Schema {
    /**
     * Two-digit code
     * @type {string}
     * @memberof CreateSegment2Schema
     */
    'code': string;
    /**
     * Villa name for the segment
     * @type {string}
     * @memberof CreateSegment2Schema
     */
    'villa_name': string;
}
/**
 * 
 * @export
 * @interface CreateWaterDistrictSchema
 */
export interface CreateWaterDistrictSchema {
    /**
     * 
     * @type {string}
     * @memberof CreateWaterDistrictSchema
     */
    'uuid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateWaterDistrictSchema
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateWaterDistrictSchema
     */
    'district_type': string;
    /**
     * 
     * @type {string}
     * @memberof CreateWaterDistrictSchema
     */
    'street_address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateWaterDistrictSchema
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateWaterDistrictSchema
     */
    'county'?: string | null;
    /**
     * 
     * @type {StateEnum}
     * @memberof CreateWaterDistrictSchema
     */
    'state'?: StateEnum | null;
    /**
     * 
     * @type {string}
     * @memberof CreateWaterDistrictSchema
     */
    'zip_code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateWaterDistrictSchema
     */
    'email_contact'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateWaterDistrictSchema
     */
    'contact_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateWaterDistrictSchema
     */
    'contact_information'?: string | null;
    /**
     * 
     * @type {OpsTerritoryEnum}
     * @memberof CreateWaterDistrictSchema
     */
    'ops_territory'?: OpsTerritoryEnum | null;
    /**
     * 
     * @type {string}
     * @memberof CreateWaterDistrictSchema
     */
    'service_map_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateWaterDistrictSchema
     */
    'website_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateWaterDistrictSchema
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateWaterDistrictSchema
     */
    'notes_estimating'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateWaterDistrictSchema
     */
    'flow_test_instructions'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateWaterDistrictSchema
     */
    'flow_test_fee_cents'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateWaterDistrictSchema
     */
    'flow_contact'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateWaterDistrictSchema
     */
    'flow_website'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateWaterDistrictSchema
     */
    'connection_fee_cents'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateWaterDistrictSchema
     */
    'connection_fee_instructions'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateWaterDistrictSchema
     */
    'connection_fee_notes'?: string | null;
    /**
     * 
     * @type {SometimesAlwaysNeverEnum}
     * @memberof CreateWaterDistrictSchema
     */
    'connection_permit_required'?: SometimesAlwaysNeverEnum | null;
    /**
     * 
     * @type {string}
     * @memberof CreateWaterDistrictSchema
     */
    'connection_permit_instructions'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateWaterDistrictSchema
     */
    'will_serve_letter_instructions'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateWaterDistrictSchema
     */
    'ahj_uuids'?: Array<string> | null;
}


/**
 * The source where the lead was created from
 * @export
 * @interface CreatedFrom
 */
export interface CreatedFrom {
}
/**
 * Schema for bulk deletion of Firestore factory ADUs.
 * @export
 * @interface DeleteMultipleFirestoreFactoryADUsSchema
 */
export interface DeleteMultipleFirestoreFactoryADUsSchema {
    /**
     * 
     * @type {Array<string>}
     * @memberof DeleteMultipleFirestoreFactoryADUsSchema
     */
    'factory_adu_ids': Array<string>;
}
/**
 * Schema for bulk deletion of prefab factories.
 * @export
 * @interface DeleteMultiplePrefabFactoriesSchema
 */
export interface DeleteMultiplePrefabFactoriesSchema {
    /**
     * 
     * @type {Array<string>}
     * @memberof DeleteMultiplePrefabFactoriesSchema
     */
    'prefab_factory_ids': Array<string>;
}
/**
 * 
 * @export
 * @interface DesignLock
 */
export interface DesignLock {
    /**
     * 
     * @type {string}
     * @memberof DesignLock
     */
    'edited_by_email'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DesignLock
     */
    'edited_timestamp'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof DesignLock
     */
    'is_locked'?: boolean;
}
/**
 * 
 * @export
 * @interface ElectricDistrictSchema
 */
export interface ElectricDistrictSchema {
    /**
     * 
     * @type {string}
     * @memberof ElectricDistrictSchema
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof ElectricDistrictSchema
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ElectricDistrictSchema
     */
    'district_type': string;
    /**
     * 
     * @type {string}
     * @memberof ElectricDistrictSchema
     */
    'street_address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ElectricDistrictSchema
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ElectricDistrictSchema
     */
    'county'?: string | null;
    /**
     * 
     * @type {StateEnum}
     * @memberof ElectricDistrictSchema
     */
    'state'?: StateEnum | null;
    /**
     * 
     * @type {string}
     * @memberof ElectricDistrictSchema
     */
    'zip_code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ElectricDistrictSchema
     */
    'email_contact'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ElectricDistrictSchema
     */
    'contact_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ElectricDistrictSchema
     */
    'contact_information'?: string | null;
    /**
     * 
     * @type {OpsTerritoryEnum}
     * @memberof ElectricDistrictSchema
     */
    'ops_territory'?: OpsTerritoryEnum | null;
    /**
     * 
     * @type {string}
     * @memberof ElectricDistrictSchema
     */
    'service_map_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ElectricDistrictSchema
     */
    'website_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ElectricDistrictSchema
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ElectricDistrictSchema
     */
    'notes_estimating'?: string | null;
}


/**
 * 
 * @export
 * @interface ElectricDistrictWithAHJs
 */
export interface ElectricDistrictWithAHJs {
    /**
     * 
     * @type {string}
     * @memberof ElectricDistrictWithAHJs
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof ElectricDistrictWithAHJs
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ElectricDistrictWithAHJs
     */
    'district_type': string;
    /**
     * 
     * @type {string}
     * @memberof ElectricDistrictWithAHJs
     */
    'street_address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ElectricDistrictWithAHJs
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ElectricDistrictWithAHJs
     */
    'county'?: string | null;
    /**
     * 
     * @type {StateEnum}
     * @memberof ElectricDistrictWithAHJs
     */
    'state'?: StateEnum | null;
    /**
     * 
     * @type {string}
     * @memberof ElectricDistrictWithAHJs
     */
    'zip_code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ElectricDistrictWithAHJs
     */
    'email_contact'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ElectricDistrictWithAHJs
     */
    'contact_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ElectricDistrictWithAHJs
     */
    'contact_information'?: string | null;
    /**
     * 
     * @type {OpsTerritoryEnum}
     * @memberof ElectricDistrictWithAHJs
     */
    'ops_territory'?: OpsTerritoryEnum | null;
    /**
     * 
     * @type {string}
     * @memberof ElectricDistrictWithAHJs
     */
    'service_map_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ElectricDistrictWithAHJs
     */
    'website_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ElectricDistrictWithAHJs
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ElectricDistrictWithAHJs
     */
    'notes_estimating'?: string | null;
    /**
     * 
     * @type {Array<AHJ>}
     * @memberof ElectricDistrictWithAHJs
     */
    'ahjs': Array<AHJ>;
}


/**
 * 
 * @export
 * @interface EmployeeResponse
 */
export interface EmployeeResponse {
    /**
     * 
     * @type {string}
     * @memberof EmployeeResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeResponse
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeResponse
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeResponse
     */
    'last_name': string;
    /**
     * 
     * @type {Array<GroupResponse>}
     * @memberof EmployeeResponse
     */
    'groups': Array<GroupResponse>;
}
/**
 * 
 * @export
 * @interface EstimateId
 */
export interface EstimateId {
    /**
     * 
     * @type {string}
     * @memberof EstimateId
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof EstimateId
     */
    'created_at': string;
}
/**
 * 
 * @export
 * @interface EventbridgeEventSchema
 */
export interface EventbridgeEventSchema {
    /**
     * 
     * @type {string}
     * @memberof EventbridgeEventSchema
     */
    'version': string;
    /**
     * 
     * @type {string}
     * @memberof EventbridgeEventSchema
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof EventbridgeEventSchema
     */
    'detail-type': string;
    /**
     * 
     * @type {string}
     * @memberof EventbridgeEventSchema
     */
    'source': string;
    /**
     * 
     * @type {string}
     * @memberof EventbridgeEventSchema
     */
    'account': string;
    /**
     * 
     * @type {string}
     * @memberof EventbridgeEventSchema
     */
    'time': string;
    /**
     * 
     * @type {string}
     * @memberof EventbridgeEventSchema
     */
    'region': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof EventbridgeEventSchema
     */
    'resources': Array<string>;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof EventbridgeEventSchema
     */
    'detail': { [key: string]: any; };
}
/**
 * Schema for bulk delete request.
 * @export
 * @interface FactoryADUBulkDeleteRequest
 */
export interface FactoryADUBulkDeleteRequest {
    /**
     * List of factory ADU UUIDs to delete
     * @type {Array<string>}
     * @memberof FactoryADUBulkDeleteRequest
     */
    'uuids': Array<string>;
}
/**
 * Schema for bulk delete response.
 * @export
 * @interface FactoryADUBulkDeleteResponse
 */
export interface FactoryADUBulkDeleteResponse {
    /**
     * Whether the deletion was successful
     * @type {boolean}
     * @memberof FactoryADUBulkDeleteResponse
     */
    'success': boolean;
    /**
     * Number of factory ADUs deleted
     * @type {number}
     * @memberof FactoryADUBulkDeleteResponse
     */
    'deleted_count': number;
    /**
     * List of deleted factory ADU UUIDs
     * @type {Array<string>}
     * @memberof FactoryADUBulkDeleteResponse
     */
    'uuids': Array<string>;
}
/**
 * Schema for creating a factory ADU.
 * @export
 * @interface FactoryADUCreate
 */
export interface FactoryADUCreate {
    /**
     * Name of the ADU model
     * @type {string}
     * @memberof FactoryADUCreate
     */
    'name': string;
    /**
     * ID of the factory that produces this ADU
     * @type {string}
     * @memberof FactoryADUCreate
     */
    'factory_id': string;
    /**
     * Square footage of the ADU
     * @type {number}
     * @memberof FactoryADUCreate
     */
    'square_footage': number;
    /**
     * Number of bedrooms
     * @type {number}
     * @memberof FactoryADUCreate
     */
    'bedrooms': number;
    /**
     * Number of bathrooms
     * @type {number}
     * @memberof FactoryADUCreate
     */
    'bathrooms': number;
    /**
     * 
     * @type {string}
     * @memberof FactoryADUCreate
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactoryADUCreate
     */
    'firestore_product_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactoryADUCreate
     */
    'cost_code_id'?: string | null;
}
/**
 * Schema for factory ADU delete response.
 * @export
 * @interface FactoryADUDeleteResponse
 */
export interface FactoryADUDeleteResponse {
    /**
     * Whether the deletion was successful
     * @type {boolean}
     * @memberof FactoryADUDeleteResponse
     */
    'success': boolean;
    /**
     * UUID of the deleted factory ADU
     * @type {string}
     * @memberof FactoryADUDeleteResponse
     */
    'uuid': string;
}
/**
 * Schema for list of factory ADUs response.
 * @export
 * @interface FactoryADUListResponse
 */
export interface FactoryADUListResponse {
    /**
     * List of factory ADUs
     * @type {Array<FactoryADUResponse>}
     * @memberof FactoryADUListResponse
     */
    'items': Array<FactoryADUResponse>;
    /**
     * Total number of factory ADUs
     * @type {number}
     * @memberof FactoryADUListResponse
     */
    'total': number;
}
/**
 * Schema for factory ADU response.
 * @export
 * @interface FactoryADUResponse
 */
export interface FactoryADUResponse {
    /**
     * Name of the ADU model
     * @type {string}
     * @memberof FactoryADUResponse
     */
    'name': string;
    /**
     * ID of the factory that produces this ADU
     * @type {string}
     * @memberof FactoryADUResponse
     */
    'factory_id': string;
    /**
     * Square footage of the ADU
     * @type {number}
     * @memberof FactoryADUResponse
     */
    'square_footage': number;
    /**
     * Number of bedrooms
     * @type {number}
     * @memberof FactoryADUResponse
     */
    'bedrooms': number;
    /**
     * Number of bathrooms
     * @type {number}
     * @memberof FactoryADUResponse
     */
    'bathrooms': number;
    /**
     * 
     * @type {string}
     * @memberof FactoryADUResponse
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactoryADUResponse
     */
    'firestore_product_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactoryADUResponse
     */
    'cost_code_id'?: string | null;
    /**
     * Unique identifier for the factory ADU
     * @type {string}
     * @memberof FactoryADUResponse
     */
    'uuid': string;
    /**
     * 
     * @type {CostCodeResponse}
     * @memberof FactoryADUResponse
     */
    'cost_code'?: CostCodeResponse | null;
}
/**
 * Schema for updating a factory ADU.
 * @export
 * @interface FactoryADUUpdate
 */
export interface FactoryADUUpdate {
    /**
     * 
     * @type {string}
     * @memberof FactoryADUUpdate
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactoryADUUpdate
     */
    'factory_id'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FactoryADUUpdate
     */
    'square_footage'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FactoryADUUpdate
     */
    'bedrooms'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FactoryADUUpdate
     */
    'bathrooms'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FactoryADUUpdate
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactoryADUUpdate
     */
    'firestore_product_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactoryADUUpdate
     */
    'cost_code_id'?: string | null;
}
/**
 * 
 * @export
 * @interface FeasibleZipcodeCreate
 */
export interface FeasibleZipcodeCreate {
    /**
     * 
     * @type {string}
     * @memberof FeasibleZipcodeCreate
     */
    'zipcode': string;
    /**
     * 
     * @type {string}
     * @memberof FeasibleZipcodeCreate
     */
    'state_code'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FeasibleZipcodeCreate
     */
    'd2c'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FeasibleZipcodeCreate
     */
    'b2b'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FeasibleZipcodeCreate
     */
    'marketing_region_uuid'?: string | null;
}
/**
 * 
 * @export
 * @interface FeasibleZipcodeResponse
 */
export interface FeasibleZipcodeResponse {
    /**
     * 
     * @type {string}
     * @memberof FeasibleZipcodeResponse
     */
    'zipcode': string;
    /**
     * 
     * @type {string}
     * @memberof FeasibleZipcodeResponse
     */
    'state_code'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FeasibleZipcodeResponse
     */
    'd2c'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FeasibleZipcodeResponse
     */
    'b2b'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FeasibleZipcodeResponse
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof FeasibleZipcodeResponse
     */
    'updated_at': string;
    /**
     * 
     * @type {SrcApiAdminSystemFeasibilityFeasibileZipcodeSchemaMarketingRegionResponse}
     * @memberof FeasibleZipcodeResponse
     */
    'marketing_region'?: SrcApiAdminSystemFeasibilityFeasibileZipcodeSchemaMarketingRegionResponse | null;
}
/**
 * 
 * @export
 * @interface FeasibleZipcodeUpdate
 */
export interface FeasibleZipcodeUpdate {
    /**
     * 
     * @type {string}
     * @memberof FeasibleZipcodeUpdate
     */
    'state_code'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FeasibleZipcodeUpdate
     */
    'd2c'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof FeasibleZipcodeUpdate
     */
    'b2b'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof FeasibleZipcodeUpdate
     */
    'marketing_region_uuid'?: string | null;
}
/**
 * 
 * @export
 * @interface FireDistrictSchema
 */
export interface FireDistrictSchema {
    /**
     * 
     * @type {string}
     * @memberof FireDistrictSchema
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof FireDistrictSchema
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof FireDistrictSchema
     */
    'district_type': string;
    /**
     * 
     * @type {string}
     * @memberof FireDistrictSchema
     */
    'street_address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FireDistrictSchema
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FireDistrictSchema
     */
    'county'?: string | null;
    /**
     * 
     * @type {StateEnum}
     * @memberof FireDistrictSchema
     */
    'state'?: StateEnum | null;
    /**
     * 
     * @type {string}
     * @memberof FireDistrictSchema
     */
    'zip_code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FireDistrictSchema
     */
    'email_contact'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FireDistrictSchema
     */
    'contact_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FireDistrictSchema
     */
    'contact_information'?: string | null;
    /**
     * 
     * @type {OpsTerritoryEnum}
     * @memberof FireDistrictSchema
     */
    'ops_territory'?: OpsTerritoryEnum | null;
    /**
     * 
     * @type {string}
     * @memberof FireDistrictSchema
     */
    'service_map_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FireDistrictSchema
     */
    'website_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FireDistrictSchema
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FireDistrictSchema
     */
    'notes_estimating'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FireDistrictSchema
     */
    'fire_plan_instructions'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FireDistrictSchema
     */
    'fee_notes'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FireDistrictSchema
     */
    'fee_cents'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FireDistrictSchema
     */
    'fire_access'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FireDistrictSchema
     */
    'hydrant_distance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FireDistrictSchema
     */
    'fire_sprinklers'?: string | null;
}


/**
 * 
 * @export
 * @interface FireDistrictWithAHJs
 */
export interface FireDistrictWithAHJs {
    /**
     * 
     * @type {string}
     * @memberof FireDistrictWithAHJs
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof FireDistrictWithAHJs
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof FireDistrictWithAHJs
     */
    'district_type': string;
    /**
     * 
     * @type {string}
     * @memberof FireDistrictWithAHJs
     */
    'street_address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FireDistrictWithAHJs
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FireDistrictWithAHJs
     */
    'county'?: string | null;
    /**
     * 
     * @type {StateEnum}
     * @memberof FireDistrictWithAHJs
     */
    'state'?: StateEnum | null;
    /**
     * 
     * @type {string}
     * @memberof FireDistrictWithAHJs
     */
    'zip_code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FireDistrictWithAHJs
     */
    'email_contact'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FireDistrictWithAHJs
     */
    'contact_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FireDistrictWithAHJs
     */
    'contact_information'?: string | null;
    /**
     * 
     * @type {OpsTerritoryEnum}
     * @memberof FireDistrictWithAHJs
     */
    'ops_territory'?: OpsTerritoryEnum | null;
    /**
     * 
     * @type {string}
     * @memberof FireDistrictWithAHJs
     */
    'service_map_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FireDistrictWithAHJs
     */
    'website_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FireDistrictWithAHJs
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FireDistrictWithAHJs
     */
    'notes_estimating'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FireDistrictWithAHJs
     */
    'fire_plan_instructions'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FireDistrictWithAHJs
     */
    'fee_notes'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FireDistrictWithAHJs
     */
    'fee_cents'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FireDistrictWithAHJs
     */
    'fire_access'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FireDistrictWithAHJs
     */
    'hydrant_distance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FireDistrictWithAHJs
     */
    'fire_sprinklers'?: string | null;
    /**
     * 
     * @type {Array<AHJ>}
     * @memberof FireDistrictWithAHJs
     */
    'ahjs': Array<AHJ>;
}


/**
 * 
 * @export
 * @interface FirestoreCartItem
 */
export interface FirestoreCartItem {
    /**
     * 
     * @type {FirestoreCartItemDetails}
     * @memberof FirestoreCartItem
     */
    'details'?: FirestoreCartItemDetails;
    /**
     * 
     * @type {string}
     * @memberof FirestoreCartItem
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof FirestoreCartItem
     */
    'quantity'?: number;
    /**
     * 
     * @type {string}
     * @memberof FirestoreCartItem
     */
    'sku'?: string;
    /**
     * 
     * @type {string}
     * @memberof FirestoreCartItem
     */
    'type'?: string;
}
/**
 * 
 * @export
 * @interface FirestoreCartItemDetails
 */
export interface FirestoreCartItemDetails {
    /**
     * 
     * @type {number}
     * @memberof FirestoreCartItemDetails
     */
    'code'?: number;
    /**
     * 
     * @type {string}
     * @memberof FirestoreCartItemDetails
     */
    'configurationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof FirestoreCartItemDetails
     */
    'display_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof FirestoreCartItemDetails
     */
    'factoryId'?: string;
    /**
     * 
     * @type {string}
     * @memberof FirestoreCartItemDetails
     */
    'productId'?: string;
    /**
     * 
     * @type {string}
     * @memberof FirestoreCartItemDetails
     */
    'versionId'?: string;
}
/**
 * 
 * @export
 * @interface FirestoreCustomerContact
 */
export interface FirestoreCustomerContact {
    /**
     * 
     * @type {string}
     * @memberof FirestoreCustomerContact
     */
    'first_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FirestoreCustomerContact
     */
    'last_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FirestoreCustomerContact
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FirestoreCustomerContact
     */
    'phone'?: string | null;
}
/**
 * Schema for multiple Firestore factories response.
 * @export
 * @interface FirestoreFactoriesResponse
 */
export interface FirestoreFactoriesResponse {
    /**
     * 
     * @type {Array<FirestoreFactorySchema>}
     * @memberof FirestoreFactoriesResponse
     */
    'factories': Array<FirestoreFactorySchema>;
}
/**
 * Schema for Firestore factory ADU deletion response.
 * @export
 * @interface FirestoreFactoryADUDeleteResponse
 */
export interface FirestoreFactoryADUDeleteResponse {
    /**
     * 
     * @type {boolean}
     * @memberof FirestoreFactoryADUDeleteResponse
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof FirestoreFactoryADUDeleteResponse
     */
    'id'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof FirestoreFactoryADUDeleteResponse
     */
    'ids'?: Array<string> | null;
    /**
     * 
     * @type {number}
     * @memberof FirestoreFactoryADUDeleteResponse
     */
    'deleted_count'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FirestoreFactoryADUDeleteResponse
     */
    'message'?: string | null;
}
/**
 * Schema for Firestore factory ADU responses.
 * @export
 * @interface FirestoreFactoryADUSchema
 */
export interface FirestoreFactoryADUSchema {
    /**
     * 
     * @type {string}
     * @memberof FirestoreFactoryADUSchema
     */
    'firestore_id': string;
    /**
     * 
     * @type {string}
     * @memberof FirestoreFactoryADUSchema
     */
    'factory_id': string;
    /**
     * 
     * @type {string}
     * @memberof FirestoreFactoryADUSchema
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof FirestoreFactoryADUSchema
     */
    'square_footage': number;
    /**
     * 
     * @type {number}
     * @memberof FirestoreFactoryADUSchema
     */
    'bedrooms': number;
    /**
     * 
     * @type {number}
     * @memberof FirestoreFactoryADUSchema
     */
    'bathrooms': number;
    /**
     * 
     * @type {string}
     * @memberof FirestoreFactoryADUSchema
     */
    'description'?: string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof FirestoreFactoryADUSchema
     */
    'features'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof FirestoreFactoryADUSchema
     */
    'pricing'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof FirestoreFactoryADUSchema
     */
    'images'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof FirestoreFactoryADUSchema
     */
    'specifications'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {string}
     * @memberof FirestoreFactoryADUSchema
     */
    'id': string;
}
/**
 * Schema for Firestore factory responses.
 * @export
 * @interface FirestoreFactorySchema
 */
export interface FirestoreFactorySchema {
    /**
     * 
     * @type {string}
     * @memberof FirestoreFactorySchema
     */
    'firestore_id': string;
    /**
     * 
     * @type {string}
     * @memberof FirestoreFactorySchema
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof FirestoreFactorySchema
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FirestoreFactorySchema
     */
    'global_title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FirestoreFactorySchema
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FirestoreFactorySchema
     */
    'country'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FirestoreFactorySchema
     */
    'county'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FirestoreFactorySchema
     */
    'state'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FirestoreFactorySchema
     */
    'street'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FirestoreFactorySchema
     */
    'street_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FirestoreFactorySchema
     */
    'zip'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FirestoreFactorySchema
     */
    'full_address'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FirestoreFactorySchema
     */
    'latitude'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FirestoreFactorySchema
     */
    'longitude'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FirestoreFactorySchema
     */
    'published_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FirestoreFactorySchema
     */
    'draft_id'?: string | null;
}
/**
 * 
 * @export
 * @interface FirestoreProject
 */
export interface FirestoreProject {
    /**
     * 
     * @type {string}
     * @memberof FirestoreProject
     */
    'project_id'?: string | null;
    /**
     * 
     * @type {FirestoreCustomerContact}
     * @memberof FirestoreProject
     */
    'customer_contact'?: FirestoreCustomerContact | null;
    /**
     * 
     * @type {FirestoreProjectAddress}
     * @memberof FirestoreProject
     */
    'project_address': FirestoreProjectAddress;
    /**
     * 
     * @type {FirestoreProjectSettings}
     * @memberof FirestoreProject
     */
    'settings'?: FirestoreProjectSettings | null;
    /**
     * 
     * @type {Array<FirestoreCartItem>}
     * @memberof FirestoreProject
     */
    'cart'?: Array<FirestoreCartItem>;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof FirestoreProject
     */
    'users'?: { [key: string]: string; } | null;
    /**
     * 
     * @type {string}
     * @memberof FirestoreProject
     */
    'portal_type'?: string | null;
}
/**
 * 
 * @export
 * @interface FirestoreProjectAddress
 */
export interface FirestoreProjectAddress {
    /**
     * 
     * @type {string}
     * @memberof FirestoreProjectAddress
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FirestoreProjectAddress
     */
    'country'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FirestoreProjectAddress
     */
    'county'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FirestoreProjectAddress
     */
    'full_address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FirestoreProjectAddress
     */
    'geohash'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FirestoreProjectAddress
     */
    'latitude'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FirestoreProjectAddress
     */
    'longitude'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FirestoreProjectAddress
     */
    'state'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FirestoreProjectAddress
     */
    'street'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FirestoreProjectAddress
     */
    'street_address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FirestoreProjectAddress
     */
    'street_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FirestoreProjectAddress
     */
    'zip'?: string | null;
}
/**
 * 
 * @export
 * @interface FirestoreProjectSettings
 */
export interface FirestoreProjectSettings {
    /**
     * 
     * @type {boolean}
     * @memberof FirestoreProjectSettings
     */
    'cart_enabled'?: boolean;
    /**
     * 
     * @type {DesignLock}
     * @memberof FirestoreProjectSettings
     */
    'design_lock'?: DesignLock | null;
    /**
     * 
     * @type {PricingMode}
     * @memberof FirestoreProjectSettings
     */
    'pricing_mode'?: PricingMode | null;
}
/**
 * 
 * @export
 * @interface Geohazards
 */
export interface Geohazards {
    /**
     * 
     * @type {string}
     * @memberof Geohazards
     */
    'liquefaction_zone': string;
    /**
     * 
     * @type {string}
     * @memberof Geohazards
     */
    'landslide_zone': string;
    /**
     * 
     * @type {string}
     * @memberof Geohazards
     */
    'fault_zone': string;
}
/**
 * 
 * @export
 * @interface GeohazardsResponse
 */
export interface GeohazardsResponse {
    /**
     * 
     * @type {Geohazards}
     * @memberof GeohazardsResponse
     */
    'geohazards': Geohazards | null;
}
/**
 * 
 * @export
 * @interface GroupResponse
 */
export interface GroupResponse {
    /**
     * 
     * @type {string}
     * @memberof GroupResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GroupResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GroupResponse
     */
    'description': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GroupResponse
     */
    'permissions': Array<string>;
}
/**
 * 
 * @export
 * @interface HTTPValidationError
 */
export interface HTTPValidationError {
    /**
     * 
     * @type {Array<ValidationError>}
     * @memberof HTTPValidationError
     */
    'detail'?: Array<ValidationError>;
}
/**
 * 
 * @export
 * @interface HistoryMessage
 */
export interface HistoryMessage {
    /**
     * 
     * @type {string}
     * @memberof HistoryMessage
     */
    'role': string;
    /**
     * 
     * @type {string}
     * @memberof HistoryMessage
     */
    'content': string;
}
/**
 * 
 * @export
 * @interface InstantQuoteProductLocationSchema
 */
export interface InstantQuoteProductLocationSchema {
    /**
     * 
     * @type {string}
     * @memberof InstantQuoteProductLocationSchema
     */
    'location_id'?: string | null;
    /**
     * The label of the location
     * @type {string}
     * @memberof InstantQuoteProductLocationSchema
     */
    'label': string;
    /**
     * The latitude of the location
     * @type {number}
     * @memberof InstantQuoteProductLocationSchema
     */
    'latitude': number;
    /**
     * The longitude of the location
     * @type {number}
     * @memberof InstantQuoteProductLocationSchema
     */
    'longitude': number;
    /**
     * The items for the location
     * @type {Array<CreateInstantQuoteProductPricingItemSchema>}
     * @memberof InstantQuoteProductLocationSchema
     */
    'items': Array<CreateInstantQuoteProductPricingItemSchema>;
}
/**
 * Address component
 * @export
 * @interface Latitude
 */
export interface Latitude {
}
/**
 * The segment of the lead
 * @export
 * @interface LeadSegment
 */
export interface LeadSegment {
}
/**
 * The source of the lead
 * @export
 * @interface LeadSource
 */
export interface LeadSource {
}
/**
 * Lead Source Detail
 * @export
 * @interface LeadSourceDetail
 */
export interface LeadSourceDetail {
}
/**
 * 
 * @export
 * @interface LeadsByMonthResponse
 */
export interface LeadsByMonthResponse {
    /**
     * 
     * @type {Array<MonthlyLeadCount>}
     * @memberof LeadsByMonthResponse
     */
    'data': Array<MonthlyLeadCount>;
}
/**
 * Address component
 * @export
 * @interface Longitude
 */
export interface Longitude {
}
/**
 * The marketing channel pick list
 * @export
 * @interface MarketingChannelPickList
 */
export interface MarketingChannelPickList {
}
/**
 * Marketing consent
 * @export
 * @interface MarketingOptIn
 */
export interface MarketingOptIn {
}
/**
 * Schema for creating a new marketing region.
 * @export
 * @interface MarketingRegionCreate
 */
export interface MarketingRegionCreate {
    /**
     * 
     * @type {string}
     * @memberof MarketingRegionCreate
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof MarketingRegionCreate
     */
    'description'?: string | null;
}
/**
 * Schema for updating a marketing region.
 * @export
 * @interface MarketingRegionUpdate
 */
export interface MarketingRegionUpdate {
    /**
     * 
     * @type {string}
     * @memberof MarketingRegionUpdate
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof MarketingRegionUpdate
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface MonthlyLeadCount
 */
export interface MonthlyLeadCount {
    /**
     * 
     * @type {string}
     * @memberof MonthlyLeadCount
     */
    'month': string;
    /**
     * 
     * @type {number}
     * @memberof MonthlyLeadCount
     */
    'lead_count': number;
    /**
     * 
     * @type {number}
     * @memberof MonthlyLeadCount
     */
    'd2c_lead_count': number;
    /**
     * 
     * @type {number}
     * @memberof MonthlyLeadCount
     */
    'serviceable_d2c_lead_count': number;
    /**
     * 
     * @type {number}
     * @memberof MonthlyLeadCount
     */
    'd2c_dead_from_property_review_count': number;
    /**
     * 
     * @type {number}
     * @memberof MonthlyLeadCount
     */
    'd2c_passed_property_review_count': number;
    /**
     * 
     * @type {number}
     * @memberof MonthlyLeadCount
     */
    'paid_deposit_count': number;
    /**
     * 
     * @type {number}
     * @memberof MonthlyLeadCount
     */
    'deposit_days_0_30': number;
    /**
     * 
     * @type {number}
     * @memberof MonthlyLeadCount
     */
    'deposit_days_31_60': number;
    /**
     * 
     * @type {number}
     * @memberof MonthlyLeadCount
     */
    'deposit_days_61_90': number;
    /**
     * 
     * @type {number}
     * @memberof MonthlyLeadCount
     */
    'deposit_days_91_plus': number;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof MonthlyLeadCount
     */
    'processing_errors'?: Array<{ [key: string]: any; }> | null;
    /**
     * 
     * @type {number}
     * @memberof MonthlyLeadCount
     */
    'percent_d2c_of_total'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MonthlyLeadCount
     */
    'percent_serviceable_of_d2c'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MonthlyLeadCount
     */
    'percent_d2c_dead_from_property_review_of_d2c'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MonthlyLeadCount
     */
    'percent_passed_property_review_of_d2c'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MonthlyLeadCount
     */
    'percent_paid_deposit_of_passed_property_review'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MonthlyLeadCount
     */
    'sales_eligible_conversion_rate'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MonthlyLeadCount
     */
    'percent_deposit_days_0_30_of_paid'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MonthlyLeadCount
     */
    'percent_deposit_days_31_60_of_paid'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MonthlyLeadCount
     */
    'percent_deposit_days_61_90_of_paid'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MonthlyLeadCount
     */
    'percent_deposit_days_91_plus_of_paid'?: number | null;
}
/**
 * 
 * @export
 * @interface OandPPercentageSchema
 */
export interface OandPPercentageSchema {
    /**
     * 
     * @type {number}
     * @memberof OandPPercentageSchema
     */
    'percentage': number;
    /**
     * 
     * @type {string}
     * @memberof OandPPercentageSchema
     */
    'budget_segment_name': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const OpsTerritoryEnum = {
    Empty: '',
    Other: 'Other',
    EastBayInner: 'East Bay (Inner)',
    LowerLaCounty: 'Lower LA County',
    SanDiego: 'San Diego',
    VenturaSantaBarbara: 'Ventura/Santa Barbara',
    SouthBay: 'South Bay',
    OrangeCounty: 'Orange County',
    EastBayOuter: 'East Bay (Outer)',
    NorthBay: 'North Bay',
    InlandEmpire: 'Inland Empire'
} as const;

export type OpsTerritoryEnum = typeof OpsTerritoryEnum[keyof typeof OpsTerritoryEnum];


/**
 * 
 * @export
 * @interface PatchSalesforceLeadSchema
 */
export interface PatchSalesforceLeadSchema {
    [key: string]: any;

    /**
     * The uuid of the lead
     * @type {string}
     * @memberof PatchSalesforceLeadSchema
     */
    'lead_uuid': string;
    /**
     * 
     * @type {MarketingChannelPickList}
     * @memberof PatchSalesforceLeadSchema
     */
    'marketing_channel_pick_list'?: MarketingChannelPickList;
}
/**
 * 
 * @export
 * @interface PermissionResponse
 */
export interface PermissionResponse {
    /**
     * 
     * @type {string}
     * @memberof PermissionResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PermissionResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PermissionResponse
     */
    'description': string;
}
/**
 * The phone number of the lead in XXX-XXX-XXXX format
 * @export
 * @interface PhoneNumber
 */
export interface PhoneNumber {
}
/**
 * Address component
 * @export
 * @interface PostalCode
 */
export interface PostalCode {
}
/**
 * Schema for prefab factory deletion response.
 * @export
 * @interface PrefabFactoryDeleteResponse
 */
export interface PrefabFactoryDeleteResponse {
    /**
     * 
     * @type {boolean}
     * @memberof PrefabFactoryDeleteResponse
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof PrefabFactoryDeleteResponse
     */
    'message': string;
}
/**
 * Schema for prefab factory responses.
 * @export
 * @interface PrefabFactorySchema
 */
export interface PrefabFactorySchema {
    /**
     * 
     * @type {string}
     * @memberof PrefabFactorySchema
     */
    'internal_name': string;
    /**
     * 
     * @type {string}
     * @memberof PrefabFactorySchema
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof PrefabFactorySchema
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof PrefabFactorySchema
     */
    'country': string;
    /**
     * 
     * @type {string}
     * @memberof PrefabFactorySchema
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof PrefabFactorySchema
     */
    'street': string;
    /**
     * 
     * @type {string}
     * @memberof PrefabFactorySchema
     */
    'zip': string;
    /**
     * 
     * @type {string}
     * @memberof PrefabFactorySchema
     */
    'county'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PrefabFactorySchema
     */
    'latitude'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PrefabFactorySchema
     */
    'longitude'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PrefabFactorySchema
     */
    'street_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrefabFactorySchema
     */
    'uuid': string;
}
/**
 * 
 * @export
 * @interface PricingMode
 */
export interface PricingMode {
    /**
     * 
     * @type {boolean}
     * @memberof PricingMode
     */
    'complex_pricing_enabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PricingMode
     */
    'edited_by_email'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PricingMode
     */
    'edited_timestamp'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PricingMode
     */
    'mode'?: string | null;
}
/**
 * Schema for a Procore budget item.
 * @export
 * @interface ProcoreBudgetItem
 */
export interface ProcoreBudgetItem {
    /**
     * Division (segment1 code)
     * @type {string}
     * @memberof ProcoreBudgetItem
     */
    'division': string;
    /**
     * Villa Budget Section (segment2 code)
     * @type {string}
     * @memberof ProcoreBudgetItem
     */
    'villa_budget_section': string;
    /**
     * Complete cost code
     * @type {string}
     * @memberof ProcoreBudgetItem
     */
    'cost_code': string;
    /**
     * Cost type (S, IP, O, P)
     * @type {string}
     * @memberof ProcoreBudgetItem
     */
    'cost_type': string;
    /**
     * Description of the cost code
     * @type {string}
     * @memberof ProcoreBudgetItem
     */
    'description': string;
    /**
     * Whether the calculation is manual
     * @type {boolean}
     * @memberof ProcoreBudgetItem
     */
    'manual_calculation'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProcoreBudgetItem
     */
    'unit_qty'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProcoreBudgetItem
     */
    'uom'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProcoreBudgetItem
     */
    'unit_cost'?: number | null;
    /**
     * Budget amount with currency formatting
     * @type {string}
     * @memberof ProcoreBudgetItem
     */
    'budget_amount': string;
}
/**
 * Schema for the Procore budget response.
 * @export
 * @interface ProcoreBudgetResponse
 */
export interface ProcoreBudgetResponse {
    /**
     * List of budget items
     * @type {Array<ProcoreBudgetItem>}
     * @memberof ProcoreBudgetResponse
     */
    'items': Array<ProcoreBudgetItem>;
    /**
     * ID of the project
     * @type {string}
     * @memberof ProcoreBudgetResponse
     */
    'project_id': string;
    /**
     * ID of the estimate
     * @type {string}
     * @memberof ProcoreBudgetResponse
     */
    'estimate_id': string;
}
/**
 * 
 * @export
 * @interface ProjectAddressSchema
 */
export interface ProjectAddressSchema {
    /**
     * 
     * @type {string}
     * @memberof ProjectAddressSchema
     */
    'full_address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectAddressSchema
     */
    'street_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectAddressSchema
     */
    'street'?: string | null;
    /**
     * Street address including street number and name
     * @type {string}
     * @memberof ProjectAddressSchema
     */
    'street_address': string;
    /**
     * City of the project address
     * @type {string}
     * @memberof ProjectAddressSchema
     */
    'city': string;
    /**
     * State of the project address
     * @type {string}
     * @memberof ProjectAddressSchema
     */
    'state': string;
    /**
     * ZIP code of the project address
     * @type {string}
     * @memberof ProjectAddressSchema
     */
    'zip': string;
    /**
     * Country of the project address
     * @type {string}
     * @memberof ProjectAddressSchema
     */
    'country': string;
    /**
     * County of the project address
     * @type {string}
     * @memberof ProjectAddressSchema
     */
    'county': string;
    /**
     * 
     * @type {number}
     * @memberof ProjectAddressSchema
     */
    'latitude'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ProjectAddressSchema
     */
    'longitude'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectAddressSchema
     */
    'geohash'?: string | null;
}
/**
 * 
 * @export
 * @interface ProjectProvisioningPayload
 */
export interface ProjectProvisioningPayload {
    /**
     * Opportunity ID from SFDC or other system.
     * @type {string}
     * @memberof ProjectProvisioningPayload
     */
    'id': string;
    /**
     * Opportunity name.
     * @type {string}
     * @memberof ProjectProvisioningPayload
     */
    'name': string;
    /**
     * Current status of the project/opportunity.
     * @type {string}
     * @memberof ProjectProvisioningPayload
     */
    'status': string;
    /**
     * Expected close date.
     * @type {string}
     * @memberof ProjectProvisioningPayload
     */
    'closeDate': string;
    /**
     * 
     * @type {string}
     * @memberof ProjectProvisioningPayload
     */
    'description'?: string | null;
    /**
     * Primary client contact name.
     * @type {string}
     * @memberof ProjectProvisioningPayload
     */
    'contactName': string;
    /**
     * Primary client contact email address.
     * @type {string}
     * @memberof ProjectProvisioningPayload
     */
    'contactEmail': string;
    /**
     * Primary client contact phone number.
     * @type {string}
     * @memberof ProjectProvisioningPayload
     */
    'contactPhone': string;
    /**
     * 
     * @type {string}
     * @memberof ProjectProvisioningPayload
     */
    'county'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectProvisioningPayload
     */
    'overrideClientPhone'?: string | null;
    /**
     * Authority Having Jurisdiction.
     * @type {string}
     * @memberof ProjectProvisioningPayload
     */
    'ahj': string;
    /**
     * 
     * @type {SmartsheetContactSchema}
     * @memberof ProjectProvisioningPayload
     */
    'homeConsultant': SmartsheetContactSchema;
    /**
     * 
     * @type {SmartsheetContactSchema}
     * @memberof ProjectProvisioningPayload
     */
    'projectCoordinator': SmartsheetContactSchema;
    /**
     * 
     * @type {SmartsheetContactSchema}
     * @memberof ProjectProvisioningPayload
     */
    'constructionManager': SmartsheetContactSchema;
    /**
     * 
     * @type {SmartsheetContactSchema}
     * @memberof ProjectProvisioningPayload
     */
    'projectManager': SmartsheetContactSchema;
    /**
     * 
     * @type {string}
     * @memberof ProjectProvisioningPayload
     */
    'notes'?: string | null;
    /**
     * Final project name for Smartsheet, must start with ID and hyphen (e.g., \'705 - Suffix\').
     * @type {string}
     * @memberof ProjectProvisioningPayload
     */
    'provisionedProjectName': string;
    /**
     * Generated Project ID for Smartsheet (must be positive). This usually comes from Smartsheet itself after folder creation, so its inclusion here might be for confirmation or if pre-generated.
     * @type {number}
     * @memberof ProjectProvisioningPayload
     */
    'projectId': number;
}
/**
 * 
 * @export
 * @interface ProjectSchema
 */
export interface ProjectSchema {
    /**
     * 
     * @type {string}
     * @memberof ProjectSchema
     */
    'project_id'?: string | null;
    /**
     * Authentication user ID of the project creator
     * @type {string}
     * @memberof ProjectSchema
     */
    'auth_user_id': string;
    /**
     * Address information for the project
     * @type {ProjectAddressSchema}
     * @memberof ProjectSchema
     */
    'address_info': ProjectAddressSchema;
    /**
     * First name of the project creator
     * @type {string}
     * @memberof ProjectSchema
     */
    'first_name': string;
    /**
     * Last name of the project creator
     * @type {string}
     * @memberof ProjectSchema
     */
    'last_name': string;
    /**
     * Email address of the project creator
     * @type {string}
     * @memberof ProjectSchema
     */
    'email': string;
    /**
     * Phone number of the project creator
     * @type {string}
     * @memberof ProjectSchema
     */
    'phone': string;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectSchema
     */
    'cart_enabled'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectSchema
     */
    'portal_type'?: string | null;
}
/**
 * Property Type
 * @export
 * @interface PropertyType
 */
export interface PropertyType {
}
/**
 * 
 * @export
 * @interface Request
 */
export interface Request {
    /**
     * 
     * @type {string}
     * @memberof Request
     */
    'token': string;
    /**
     * 
     * @type {string}
     * @memberof Request
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof Request
     */
    'team_id': string;
    /**
     * 
     * @type {string}
     * @memberof Request
     */
    'api_app_id': string;
    /**
     * 
     * @type {SlackEvent}
     * @memberof Request
     */
    'event': SlackEvent;
    /**
     * 
     * @type {string}
     * @memberof Request
     */
    'event_id': string;
    /**
     * 
     * @type {number}
     * @memberof Request
     */
    'event_time': number;
    /**
     * 
     * @type {Array<SlackAuthorization>}
     * @memberof Request
     */
    'authorizations': Array<SlackAuthorization>;
    /**
     * 
     * @type {boolean}
     * @memberof Request
     */
    'is_ext_shared_channel'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Request
     */
    'event_context': string;
    /**
     * 
     * @type {string}
     * @memberof Request
     */
    'challenge': string;
}
/**
 * 
 * @export
 * @interface SalesTaxModifierSchema
 */
export interface SalesTaxModifierSchema {
    /**
     * 
     * @type {number}
     * @memberof SalesTaxModifierSchema
     */
    'sales_tax_percentage': number;
    /**
     * 
     * @type {number}
     * @memberof SalesTaxModifierSchema
     */
    'sales_tax_modifier_percentage': number;
}
/**
 * 
 * @export
 * @interface SanitationDistrictSchema
 */
export interface SanitationDistrictSchema {
    /**
     * 
     * @type {string}
     * @memberof SanitationDistrictSchema
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof SanitationDistrictSchema
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SanitationDistrictSchema
     */
    'district_type': string;
    /**
     * 
     * @type {string}
     * @memberof SanitationDistrictSchema
     */
    'street_address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SanitationDistrictSchema
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SanitationDistrictSchema
     */
    'county'?: string | null;
    /**
     * 
     * @type {StateEnum}
     * @memberof SanitationDistrictSchema
     */
    'state'?: StateEnum | null;
    /**
     * 
     * @type {string}
     * @memberof SanitationDistrictSchema
     */
    'zip_code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SanitationDistrictSchema
     */
    'email_contact'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SanitationDistrictSchema
     */
    'contact_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SanitationDistrictSchema
     */
    'contact_information'?: string | null;
    /**
     * 
     * @type {OpsTerritoryEnum}
     * @memberof SanitationDistrictSchema
     */
    'ops_territory'?: OpsTerritoryEnum | null;
    /**
     * 
     * @type {string}
     * @memberof SanitationDistrictSchema
     */
    'service_map_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SanitationDistrictSchema
     */
    'website_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SanitationDistrictSchema
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SanitationDistrictSchema
     */
    'notes_estimating'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SanitationDistrictSchema
     */
    'will_serve_letter_instructions'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SanitationDistrictSchema
     */
    'connection_fee_cents'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SanitationDistrictSchema
     */
    'connection_fee_instructions'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SanitationDistrictSchema
     */
    'connection_fee_notes'?: string | null;
    /**
     * 
     * @type {SometimesAlwaysNeverEnum}
     * @memberof SanitationDistrictSchema
     */
    'connection_permit_required'?: SometimesAlwaysNeverEnum | null;
}


/**
 * 
 * @export
 * @interface SanitationDistrictWithAHJs
 */
export interface SanitationDistrictWithAHJs {
    /**
     * 
     * @type {string}
     * @memberof SanitationDistrictWithAHJs
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof SanitationDistrictWithAHJs
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SanitationDistrictWithAHJs
     */
    'district_type': string;
    /**
     * 
     * @type {string}
     * @memberof SanitationDistrictWithAHJs
     */
    'street_address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SanitationDistrictWithAHJs
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SanitationDistrictWithAHJs
     */
    'county'?: string | null;
    /**
     * 
     * @type {StateEnum}
     * @memberof SanitationDistrictWithAHJs
     */
    'state'?: StateEnum | null;
    /**
     * 
     * @type {string}
     * @memberof SanitationDistrictWithAHJs
     */
    'zip_code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SanitationDistrictWithAHJs
     */
    'email_contact'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SanitationDistrictWithAHJs
     */
    'contact_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SanitationDistrictWithAHJs
     */
    'contact_information'?: string | null;
    /**
     * 
     * @type {OpsTerritoryEnum}
     * @memberof SanitationDistrictWithAHJs
     */
    'ops_territory'?: OpsTerritoryEnum | null;
    /**
     * 
     * @type {string}
     * @memberof SanitationDistrictWithAHJs
     */
    'service_map_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SanitationDistrictWithAHJs
     */
    'website_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SanitationDistrictWithAHJs
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SanitationDistrictWithAHJs
     */
    'notes_estimating'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SanitationDistrictWithAHJs
     */
    'will_serve_letter_instructions'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SanitationDistrictWithAHJs
     */
    'connection_fee_cents'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SanitationDistrictWithAHJs
     */
    'connection_fee_instructions'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SanitationDistrictWithAHJs
     */
    'connection_fee_notes'?: string | null;
    /**
     * 
     * @type {SometimesAlwaysNeverEnum}
     * @memberof SanitationDistrictWithAHJs
     */
    'connection_permit_required'?: SometimesAlwaysNeverEnum | null;
    /**
     * 
     * @type {Array<AHJ>}
     * @memberof SanitationDistrictWithAHJs
     */
    'ahjs': Array<AHJ>;
}


/**
 * 
 * @export
 * @interface SchoolDistrictSchema
 */
export interface SchoolDistrictSchema {
    /**
     * 
     * @type {string}
     * @memberof SchoolDistrictSchema
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof SchoolDistrictSchema
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SchoolDistrictSchema
     */
    'district_type': string;
    /**
     * 
     * @type {string}
     * @memberof SchoolDistrictSchema
     */
    'street_address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SchoolDistrictSchema
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SchoolDistrictSchema
     */
    'county'?: string | null;
    /**
     * 
     * @type {StateEnum}
     * @memberof SchoolDistrictSchema
     */
    'state'?: StateEnum | null;
    /**
     * 
     * @type {string}
     * @memberof SchoolDistrictSchema
     */
    'zip_code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SchoolDistrictSchema
     */
    'email_contact'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SchoolDistrictSchema
     */
    'contact_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SchoolDistrictSchema
     */
    'contact_information'?: string | null;
    /**
     * 
     * @type {OpsTerritoryEnum}
     * @memberof SchoolDistrictSchema
     */
    'ops_territory'?: OpsTerritoryEnum | null;
    /**
     * 
     * @type {string}
     * @memberof SchoolDistrictSchema
     */
    'service_map_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SchoolDistrictSchema
     */
    'website_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SchoolDistrictSchema
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SchoolDistrictSchema
     */
    'notes_estimating'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SchoolDistrictSchema
     */
    'payment_instructions'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SchoolDistrictSchema
     */
    'payment_website'?: string | null;
}


/**
 * 
 * @export
 * @interface SchoolDistrictWithAHJs
 */
export interface SchoolDistrictWithAHJs {
    /**
     * 
     * @type {string}
     * @memberof SchoolDistrictWithAHJs
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof SchoolDistrictWithAHJs
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SchoolDistrictWithAHJs
     */
    'district_type': string;
    /**
     * 
     * @type {string}
     * @memberof SchoolDistrictWithAHJs
     */
    'street_address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SchoolDistrictWithAHJs
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SchoolDistrictWithAHJs
     */
    'county'?: string | null;
    /**
     * 
     * @type {StateEnum}
     * @memberof SchoolDistrictWithAHJs
     */
    'state'?: StateEnum | null;
    /**
     * 
     * @type {string}
     * @memberof SchoolDistrictWithAHJs
     */
    'zip_code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SchoolDistrictWithAHJs
     */
    'email_contact'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SchoolDistrictWithAHJs
     */
    'contact_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SchoolDistrictWithAHJs
     */
    'contact_information'?: string | null;
    /**
     * 
     * @type {OpsTerritoryEnum}
     * @memberof SchoolDistrictWithAHJs
     */
    'ops_territory'?: OpsTerritoryEnum | null;
    /**
     * 
     * @type {string}
     * @memberof SchoolDistrictWithAHJs
     */
    'service_map_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SchoolDistrictWithAHJs
     */
    'website_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SchoolDistrictWithAHJs
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SchoolDistrictWithAHJs
     */
    'notes_estimating'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SchoolDistrictWithAHJs
     */
    'payment_instructions'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SchoolDistrictWithAHJs
     */
    'payment_website'?: string | null;
    /**
     * 
     * @type {Array<AHJ>}
     * @memberof SchoolDistrictWithAHJs
     */
    'ahjs': Array<AHJ>;
}


/**
 * 
 * @export
 * @interface SlackAuthorization
 */
export interface SlackAuthorization {
    /**
     * 
     * @type {string}
     * @memberof SlackAuthorization
     */
    'enterprise_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SlackAuthorization
     */
    'team_id': string;
    /**
     * 
     * @type {string}
     * @memberof SlackAuthorization
     */
    'user_id': string;
    /**
     * 
     * @type {boolean}
     * @memberof SlackAuthorization
     */
    'is_bot': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SlackAuthorization
     */
    'is_enterprise_install': boolean;
}
/**
 * 
 * @export
 * @interface SlackBlock
 */
export interface SlackBlock {
    /**
     * 
     * @type {string}
     * @memberof SlackBlock
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof SlackBlock
     */
    'block_id'?: string | null;
    /**
     * 
     * @type {Array<SlackBlockElementsInner>}
     * @memberof SlackBlock
     */
    'elements'?: Array<SlackBlockElementsInner> | null;
    /**
     * 
     * @type {Text}
     * @memberof SlackBlock
     */
    'text'?: Text | null;
}
/**
 * 
 * @export
 * @interface SlackBlockElementsInner
 */
export interface SlackBlockElementsInner {
    /**
     * 
     * @type {string}
     * @memberof SlackBlockElementsInner
     */
    'type': string;
    /**
     * 
     * @type {Array<SlackRichTextSectionElementsInner>}
     * @memberof SlackBlockElementsInner
     */
    'elements': Array<SlackRichTextSectionElementsInner>;
}
/**
 * 
 * @export
 * @interface SlackChallengeRequest
 */
export interface SlackChallengeRequest {
    /**
     * 
     * @type {string}
     * @memberof SlackChallengeRequest
     */
    'token': string;
    /**
     * 
     * @type {string}
     * @memberof SlackChallengeRequest
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof SlackChallengeRequest
     */
    'challenge': string;
}
/**
 * 
 * @export
 * @interface SlackEvent
 */
export interface SlackEvent {
    /**
     * 
     * @type {string}
     * @memberof SlackEvent
     */
    'client_msg_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SlackEvent
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof SlackEvent
     */
    'text'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SlackEvent
     */
    'user': string;
    /**
     * 
     * @type {string}
     * @memberof SlackEvent
     */
    'ts': string;
    /**
     * 
     * @type {Array<SlackBlock>}
     * @memberof SlackEvent
     */
    'blocks'?: Array<SlackBlock> | null;
    /**
     * 
     * @type {string}
     * @memberof SlackEvent
     */
    'team'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SlackEvent
     */
    'channel': string;
    /**
     * 
     * @type {string}
     * @memberof SlackEvent
     */
    'event_ts': string;
    /**
     * 
     * @type {string}
     * @memberof SlackEvent
     */
    'thread_ts'?: string | null;
}
/**
 * 
 * @export
 * @interface SlackEventRequest
 */
export interface SlackEventRequest {
    /**
     * 
     * @type {string}
     * @memberof SlackEventRequest
     */
    'token': string;
    /**
     * 
     * @type {string}
     * @memberof SlackEventRequest
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof SlackEventRequest
     */
    'team_id': string;
    /**
     * 
     * @type {string}
     * @memberof SlackEventRequest
     */
    'api_app_id': string;
    /**
     * 
     * @type {SlackEvent}
     * @memberof SlackEventRequest
     */
    'event': SlackEvent;
    /**
     * 
     * @type {string}
     * @memberof SlackEventRequest
     */
    'event_id': string;
    /**
     * 
     * @type {number}
     * @memberof SlackEventRequest
     */
    'event_time': number;
    /**
     * 
     * @type {Array<SlackAuthorization>}
     * @memberof SlackEventRequest
     */
    'authorizations': Array<SlackAuthorization>;
    /**
     * 
     * @type {boolean}
     * @memberof SlackEventRequest
     */
    'is_ext_shared_channel'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SlackEventRequest
     */
    'event_context': string;
}
/**
 * 
 * @export
 * @interface SlackRichTextSection
 */
export interface SlackRichTextSection {
    /**
     * 
     * @type {string}
     * @memberof SlackRichTextSection
     */
    'type': string;
    /**
     * 
     * @type {Array<SlackRichTextSectionElementsInner>}
     * @memberof SlackRichTextSection
     */
    'elements': Array<SlackRichTextSectionElementsInner>;
}
/**
 * 
 * @export
 * @interface SlackRichTextSectionElementsInner
 */
export interface SlackRichTextSectionElementsInner {
    /**
     * 
     * @type {string}
     * @memberof SlackRichTextSectionElementsInner
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof SlackRichTextSectionElementsInner
     */
    'text': string;
    /**
     * 
     * @type {string}
     * @memberof SlackRichTextSectionElementsInner
     */
    'user_id': string;
}
/**
 * 
 * @export
 * @interface SlackTextElement
 */
export interface SlackTextElement {
    /**
     * 
     * @type {string}
     * @memberof SlackTextElement
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof SlackTextElement
     */
    'text': string;
}
/**
 * 
 * @export
 * @interface SlackUserElement
 */
export interface SlackUserElement {
    /**
     * 
     * @type {string}
     * @memberof SlackUserElement
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof SlackUserElement
     */
    'user_id': string;
}
/**
 * 
 * @export
 * @interface SmartsheetContactSchema
 */
export interface SmartsheetContactSchema {
    /**
     * Name of the Smartsheet contact.
     * @type {string}
     * @memberof SmartsheetContactSchema
     */
    'name': string;
    /**
     * Email address of the Smartsheet contact.
     * @type {string}
     * @memberof SmartsheetContactSchema
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface SoftwareVendorSchema
 */
export interface SoftwareVendorSchema {
    /**
     * 
     * @type {string}
     * @memberof SoftwareVendorSchema
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SoftwareVendorSchema
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof SoftwareVendorSchema
     */
    'contractAmount': number;
    /**
     * 
     * @type {number}
     * @memberof SoftwareVendorSchema
     */
    'contractLength': number;
    /**
     * 
     * @type {string}
     * @memberof SoftwareVendorSchema
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof SoftwareVendorSchema
     */
    'endDate': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const SometimesAlwaysNeverEnum = {
    Empty: '',
    Sometimes: 'SOMETIMES',
    Always: 'ALWAYS',
    Never: 'NEVER',
    True: 'True',
    False: 'False'
} as const;

export type SometimesAlwaysNeverEnum = typeof SometimesAlwaysNeverEnum[keyof typeof SometimesAlwaysNeverEnum];


/**
 * 
 * @export
 * @interface SrcApiAdminSystemFeasibilityFeasibileZipcodeSchemaMarketingRegionResponse
 */
export interface SrcApiAdminSystemFeasibilityFeasibileZipcodeSchemaMarketingRegionResponse {
    /**
     * 
     * @type {string}
     * @memberof SrcApiAdminSystemFeasibilityFeasibileZipcodeSchemaMarketingRegionResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SrcApiAdminSystemFeasibilityFeasibileZipcodeSchemaMarketingRegionResponse
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SrcApiAdminSystemFeasibilityFeasibileZipcodeSchemaMarketingRegionResponse
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof SrcApiAdminSystemFeasibilityFeasibileZipcodeSchemaMarketingRegionResponse
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof SrcApiAdminSystemFeasibilityFeasibileZipcodeSchemaMarketingRegionResponse
     */
    'updated_at': string;
}
/**
 * Schema for marketing region responses.
 * @export
 * @interface SrcApiAdminSystemFeasibilityMarketingRegionSchemaMarketingRegionResponse
 */
export interface SrcApiAdminSystemFeasibilityMarketingRegionSchemaMarketingRegionResponse {
    /**
     * 
     * @type {string}
     * @memberof SrcApiAdminSystemFeasibilityMarketingRegionSchemaMarketingRegionResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SrcApiAdminSystemFeasibilityMarketingRegionSchemaMarketingRegionResponse
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SrcApiAdminSystemFeasibilityMarketingRegionSchemaMarketingRegionResponse
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof SrcApiAdminSystemFeasibilityMarketingRegionSchemaMarketingRegionResponse
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof SrcApiAdminSystemFeasibilityMarketingRegionSchemaMarketingRegionResponse
     */
    'updated_at': string;
}
/**
 * Address component
 * @export
 * @interface State
 */
export interface State {
}
/**
 * 
 * @export
 * @enum {string}
 */

export const StateEnum = {
    Empty: '',
    Ca: 'CA',
    Co: 'CO'
} as const;

export type StateEnum = typeof StateEnum[keyof typeof StateEnum];


/**
 * Address component
 * @export
 * @interface Street
 */
export interface Street {
}
/**
 * Schema for AHJ table view response.
 * @export
 * @interface TableViewAHJ
 */
export interface TableViewAHJ {
    /**
     * 
     * @type {string}
     * @memberof TableViewAHJ
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof TableViewAHJ
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof TableViewAHJ
     */
    'county': string;
    /**
     * 
     * @type {string}
     * @memberof TableViewAHJ
     */
    'state': string;
    /**
     * 
     * @type {boolean}
     * @memberof TableViewAHJ
     */
    'design_match'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof TableViewAHJ
     */
    'gas_ban'?: boolean | null;
    /**
     * 
     * @type {Array<AHJEstimatingRequirement>}
     * @memberof TableViewAHJ
     */
    'estimating_requirements'?: Array<AHJEstimatingRequirement>;
}
/**
 * 
 * @export
 * @interface Text
 */
export interface Text {
}
/**
 * The answer to the timeline question
 * @export
 * @interface TimelineAnswer
 */
export interface TimelineAnswer {
}
/**
 * 
 * @export
 * @interface UpdateAHJSchema
 */
export interface UpdateAHJSchema {
    /**
     * 
     * @type {string}
     * @memberof UpdateAHJSchema
     */
    'uuid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAHJSchema
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAHJSchema
     */
    'county'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAHJSchema
     */
    'state'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAHJSchema
     */
    'adu_checklist'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAHJSchema
     */
    'adu_ordinance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAHJSchema
     */
    'adu_regulations'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAHJSchema
     */
    'adu_website'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAHJSchema
     */
    'design_match'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAHJSchema
     */
    'fire_separation'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAHJSchema
     */
    'gas_ban'?: boolean | null;
    /**
     * 
     * @type {AHJGeometry}
     * @memberof UpdateAHJSchema
     */
    'geometry'?: AHJGeometry | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAHJSchema
     */
    'impact_fees'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAHJSchema
     */
    'max_unit_size'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAHJSchema
     */
    'muni_code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAHJSchema
     */
    'permit_submittal_instructions'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAHJSchema
     */
    'zoning_map'?: string | null;
    /**
     * 
     * @type {Array<AHJApprovalRequirement>}
     * @memberof UpdateAHJSchema
     */
    'approval_requirements'?: Array<AHJApprovalRequirement> | null;
    /**
     * 
     * @type {Array<AHJEstimatingRequirement>}
     * @memberof UpdateAHJSchema
     */
    'estimating_requirements'?: Array<AHJEstimatingRequirement> | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAHJSchema
     */
    'final_requirements'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAHJSchema
     */
    'issuance_requirements'?: string | null;
    /**
     * 
     * @type {Array<AHJSubmittalRequirement>}
     * @memberof UpdateAHJSchema
     */
    'submittal_requirements'?: Array<AHJSubmittalRequirement> | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateAHJSchema
     */
    'cornerlot_setback_feet_engineering'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAHJSchema
     */
    'cornerlot_setback_notes'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateAHJSchema
     */
    'front_setback_feet_engineering'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAHJSchema
     */
    'front_setback_notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAHJSchema
     */
    'landings_in_setback'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAHJSchema
     */
    'primary_residence_setback_notes'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateAHJSchema
     */
    'primary_residence_setback_feet_engineering'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateAHJSchema
     */
    'side_and_rear_setbacks_feet_engineering'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAHJSchema
     */
    'side_and_rear_setbacks_notes'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateAHJSchema
     */
    'structure_setback_feet_engineering'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAHJSchema
     */
    'structure_setback_notes'?: string | null;
    /**
     * 
     * @type {Array<ElectricDistrictSchema>}
     * @memberof UpdateAHJSchema
     */
    'electric_districts'?: Array<ElectricDistrictSchema> | null;
    /**
     * 
     * @type {Array<FireDistrictSchema>}
     * @memberof UpdateAHJSchema
     */
    'fire_districts'?: Array<FireDistrictSchema> | null;
    /**
     * 
     * @type {Array<SanitationDistrictSchema>}
     * @memberof UpdateAHJSchema
     */
    'sanitation_districts'?: Array<SanitationDistrictSchema> | null;
    /**
     * 
     * @type {Array<SchoolDistrictSchema>}
     * @memberof UpdateAHJSchema
     */
    'school_districts'?: Array<SchoolDistrictSchema> | null;
    /**
     * 
     * @type {Array<WaterDistrictSchema>}
     * @memberof UpdateAHJSchema
     */
    'water_districts'?: Array<WaterDistrictSchema> | null;
}
/**
 * 
 * @export
 * @interface UpdateElectricDistrictSchema
 */
export interface UpdateElectricDistrictSchema {
    /**
     * 
     * @type {string}
     * @memberof UpdateElectricDistrictSchema
     */
    'uuid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateElectricDistrictSchema
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateElectricDistrictSchema
     */
    'district_type': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateElectricDistrictSchema
     */
    'street_address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateElectricDistrictSchema
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateElectricDistrictSchema
     */
    'county'?: string | null;
    /**
     * 
     * @type {StateEnum}
     * @memberof UpdateElectricDistrictSchema
     */
    'state'?: StateEnum | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateElectricDistrictSchema
     */
    'zip_code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateElectricDistrictSchema
     */
    'email_contact'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateElectricDistrictSchema
     */
    'contact_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateElectricDistrictSchema
     */
    'contact_information'?: string | null;
    /**
     * 
     * @type {OpsTerritoryEnum}
     * @memberof UpdateElectricDistrictSchema
     */
    'ops_territory'?: OpsTerritoryEnum | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateElectricDistrictSchema
     */
    'service_map_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateElectricDistrictSchema
     */
    'website_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateElectricDistrictSchema
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateElectricDistrictSchema
     */
    'notes_estimating'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateElectricDistrictSchema
     */
    'ahj_uuids'?: Array<string> | null;
}


/**
 * 
 * @export
 * @interface UpdateEmployeeGroupsRequest
 */
export interface UpdateEmployeeGroupsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateEmployeeGroupsRequest
     */
    'group_ids': Array<string>;
}
/**
 * 
 * @export
 * @interface UpdateFireDistrictSchema
 */
export interface UpdateFireDistrictSchema {
    /**
     * 
     * @type {string}
     * @memberof UpdateFireDistrictSchema
     */
    'uuid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateFireDistrictSchema
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateFireDistrictSchema
     */
    'district_type': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateFireDistrictSchema
     */
    'street_address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateFireDistrictSchema
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateFireDistrictSchema
     */
    'county'?: string | null;
    /**
     * 
     * @type {StateEnum}
     * @memberof UpdateFireDistrictSchema
     */
    'state'?: StateEnum | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateFireDistrictSchema
     */
    'zip_code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateFireDistrictSchema
     */
    'email_contact'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateFireDistrictSchema
     */
    'contact_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateFireDistrictSchema
     */
    'contact_information'?: string | null;
    /**
     * 
     * @type {OpsTerritoryEnum}
     * @memberof UpdateFireDistrictSchema
     */
    'ops_territory'?: OpsTerritoryEnum | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateFireDistrictSchema
     */
    'service_map_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateFireDistrictSchema
     */
    'website_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateFireDistrictSchema
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateFireDistrictSchema
     */
    'notes_estimating'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateFireDistrictSchema
     */
    'fire_plan_instructions'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateFireDistrictSchema
     */
    'fee_notes'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateFireDistrictSchema
     */
    'fee_cents'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateFireDistrictSchema
     */
    'fire_access'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateFireDistrictSchema
     */
    'hydrant_distance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateFireDistrictSchema
     */
    'fire_sprinklers'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateFireDistrictSchema
     */
    'ahj_uuids'?: Array<string> | null;
}


/**
 * Schema for updating an existing Firestore factory ADU.
 * @export
 * @interface UpdateFirestoreFactoryADUSchema
 */
export interface UpdateFirestoreFactoryADUSchema {
    /**
     * 
     * @type {string}
     * @memberof UpdateFirestoreFactoryADUSchema
     */
    'factory_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateFirestoreFactoryADUSchema
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateFirestoreFactoryADUSchema
     */
    'square_footage'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateFirestoreFactoryADUSchema
     */
    'bedrooms'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateFirestoreFactoryADUSchema
     */
    'bathrooms'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateFirestoreFactoryADUSchema
     */
    'description'?: string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof UpdateFirestoreFactoryADUSchema
     */
    'features'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof UpdateFirestoreFactoryADUSchema
     */
    'pricing'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof UpdateFirestoreFactoryADUSchema
     */
    'images'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof UpdateFirestoreFactoryADUSchema
     */
    'specifications'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface UpdateGroupPermissionsRequest
 */
export interface UpdateGroupPermissionsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateGroupPermissionsRequest
     */
    'permission_ids': Array<string>;
}
/**
 * 
 * @export
 * @interface UpdateGroupRequest
 */
export interface UpdateGroupRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateGroupRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateGroupRequest
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateLeadQuestionsSchema
 */
export interface UpdateLeadQuestionsSchema {
    [key: string]: any;

    /**
     * The first name of the lead
     * @type {string}
     * @memberof UpdateLeadQuestionsSchema
     */
    'lead_first_name': string;
    /**
     * The last name of the lead
     * @type {string}
     * @memberof UpdateLeadQuestionsSchema
     */
    'lead_last_name': string;
    /**
     * The email of the lead
     * @type {string}
     * @memberof UpdateLeadQuestionsSchema
     */
    'lead_email': string;
    /**
     * 
     * @type {TimelineAnswer}
     * @memberof UpdateLeadQuestionsSchema
     */
    'timeline_answer'?: TimelineAnswer;
    /**
     * 
     * @type {BudgetAnswer}
     * @memberof UpdateLeadQuestionsSchema
     */
    'budget_answer'?: BudgetAnswer;
    /**
     * 
     * @type {AdditionalInformationAnswer}
     * @memberof UpdateLeadQuestionsSchema
     */
    'additional_information_answer'?: AdditionalInformationAnswer;
}
/**
 * 
 * @export
 * @interface UpdateModeSchema
 */
export interface UpdateModeSchema {
    /**
     * 
     * @type {string}
     * @memberof UpdateModeSchema
     */
    'mode': string;
}
/**
 * 
 * @export
 * @interface UpdateOandPSchema
 */
export interface UpdateOandPSchema {
    /**
     * 
     * @type {number}
     * @memberof UpdateOandPSchema
     */
    'o_and_p_percentage': number;
}
/**
 * 
 * @export
 * @interface UpdatePhaseFeesSchema
 */
export interface UpdatePhaseFeesSchema {
    /**
     * 
     * @type {number}
     * @memberof UpdatePhaseFeesSchema
     */
    'phase_1_fee_price': number;
    /**
     * 
     * @type {number}
     * @memberof UpdatePhaseFeesSchema
     */
    'phase_2_fee_price': number;
}
/**
 * Schema for updating an existing prefab factory.
 * @export
 * @interface UpdatePrefabFactorySchema
 */
export interface UpdatePrefabFactorySchema {
    /**
     * 
     * @type {string}
     * @memberof UpdatePrefabFactorySchema
     */
    'internal_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdatePrefabFactorySchema
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdatePrefabFactorySchema
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdatePrefabFactorySchema
     */
    'country'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdatePrefabFactorySchema
     */
    'county'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdatePrefabFactorySchema
     */
    'latitude'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdatePrefabFactorySchema
     */
    'longitude'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdatePrefabFactorySchema
     */
    'state'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdatePrefabFactorySchema
     */
    'street'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdatePrefabFactorySchema
     */
    'street_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdatePrefabFactorySchema
     */
    'zip'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdatePublishedSchema
 */
export interface UpdatePublishedSchema {
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePublishedSchema
     */
    'published': boolean;
}
/**
 * 
 * @export
 * @interface UpdateSalesTaxSchema
 */
export interface UpdateSalesTaxSchema {
    /**
     * 
     * @type {number}
     * @memberof UpdateSalesTaxSchema
     */
    'sales_tax_percentage': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateSalesTaxSchema
     */
    'sales_tax_modifier_percentage': number;
}
/**
 * 
 * @export
 * @interface UpdateSanitationDistrictSchema
 */
export interface UpdateSanitationDistrictSchema {
    /**
     * 
     * @type {string}
     * @memberof UpdateSanitationDistrictSchema
     */
    'uuid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateSanitationDistrictSchema
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateSanitationDistrictSchema
     */
    'district_type': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSanitationDistrictSchema
     */
    'street_address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateSanitationDistrictSchema
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateSanitationDistrictSchema
     */
    'county'?: string | null;
    /**
     * 
     * @type {StateEnum}
     * @memberof UpdateSanitationDistrictSchema
     */
    'state'?: StateEnum | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateSanitationDistrictSchema
     */
    'zip_code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateSanitationDistrictSchema
     */
    'email_contact'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateSanitationDistrictSchema
     */
    'contact_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateSanitationDistrictSchema
     */
    'contact_information'?: string | null;
    /**
     * 
     * @type {OpsTerritoryEnum}
     * @memberof UpdateSanitationDistrictSchema
     */
    'ops_territory'?: OpsTerritoryEnum | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateSanitationDistrictSchema
     */
    'service_map_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateSanitationDistrictSchema
     */
    'website_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateSanitationDistrictSchema
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateSanitationDistrictSchema
     */
    'notes_estimating'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateSanitationDistrictSchema
     */
    'will_serve_letter_instructions'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateSanitationDistrictSchema
     */
    'connection_fee_cents'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateSanitationDistrictSchema
     */
    'connection_fee_instructions'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateSanitationDistrictSchema
     */
    'connection_fee_notes'?: string | null;
    /**
     * 
     * @type {SometimesAlwaysNeverEnum}
     * @memberof UpdateSanitationDistrictSchema
     */
    'connection_permit_required'?: SometimesAlwaysNeverEnum | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateSanitationDistrictSchema
     */
    'ahj_uuids'?: Array<string> | null;
}


/**
 * 
 * @export
 * @interface UpdateSchoolDistrictSchema
 */
export interface UpdateSchoolDistrictSchema {
    /**
     * 
     * @type {string}
     * @memberof UpdateSchoolDistrictSchema
     */
    'uuid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateSchoolDistrictSchema
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateSchoolDistrictSchema
     */
    'district_type': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSchoolDistrictSchema
     */
    'street_address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateSchoolDistrictSchema
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateSchoolDistrictSchema
     */
    'county'?: string | null;
    /**
     * 
     * @type {StateEnum}
     * @memberof UpdateSchoolDistrictSchema
     */
    'state'?: StateEnum | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateSchoolDistrictSchema
     */
    'zip_code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateSchoolDistrictSchema
     */
    'email_contact'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateSchoolDistrictSchema
     */
    'contact_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateSchoolDistrictSchema
     */
    'contact_information'?: string | null;
    /**
     * 
     * @type {OpsTerritoryEnum}
     * @memberof UpdateSchoolDistrictSchema
     */
    'ops_territory'?: OpsTerritoryEnum | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateSchoolDistrictSchema
     */
    'service_map_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateSchoolDistrictSchema
     */
    'website_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateSchoolDistrictSchema
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateSchoolDistrictSchema
     */
    'notes_estimating'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateSchoolDistrictSchema
     */
    'payment_instructions'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateSchoolDistrictSchema
     */
    'payment_website'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateSchoolDistrictSchema
     */
    'ahj_uuids'?: Array<string> | null;
}


/**
 * Schema for updating a Segment 1 entry.
 * @export
 * @interface UpdateSegment1Schema
 */
export interface UpdateSegment1Schema {
    /**
     * 
     * @type {string}
     * @memberof UpdateSegment1Schema
     */
    'villa_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateSegment1Schema
     */
    'csi_name'?: string | null;
}
/**
 * Schema for updating a Segment 2 entry.
 * @export
 * @interface UpdateSegment2Schema
 */
export interface UpdateSegment2Schema {
    /**
     * 
     * @type {string}
     * @memberof UpdateSegment2Schema
     */
    'villa_name'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateWaterDistrictSchema
 */
export interface UpdateWaterDistrictSchema {
    /**
     * 
     * @type {string}
     * @memberof UpdateWaterDistrictSchema
     */
    'uuid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateWaterDistrictSchema
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateWaterDistrictSchema
     */
    'district_type': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateWaterDistrictSchema
     */
    'street_address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateWaterDistrictSchema
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateWaterDistrictSchema
     */
    'county'?: string | null;
    /**
     * 
     * @type {StateEnum}
     * @memberof UpdateWaterDistrictSchema
     */
    'state'?: StateEnum | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateWaterDistrictSchema
     */
    'zip_code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateWaterDistrictSchema
     */
    'email_contact'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateWaterDistrictSchema
     */
    'contact_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateWaterDistrictSchema
     */
    'contact_information'?: string | null;
    /**
     * 
     * @type {OpsTerritoryEnum}
     * @memberof UpdateWaterDistrictSchema
     */
    'ops_territory'?: OpsTerritoryEnum | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateWaterDistrictSchema
     */
    'service_map_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateWaterDistrictSchema
     */
    'website_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateWaterDistrictSchema
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateWaterDistrictSchema
     */
    'notes_estimating'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateWaterDistrictSchema
     */
    'flow_test_instructions'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateWaterDistrictSchema
     */
    'flow_test_fee_cents'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateWaterDistrictSchema
     */
    'flow_contact'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateWaterDistrictSchema
     */
    'flow_website'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateWaterDistrictSchema
     */
    'connection_fee_cents'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateWaterDistrictSchema
     */
    'connection_fee_instructions'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateWaterDistrictSchema
     */
    'connection_fee_notes'?: string | null;
    /**
     * 
     * @type {SometimesAlwaysNeverEnum}
     * @memberof UpdateWaterDistrictSchema
     */
    'connection_permit_required'?: SometimesAlwaysNeverEnum | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateWaterDistrictSchema
     */
    'connection_permit_instructions'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateWaterDistrictSchema
     */
    'will_serve_letter_instructions'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateWaterDistrictSchema
     */
    'ahj_uuids'?: Array<string> | null;
}


/**
 * 
 * @export
 * @interface ValidationError
 */
export interface ValidationError {
    /**
     * 
     * @type {Array<ValidationErrorLocInner>}
     * @memberof ValidationError
     */
    'loc': Array<ValidationErrorLocInner>;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'msg': string;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface ValidationErrorLocInner
 */
export interface ValidationErrorLocInner {
}
/**
 * This schema is used to validate the data from the waitlist form.
 * @export
 * @interface WaitlistLeadSchema
 */
export interface WaitlistLeadSchema {
    /**
     * 
     * @type {string}
     * @memberof WaitlistLeadSchema
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof WaitlistLeadSchema
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof WaitlistLeadSchema
     */
    'last_name': string;
    /**
     * 
     * @type {string}
     * @memberof WaitlistLeadSchema
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof WaitlistLeadSchema
     */
    'waitlist_id': string;
    /**
     * 
     * @type {string}
     * @memberof WaitlistLeadSchema
     */
    'intent': string;
    /**
     * 
     * @type {boolean}
     * @memberof WaitlistLeadSchema
     */
    'marketing_consent': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WaitlistLeadSchema
     */
    'terms_consent': boolean;
}
/**
 * 
 * @export
 * @interface WaterDistrictSchema
 */
export interface WaterDistrictSchema {
    /**
     * 
     * @type {string}
     * @memberof WaterDistrictSchema
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof WaterDistrictSchema
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof WaterDistrictSchema
     */
    'district_type': string;
    /**
     * 
     * @type {string}
     * @memberof WaterDistrictSchema
     */
    'street_address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WaterDistrictSchema
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WaterDistrictSchema
     */
    'county'?: string | null;
    /**
     * 
     * @type {StateEnum}
     * @memberof WaterDistrictSchema
     */
    'state'?: StateEnum | null;
    /**
     * 
     * @type {string}
     * @memberof WaterDistrictSchema
     */
    'zip_code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WaterDistrictSchema
     */
    'email_contact'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WaterDistrictSchema
     */
    'contact_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WaterDistrictSchema
     */
    'contact_information'?: string | null;
    /**
     * 
     * @type {OpsTerritoryEnum}
     * @memberof WaterDistrictSchema
     */
    'ops_territory'?: OpsTerritoryEnum | null;
    /**
     * 
     * @type {string}
     * @memberof WaterDistrictSchema
     */
    'service_map_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WaterDistrictSchema
     */
    'website_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WaterDistrictSchema
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WaterDistrictSchema
     */
    'notes_estimating'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WaterDistrictSchema
     */
    'flow_test_instructions'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WaterDistrictSchema
     */
    'flow_test_fee_cents'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof WaterDistrictSchema
     */
    'flow_contact'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WaterDistrictSchema
     */
    'flow_website'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WaterDistrictSchema
     */
    'connection_fee_cents'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof WaterDistrictSchema
     */
    'connection_fee_instructions'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WaterDistrictSchema
     */
    'connection_fee_notes'?: string | null;
    /**
     * 
     * @type {SometimesAlwaysNeverEnum}
     * @memberof WaterDistrictSchema
     */
    'connection_permit_required'?: SometimesAlwaysNeverEnum | null;
    /**
     * 
     * @type {string}
     * @memberof WaterDistrictSchema
     */
    'connection_permit_instructions'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WaterDistrictSchema
     */
    'will_serve_letter_instructions'?: string | null;
}


/**
 * 
 * @export
 * @interface WaterDistrictWithAHJs
 */
export interface WaterDistrictWithAHJs {
    /**
     * 
     * @type {string}
     * @memberof WaterDistrictWithAHJs
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof WaterDistrictWithAHJs
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof WaterDistrictWithAHJs
     */
    'district_type': string;
    /**
     * 
     * @type {string}
     * @memberof WaterDistrictWithAHJs
     */
    'street_address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WaterDistrictWithAHJs
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WaterDistrictWithAHJs
     */
    'county'?: string | null;
    /**
     * 
     * @type {StateEnum}
     * @memberof WaterDistrictWithAHJs
     */
    'state'?: StateEnum | null;
    /**
     * 
     * @type {string}
     * @memberof WaterDistrictWithAHJs
     */
    'zip_code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WaterDistrictWithAHJs
     */
    'email_contact'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WaterDistrictWithAHJs
     */
    'contact_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WaterDistrictWithAHJs
     */
    'contact_information'?: string | null;
    /**
     * 
     * @type {OpsTerritoryEnum}
     * @memberof WaterDistrictWithAHJs
     */
    'ops_territory'?: OpsTerritoryEnum | null;
    /**
     * 
     * @type {string}
     * @memberof WaterDistrictWithAHJs
     */
    'service_map_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WaterDistrictWithAHJs
     */
    'website_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WaterDistrictWithAHJs
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WaterDistrictWithAHJs
     */
    'notes_estimating'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WaterDistrictWithAHJs
     */
    'flow_test_instructions'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WaterDistrictWithAHJs
     */
    'flow_test_fee_cents'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof WaterDistrictWithAHJs
     */
    'flow_contact'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WaterDistrictWithAHJs
     */
    'flow_website'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WaterDistrictWithAHJs
     */
    'connection_fee_cents'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof WaterDistrictWithAHJs
     */
    'connection_fee_instructions'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WaterDistrictWithAHJs
     */
    'connection_fee_notes'?: string | null;
    /**
     * 
     * @type {SometimesAlwaysNeverEnum}
     * @memberof WaterDistrictWithAHJs
     */
    'connection_permit_required'?: SometimesAlwaysNeverEnum | null;
    /**
     * 
     * @type {string}
     * @memberof WaterDistrictWithAHJs
     */
    'connection_permit_instructions'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WaterDistrictWithAHJs
     */
    'will_serve_letter_instructions'?: string | null;
    /**
     * 
     * @type {Array<AHJ>}
     * @memberof WaterDistrictWithAHJs
     */
    'ahjs': Array<AHJ>;
}



/**
 * AdminApi - axios parameter creator
 * @export
 */
export const AdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Delete multiple factory ADUs.
         * @summary Bulk Delete Factory Adus
         * @param {FactoryADUBulkDeleteRequest} factoryADUBulkDeleteRequest 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDeleteFactoryAdus: async (factoryADUBulkDeleteRequest: FactoryADUBulkDeleteRequest, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'factoryADUBulkDeleteRequest' is not null or undefined
            assertParamExists('bulkDeleteFactoryAdus', 'factoryADUBulkDeleteRequest', factoryADUBulkDeleteRequest)
            const localVarPath = `/admin/factory-adus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(factoryADUBulkDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Can Auth User Access Project
         * @param {string} authUserId 
         * @param {string} projectId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        canAuthUserAccessProject: async (authUserId: string, projectId: string, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authUserId' is not null or undefined
            assertParamExists('canAuthUserAccessProject', 'authUserId', authUserId)
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('canAuthUserAccessProject', 'projectId', projectId)
            const localVarPath = `/admin/customers/auth_user/{auth_user_id}/can_access_project/{project_id}`
                .replace(`{${"auth_user_id"}}`, encodeURIComponent(String(authUserId)))
                .replace(`{${"project_id"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Firebase-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-firebase-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new factory ADU.
         * @summary Create Factory Adu
         * @param {FactoryADUCreate} factoryADUCreate 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFactoryAdu: async (factoryADUCreate: FactoryADUCreate, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'factoryADUCreate' is not null or undefined
            assertParamExists('createFactoryAdu', 'factoryADUCreate', factoryADUCreate)
            const localVarPath = `/admin/factory-adus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(factoryADUCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a factory ADU.
         * @summary Delete Factory Adu
         * @param {string} factoryAduId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFactoryAdu: async (factoryAduId: string, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'factoryAduId' is not null or undefined
            assertParamExists('deleteFactoryAdu', 'factoryAduId', factoryAduId)
            const localVarPath = `/admin/factory-adus/{factory_adu_id}`
                .replace(`{${"factory_adu_id"}}`, encodeURIComponent(String(factoryAduId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get All Listed Products
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllListedProducts: async (requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/products/listed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Firebase-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-firebase-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Customer
         * @param {string} userId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomer: async (userId: string, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getCustomer', 'userId', userId)
            const localVarPath = `/admin/customers/{user_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Firebase-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-firebase-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Customer By Auth User Id
         * @param {string} authUserId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerByAuthUserId: async (authUserId: string, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authUserId' is not null or undefined
            assertParamExists('getCustomerByAuthUserId', 'authUserId', authUserId)
            const localVarPath = `/admin/customers/auth_user/{auth_user_id}`
                .replace(`{${"auth_user_id"}}`, encodeURIComponent(String(authUserId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Firebase-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-firebase-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Customer Portfolios By Auth User Id
         * @param {string} authUserId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerPortfoliosByAuthUserId: async (authUserId: string, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authUserId' is not null or undefined
            assertParamExists('getCustomerPortfoliosByAuthUserId', 'authUserId', authUserId)
            const localVarPath = `/admin/customers/auth_user/{auth_user_id}/portfolios`
                .replace(`{${"auth_user_id"}}`, encodeURIComponent(String(authUserId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Firebase-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-firebase-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific factory ADU by ID.
         * @summary Get Factory Adu
         * @param {string} factoryAduId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFactoryAdu: async (factoryAduId: string, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'factoryAduId' is not null or undefined
            assertParamExists('getFactoryAdu', 'factoryAduId', factoryAduId)
            const localVarPath = `/admin/factory-adus/{factory_adu_id}`
                .replace(`{${"factory_adu_id"}}`, encodeURIComponent(String(factoryAduId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all factory ADUs.
         * @summary List Factory Adus
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFactoryAdus: async (requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/factory-adus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all factory ADUs for a specific factory.
         * @summary List Factory Adus By Factory
         * @param {string} factoryId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFactoryAdusByFactory: async (factoryId: string, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'factoryId' is not null or undefined
            assertParamExists('listFactoryAdusByFactory', 'factoryId', factoryId)
            const localVarPath = `/admin/factory-adus/factory/{factory_id}`
                .replace(`{${"factory_id"}}`, encodeURIComponent(String(factoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sync Customers
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncCustomers: async (requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/customers/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Firebase-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-firebase-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing factory ADU.
         * @summary Update Factory Adu
         * @param {string} factoryAduId 
         * @param {FactoryADUUpdate} factoryADUUpdate 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFactoryAdu: async (factoryAduId: string, factoryADUUpdate: FactoryADUUpdate, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'factoryAduId' is not null or undefined
            assertParamExists('updateFactoryAdu', 'factoryAduId', factoryAduId)
            // verify required parameter 'factoryADUUpdate' is not null or undefined
            assertParamExists('updateFactoryAdu', 'factoryADUUpdate', factoryADUUpdate)
            const localVarPath = `/admin/factory-adus/{factory_adu_id}`
                .replace(`{${"factory_adu_id"}}`, encodeURIComponent(String(factoryAduId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(factoryADUUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminApi - functional programming interface
 * @export
 */
export const AdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminApiAxiosParamCreator(configuration)
    return {
        /**
         * Delete multiple factory ADUs.
         * @summary Bulk Delete Factory Adus
         * @param {FactoryADUBulkDeleteRequest} factoryADUBulkDeleteRequest 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkDeleteFactoryAdus(factoryADUBulkDeleteRequest: FactoryADUBulkDeleteRequest, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FactoryADUBulkDeleteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkDeleteFactoryAdus(factoryADUBulkDeleteRequest, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.bulkDeleteFactoryAdus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Can Auth User Access Project
         * @param {string} authUserId 
         * @param {string} projectId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async canAuthUserAccessProject(authUserId: string, projectId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.canAuthUserAccessProject(authUserId, projectId, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.canAuthUserAccessProject']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new factory ADU.
         * @summary Create Factory Adu
         * @param {FactoryADUCreate} factoryADUCreate 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFactoryAdu(factoryADUCreate: FactoryADUCreate, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FactoryADUResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFactoryAdu(factoryADUCreate, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.createFactoryAdu']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a factory ADU.
         * @summary Delete Factory Adu
         * @param {string} factoryAduId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFactoryAdu(factoryAduId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FactoryADUDeleteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFactoryAdu(factoryAduId, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.deleteFactoryAdu']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get All Listed Products
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllListedProducts(requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllListedProducts(requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.getAllListedProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Customer
         * @param {string} userId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomer(userId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomer(userId, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.getCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Customer By Auth User Id
         * @param {string} authUserId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerByAuthUserId(authUserId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerByAuthUserId(authUserId, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.getCustomerByAuthUserId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Customer Portfolios By Auth User Id
         * @param {string} authUserId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerPortfoliosByAuthUserId(authUserId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerPortfoliosByAuthUserId(authUserId, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.getCustomerPortfoliosByAuthUserId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a specific factory ADU by ID.
         * @summary Get Factory Adu
         * @param {string} factoryAduId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFactoryAdu(factoryAduId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FactoryADUResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFactoryAdu(factoryAduId, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.getFactoryAdu']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all factory ADUs.
         * @summary List Factory Adus
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listFactoryAdus(requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FactoryADUListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listFactoryAdus(requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.listFactoryAdus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all factory ADUs for a specific factory.
         * @summary List Factory Adus By Factory
         * @param {string} factoryId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listFactoryAdusByFactory(factoryId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FactoryADUListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listFactoryAdusByFactory(factoryId, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.listFactoryAdusByFactory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Sync Customers
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncCustomers(requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncCustomers(requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.syncCustomers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing factory ADU.
         * @summary Update Factory Adu
         * @param {string} factoryAduId 
         * @param {FactoryADUUpdate} factoryADUUpdate 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFactoryAdu(factoryAduId: string, factoryADUUpdate: FactoryADUUpdate, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FactoryADUResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFactoryAdu(factoryAduId, factoryADUUpdate, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.updateFactoryAdu']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminApi - factory interface
 * @export
 */
export const AdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminApiFp(configuration)
    return {
        /**
         * Delete multiple factory ADUs.
         * @summary Bulk Delete Factory Adus
         * @param {FactoryADUBulkDeleteRequest} factoryADUBulkDeleteRequest 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDeleteFactoryAdus(factoryADUBulkDeleteRequest: FactoryADUBulkDeleteRequest, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<FactoryADUBulkDeleteResponse> {
            return localVarFp.bulkDeleteFactoryAdus(factoryADUBulkDeleteRequest, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Can Auth User Access Project
         * @param {string} authUserId 
         * @param {string} projectId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        canAuthUserAccessProject(authUserId: string, projectId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.canAuthUserAccessProject(authUserId, projectId, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new factory ADU.
         * @summary Create Factory Adu
         * @param {FactoryADUCreate} factoryADUCreate 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFactoryAdu(factoryADUCreate: FactoryADUCreate, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<FactoryADUResponse> {
            return localVarFp.createFactoryAdu(factoryADUCreate, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a factory ADU.
         * @summary Delete Factory Adu
         * @param {string} factoryAduId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFactoryAdu(factoryAduId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<FactoryADUDeleteResponse> {
            return localVarFp.deleteFactoryAdu(factoryAduId, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get All Listed Products
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllListedProducts(requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getAllListedProducts(requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Customer
         * @param {string} userId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomer(userId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getCustomer(userId, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Customer By Auth User Id
         * @param {string} authUserId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerByAuthUserId(authUserId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getCustomerByAuthUserId(authUserId, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Customer Portfolios By Auth User Id
         * @param {string} authUserId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerPortfoliosByAuthUserId(authUserId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getCustomerPortfoliosByAuthUserId(authUserId, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific factory ADU by ID.
         * @summary Get Factory Adu
         * @param {string} factoryAduId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFactoryAdu(factoryAduId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<FactoryADUResponse> {
            return localVarFp.getFactoryAdu(factoryAduId, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * List all factory ADUs.
         * @summary List Factory Adus
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFactoryAdus(requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<FactoryADUListResponse> {
            return localVarFp.listFactoryAdus(requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * List all factory ADUs for a specific factory.
         * @summary List Factory Adus By Factory
         * @param {string} factoryId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFactoryAdusByFactory(factoryId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<FactoryADUListResponse> {
            return localVarFp.listFactoryAdusByFactory(factoryId, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sync Customers
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncCustomers(requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.syncCustomers(requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing factory ADU.
         * @summary Update Factory Adu
         * @param {string} factoryAduId 
         * @param {FactoryADUUpdate} factoryADUUpdate 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFactoryAdu(factoryAduId: string, factoryADUUpdate: FactoryADUUpdate, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<FactoryADUResponse> {
            return localVarFp.updateFactoryAdu(factoryAduId, factoryADUUpdate, requestSource, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminApi - object-oriented interface
 * @export
 * @class AdminApi
 * @extends {BaseAPI}
 */
export class AdminApi extends BaseAPI {
    /**
     * Delete multiple factory ADUs.
     * @summary Bulk Delete Factory Adus
     * @param {FactoryADUBulkDeleteRequest} factoryADUBulkDeleteRequest 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public bulkDeleteFactoryAdus(factoryADUBulkDeleteRequest: FactoryADUBulkDeleteRequest, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).bulkDeleteFactoryAdus(factoryADUBulkDeleteRequest, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Can Auth User Access Project
     * @param {string} authUserId 
     * @param {string} projectId 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public canAuthUserAccessProject(authUserId: string, projectId: string, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).canAuthUserAccessProject(authUserId, projectId, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new factory ADU.
     * @summary Create Factory Adu
     * @param {FactoryADUCreate} factoryADUCreate 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public createFactoryAdu(factoryADUCreate: FactoryADUCreate, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).createFactoryAdu(factoryADUCreate, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a factory ADU.
     * @summary Delete Factory Adu
     * @param {string} factoryAduId 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public deleteFactoryAdu(factoryAduId: string, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).deleteFactoryAdu(factoryAduId, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get All Listed Products
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public getAllListedProducts(requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).getAllListedProducts(requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Customer
     * @param {string} userId 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public getCustomer(userId: string, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).getCustomer(userId, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Customer By Auth User Id
     * @param {string} authUserId 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public getCustomerByAuthUserId(authUserId: string, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).getCustomerByAuthUserId(authUserId, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Customer Portfolios By Auth User Id
     * @param {string} authUserId 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public getCustomerPortfoliosByAuthUserId(authUserId: string, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).getCustomerPortfoliosByAuthUserId(authUserId, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific factory ADU by ID.
     * @summary Get Factory Adu
     * @param {string} factoryAduId 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public getFactoryAdu(factoryAduId: string, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).getFactoryAdu(factoryAduId, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all factory ADUs.
     * @summary List Factory Adus
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public listFactoryAdus(requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).listFactoryAdus(requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all factory ADUs for a specific factory.
     * @summary List Factory Adus By Factory
     * @param {string} factoryId 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public listFactoryAdusByFactory(factoryId: string, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).listFactoryAdusByFactory(factoryId, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sync Customers
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public syncCustomers(requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).syncCustomers(requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing factory ADU.
     * @summary Update Factory Adu
     * @param {string} factoryAduId 
     * @param {FactoryADUUpdate} factoryADUUpdate 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public updateFactoryAdu(factoryAduId: string, factoryADUUpdate: FactoryADUUpdate, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).updateFactoryAdu(factoryAduId, factoryADUUpdate, requestSource, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminAhjApi - axios parameter creator
 * @export
 */
export const AdminAhjApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Ahj
         * @param {CreateAHJSchema} createAHJSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAhj: async (createAHJSchema: CreateAHJSchema, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createAHJSchema' is not null or undefined
            assertParamExists('createAhj', 'createAHJSchema', createAHJSchema)
            const localVarPath = `/admin/ahj`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAHJSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Ahj Embedding By Id
         * @param {string} ahjId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAhjEmbeddingById: async (ahjId: string, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ahjId' is not null or undefined
            assertParamExists('createAhjEmbeddingById', 'ahjId', ahjId)
            const localVarPath = `/admin/ahj/{ahj_id}/embeddings/create`
                .replace(`{${"ahj_id"}}`, encodeURIComponent(String(ahjId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create embeddings for all AHJs in the database.
         * @summary Create Ahj Embeddings
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAhjEmbeddings: async (requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/ahj/embeddings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Ahj Requirements
         * @param {string} requirementType 
         * @param {CreateAHJRequirement} createAHJRequirement 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAhjRequirements: async (requirementType: string, createAHJRequirement: CreateAHJRequirement, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requirementType' is not null or undefined
            assertParamExists('createAhjRequirements', 'requirementType', requirementType)
            // verify required parameter 'createAHJRequirement' is not null or undefined
            assertParamExists('createAhjRequirements', 'createAHJRequirement', createAHJRequirement)
            const localVarPath = `/admin/ahj/requirement/{requirement_type}`
                .replace(`{${"requirement_type"}}`, encodeURIComponent(String(requirementType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAHJRequirement, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Ahj By Id
         * @param {string} ahjId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAhjById: async (ahjId: string, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ahjId' is not null or undefined
            assertParamExists('deleteAhjById', 'ahjId', ahjId)
            const localVarPath = `/admin/ahj/{ahj_id}`
                .replace(`{${"ahj_id"}}`, encodeURIComponent(String(ahjId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single AHJ by ID with optional relationships.
         * @summary Get Ahj
         * @param {string} ahjId 
         * @param {boolean} [includeGeometry] 
         * @param {boolean} [includeRequirements] 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAhj: async (ahjId: string, includeGeometry?: boolean, includeRequirements?: boolean, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ahjId' is not null or undefined
            assertParamExists('getAhj', 'ahjId', ahjId)
            const localVarPath = `/admin/ahj/{ahj_id}`
                .replace(`{${"ahj_id"}}`, encodeURIComponent(String(ahjId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)

            if (includeGeometry !== undefined) {
                localVarQueryParameter['include_geometry'] = includeGeometry;
            }

            if (includeRequirements !== undefined) {
                localVarQueryParameter['include_requirements'] = includeRequirements;
            }


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Ahj Requirements
         * @param {string} requirementType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAhjRequirements: async (requirementType: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requirementType' is not null or undefined
            assertParamExists('getAhjRequirements', 'requirementType', requirementType)
            const localVarPath = `/admin/ahj/requirement/{requirement_type}`
                .replace(`{${"requirement_type"}}`, encodeURIComponent(String(requirementType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all AHJs in table view format. Returns simplified AHJ objects with essential fields for table display.
         * @summary Get All Ahjs
         * @param {string} [searchQuery] 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAhjs: async (searchQuery?: string, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/ahj`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)

            if (searchQuery !== undefined) {
                localVarQueryParameter['search_query'] = searchQuery;
            }


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Count Of Ahjs To Migrate
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountOfAhjsToMigrate: async (requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/ahj/migrate/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Migrate Ahjs
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrateAhjs: async (requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/ahj/migrate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search Ahj By Lat Long
         * @param {string} latitude 
         * @param {string} longitude 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAhjByLatLong: async (latitude: string, longitude: string, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'latitude' is not null or undefined
            assertParamExists('searchAhjByLatLong', 'latitude', latitude)
            // verify required parameter 'longitude' is not null or undefined
            assertParamExists('searchAhjByLatLong', 'longitude', longitude)
            const localVarPath = `/admin/ahj/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)

            if (latitude !== undefined) {
                localVarQueryParameter['latitude'] = latitude;
            }

            if (longitude !== undefined) {
                localVarQueryParameter['longitude'] = longitude;
            }


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search for AHJs similar to a text query.
         * @summary Search Similar Ahjs
         * @param {string} query 
         * @param {number} [limit] 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSimilarAhjs: async (query: string, limit?: number, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'query' is not null or undefined
            assertParamExists('searchSimilarAhjs', 'query', query)
            const localVarPath = `/admin/ahj/search/similar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Ahj
         * @param {string} ahjId 
         * @param {UpdateAHJSchema} updateAHJSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAhj: async (ahjId: string, updateAHJSchema: UpdateAHJSchema, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ahjId' is not null or undefined
            assertParamExists('updateAhj', 'ahjId', ahjId)
            // verify required parameter 'updateAHJSchema' is not null or undefined
            assertParamExists('updateAhj', 'updateAHJSchema', updateAHJSchema)
            const localVarPath = `/admin/ahj/{ahj_id}`
                .replace(`{${"ahj_id"}}`, encodeURIComponent(String(ahjId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAHJSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminAhjApi - functional programming interface
 * @export
 */
export const AdminAhjApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminAhjApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Ahj
         * @param {CreateAHJSchema} createAHJSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAhj(createAHJSchema: CreateAHJSchema, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AHJ>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAhj(createAHJSchema, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAhjApi.createAhj']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Ahj Embedding By Id
         * @param {string} ahjId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAhjEmbeddingById(ahjId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAhjEmbeddingById(ahjId, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAhjApi.createAhjEmbeddingById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create embeddings for all AHJs in the database.
         * @summary Create Ahj Embeddings
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAhjEmbeddings(requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAhjEmbeddings(requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAhjApi.createAhjEmbeddings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Ahj Requirements
         * @param {string} requirementType 
         * @param {CreateAHJRequirement} createAHJRequirement 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAhjRequirements(requirementType: string, createAHJRequirement: CreateAHJRequirement, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAhjRequirements(requirementType, createAHJRequirement, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAhjApi.createAhjRequirements']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Ahj By Id
         * @param {string} ahjId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAhjById(ahjId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAhjById(ahjId, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAhjApi.deleteAhjById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a single AHJ by ID with optional relationships.
         * @summary Get Ahj
         * @param {string} ahjId 
         * @param {boolean} [includeGeometry] 
         * @param {boolean} [includeRequirements] 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAhj(ahjId: string, includeGeometry?: boolean, includeRequirements?: boolean, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AHJWithDistricts>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAhj(ahjId, includeGeometry, includeRequirements, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAhjApi.getAhj']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Ahj Requirements
         * @param {string} requirementType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAhjRequirements(requirementType: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAhjRequirements(requirementType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAhjApi.getAhjRequirements']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all AHJs in table view format. Returns simplified AHJ objects with essential fields for table display.
         * @summary Get All Ahjs
         * @param {string} [searchQuery] 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllAhjs(searchQuery?: string, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TableViewAHJ>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllAhjs(searchQuery, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAhjApi.getAllAhjs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Count Of Ahjs To Migrate
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCountOfAhjsToMigrate(requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCountOfAhjsToMigrate(requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAhjApi.getCountOfAhjsToMigrate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Migrate Ahjs
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async migrateAhjs(requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.migrateAhjs(requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAhjApi.migrateAhjs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Search Ahj By Lat Long
         * @param {string} latitude 
         * @param {string} longitude 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchAhjByLatLong(latitude: string, longitude: string, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AHJ>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchAhjByLatLong(latitude, longitude, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAhjApi.searchAhjByLatLong']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search for AHJs similar to a text query.
         * @summary Search Similar Ahjs
         * @param {string} query 
         * @param {number} [limit] 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchSimilarAhjs(query: string, limit?: number, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchSimilarAhjs(query, limit, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAhjApi.searchSimilarAhjs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Ahj
         * @param {string} ahjId 
         * @param {UpdateAHJSchema} updateAHJSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAhj(ahjId: string, updateAHJSchema: UpdateAHJSchema, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AHJ>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAhj(ahjId, updateAHJSchema, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAhjApi.updateAhj']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminAhjApi - factory interface
 * @export
 */
export const AdminAhjApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminAhjApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Ahj
         * @param {CreateAHJSchema} createAHJSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAhj(createAHJSchema: CreateAHJSchema, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<AHJ> {
            return localVarFp.createAhj(createAHJSchema, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Ahj Embedding By Id
         * @param {string} ahjId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAhjEmbeddingById(ahjId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.createAhjEmbeddingById(ahjId, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Create embeddings for all AHJs in the database.
         * @summary Create Ahj Embeddings
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAhjEmbeddings(requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.createAhjEmbeddings(requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Ahj Requirements
         * @param {string} requirementType 
         * @param {CreateAHJRequirement} createAHJRequirement 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAhjRequirements(requirementType: string, createAHJRequirement: CreateAHJRequirement, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.createAhjRequirements(requirementType, createAHJRequirement, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Ahj By Id
         * @param {string} ahjId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAhjById(ahjId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteAhjById(ahjId, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a single AHJ by ID with optional relationships.
         * @summary Get Ahj
         * @param {string} ahjId 
         * @param {boolean} [includeGeometry] 
         * @param {boolean} [includeRequirements] 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAhj(ahjId: string, includeGeometry?: boolean, includeRequirements?: boolean, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<AHJWithDistricts> {
            return localVarFp.getAhj(ahjId, includeGeometry, includeRequirements, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Ahj Requirements
         * @param {string} requirementType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAhjRequirements(requirementType: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getAhjRequirements(requirementType, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all AHJs in table view format. Returns simplified AHJ objects with essential fields for table display.
         * @summary Get All Ahjs
         * @param {string} [searchQuery] 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAhjs(searchQuery?: string, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<Array<TableViewAHJ>> {
            return localVarFp.getAllAhjs(searchQuery, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Count Of Ahjs To Migrate
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountOfAhjsToMigrate(requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getCountOfAhjsToMigrate(requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Migrate Ahjs
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrateAhjs(requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.migrateAhjs(requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search Ahj By Lat Long
         * @param {string} latitude 
         * @param {string} longitude 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAhjByLatLong(latitude: string, longitude: string, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<AHJ> {
            return localVarFp.searchAhjByLatLong(latitude, longitude, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Search for AHJs similar to a text query.
         * @summary Search Similar Ahjs
         * @param {string} query 
         * @param {number} [limit] 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSimilarAhjs(query: string, limit?: number, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.searchSimilarAhjs(query, limit, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Ahj
         * @param {string} ahjId 
         * @param {UpdateAHJSchema} updateAHJSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAhj(ahjId: string, updateAHJSchema: UpdateAHJSchema, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<AHJ> {
            return localVarFp.updateAhj(ahjId, updateAHJSchema, requestSource, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminAhjApi - object-oriented interface
 * @export
 * @class AdminAhjApi
 * @extends {BaseAPI}
 */
export class AdminAhjApi extends BaseAPI {
    /**
     * 
     * @summary Create Ahj
     * @param {CreateAHJSchema} createAHJSchema 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAhjApi
     */
    public createAhj(createAHJSchema: CreateAHJSchema, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminAhjApiFp(this.configuration).createAhj(createAHJSchema, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Ahj Embedding By Id
     * @param {string} ahjId 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAhjApi
     */
    public createAhjEmbeddingById(ahjId: string, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminAhjApiFp(this.configuration).createAhjEmbeddingById(ahjId, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create embeddings for all AHJs in the database.
     * @summary Create Ahj Embeddings
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAhjApi
     */
    public createAhjEmbeddings(requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminAhjApiFp(this.configuration).createAhjEmbeddings(requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Ahj Requirements
     * @param {string} requirementType 
     * @param {CreateAHJRequirement} createAHJRequirement 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAhjApi
     */
    public createAhjRequirements(requirementType: string, createAHJRequirement: CreateAHJRequirement, options?: RawAxiosRequestConfig) {
        return AdminAhjApiFp(this.configuration).createAhjRequirements(requirementType, createAHJRequirement, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Ahj By Id
     * @param {string} ahjId 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAhjApi
     */
    public deleteAhjById(ahjId: string, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminAhjApiFp(this.configuration).deleteAhjById(ahjId, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a single AHJ by ID with optional relationships.
     * @summary Get Ahj
     * @param {string} ahjId 
     * @param {boolean} [includeGeometry] 
     * @param {boolean} [includeRequirements] 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAhjApi
     */
    public getAhj(ahjId: string, includeGeometry?: boolean, includeRequirements?: boolean, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminAhjApiFp(this.configuration).getAhj(ahjId, includeGeometry, includeRequirements, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Ahj Requirements
     * @param {string} requirementType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAhjApi
     */
    public getAhjRequirements(requirementType: string, options?: RawAxiosRequestConfig) {
        return AdminAhjApiFp(this.configuration).getAhjRequirements(requirementType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all AHJs in table view format. Returns simplified AHJ objects with essential fields for table display.
     * @summary Get All Ahjs
     * @param {string} [searchQuery] 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAhjApi
     */
    public getAllAhjs(searchQuery?: string, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminAhjApiFp(this.configuration).getAllAhjs(searchQuery, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Count Of Ahjs To Migrate
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAhjApi
     */
    public getCountOfAhjsToMigrate(requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminAhjApiFp(this.configuration).getCountOfAhjsToMigrate(requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Migrate Ahjs
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAhjApi
     */
    public migrateAhjs(requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminAhjApiFp(this.configuration).migrateAhjs(requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search Ahj By Lat Long
     * @param {string} latitude 
     * @param {string} longitude 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAhjApi
     */
    public searchAhjByLatLong(latitude: string, longitude: string, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminAhjApiFp(this.configuration).searchAhjByLatLong(latitude, longitude, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search for AHJs similar to a text query.
     * @summary Search Similar Ahjs
     * @param {string} query 
     * @param {number} [limit] 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAhjApi
     */
    public searchSimilarAhjs(query: string, limit?: number, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminAhjApiFp(this.configuration).searchSimilarAhjs(query, limit, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Ahj
     * @param {string} ahjId 
     * @param {UpdateAHJSchema} updateAHJSchema 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAhjApi
     */
    public updateAhj(ahjId: string, updateAHJSchema: UpdateAHJSchema, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminAhjApiFp(this.configuration).updateAhj(ahjId, updateAHJSchema, requestSource, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminCustomerApi - axios parameter creator
 * @export
 */
export const AdminCustomerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Firebase User By Salesforce Id
         * @param {string | null} [firstName] 
         * @param {string | null} [lastName] 
         * @param {string | null} [email] 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFirebaseUserBySalesforceId: async (firstName?: string | null, lastName?: string | null, email?: string | null, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/firebase-user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)

            if (firstName !== undefined) {
                localVarQueryParameter['first_name'] = firstName;
            }

            if (lastName !== undefined) {
                localVarQueryParameter['last_name'] = lastName;
            }

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search for customers in Firebase Auth by email, first name, or last name.
         * @summary Search Customers Firebase
         * @param {string | null} [email] 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCustomersFirebase: async (email?: string | null, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/customer/search/firebase`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search for customers in Firestore by email, first name, or last name.
         * @summary Search Customers Firestore
         * @param {string | null} [email] 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCustomersFirestore: async (email?: string | null, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/customer/search/firestore`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminCustomerApi - functional programming interface
 * @export
 */
export const AdminCustomerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminCustomerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Firebase User By Salesforce Id
         * @param {string | null} [firstName] 
         * @param {string | null} [lastName] 
         * @param {string | null} [email] 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFirebaseUserBySalesforceId(firstName?: string | null, lastName?: string | null, email?: string | null, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFirebaseUserBySalesforceId(firstName, lastName, email, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCustomerApi.createFirebaseUserBySalesforceId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search for customers in Firebase Auth by email, first name, or last name.
         * @summary Search Customers Firebase
         * @param {string | null} [email] 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchCustomersFirebase(email?: string | null, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchCustomersFirebase(email, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCustomerApi.searchCustomersFirebase']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search for customers in Firestore by email, first name, or last name.
         * @summary Search Customers Firestore
         * @param {string | null} [email] 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchCustomersFirestore(email?: string | null, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchCustomersFirestore(email, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCustomerApi.searchCustomersFirestore']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminCustomerApi - factory interface
 * @export
 */
export const AdminCustomerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminCustomerApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Firebase User By Salesforce Id
         * @param {string | null} [firstName] 
         * @param {string | null} [lastName] 
         * @param {string | null} [email] 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFirebaseUserBySalesforceId(firstName?: string | null, lastName?: string | null, email?: string | null, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.createFirebaseUserBySalesforceId(firstName, lastName, email, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Search for customers in Firebase Auth by email, first name, or last name.
         * @summary Search Customers Firebase
         * @param {string | null} [email] 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCustomersFirebase(email?: string | null, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.searchCustomersFirebase(email, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Search for customers in Firestore by email, first name, or last name.
         * @summary Search Customers Firestore
         * @param {string | null} [email] 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCustomersFirestore(email?: string | null, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.searchCustomersFirestore(email, requestSource, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminCustomerApi - object-oriented interface
 * @export
 * @class AdminCustomerApi
 * @extends {BaseAPI}
 */
export class AdminCustomerApi extends BaseAPI {
    /**
     * 
     * @summary Create Firebase User By Salesforce Id
     * @param {string | null} [firstName] 
     * @param {string | null} [lastName] 
     * @param {string | null} [email] 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCustomerApi
     */
    public createFirebaseUserBySalesforceId(firstName?: string | null, lastName?: string | null, email?: string | null, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminCustomerApiFp(this.configuration).createFirebaseUserBySalesforceId(firstName, lastName, email, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search for customers in Firebase Auth by email, first name, or last name.
     * @summary Search Customers Firebase
     * @param {string | null} [email] 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCustomerApi
     */
    public searchCustomersFirebase(email?: string | null, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminCustomerApiFp(this.configuration).searchCustomersFirebase(email, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search for customers in Firestore by email, first name, or last name.
     * @summary Search Customers Firestore
     * @param {string | null} [email] 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCustomerApi
     */
    public searchCustomersFirestore(email?: string | null, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminCustomerApiFp(this.configuration).searchCustomersFirestore(email, requestSource, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminDistrictsApi - axios parameter creator
 * @export
 */
export const AdminDistrictsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Admin Create Electric District
         * @param {CreateElectricDistrictSchema} createElectricDistrictSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateElectricDistrict: async (createElectricDistrictSchema: CreateElectricDistrictSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createElectricDistrictSchema' is not null or undefined
            assertParamExists('adminCreateElectricDistrict', 'createElectricDistrictSchema', createElectricDistrictSchema)
            const localVarPath = `/admin/district/electric`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createElectricDistrictSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin Create Fire District
         * @param {CreateFireDistrictSchema} createFireDistrictSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateFireDistrict: async (createFireDistrictSchema: CreateFireDistrictSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createFireDistrictSchema' is not null or undefined
            assertParamExists('adminCreateFireDistrict', 'createFireDistrictSchema', createFireDistrictSchema)
            const localVarPath = `/admin/district/fire`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFireDistrictSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin Create Sanitation District
         * @param {CreateSanitationDistrictSchema} createSanitationDistrictSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateSanitationDistrict: async (createSanitationDistrictSchema: CreateSanitationDistrictSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createSanitationDistrictSchema' is not null or undefined
            assertParamExists('adminCreateSanitationDistrict', 'createSanitationDistrictSchema', createSanitationDistrictSchema)
            const localVarPath = `/admin/district/sanitation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSanitationDistrictSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin Create School District
         * @param {CreateSchoolDistrictSchema} createSchoolDistrictSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateSchoolDistrict: async (createSchoolDistrictSchema: CreateSchoolDistrictSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createSchoolDistrictSchema' is not null or undefined
            assertParamExists('adminCreateSchoolDistrict', 'createSchoolDistrictSchema', createSchoolDistrictSchema)
            const localVarPath = `/admin/district/school`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSchoolDistrictSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin Create Water District
         * @param {CreateWaterDistrictSchema} createWaterDistrictSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateWaterDistrict: async (createWaterDistrictSchema: CreateWaterDistrictSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createWaterDistrictSchema' is not null or undefined
            assertParamExists('adminCreateWaterDistrict', 'createWaterDistrictSchema', createWaterDistrictSchema)
            const localVarPath = `/admin/district/water`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createWaterDistrictSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin Delete Electric District
         * @param {string} districtId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteElectricDistrict: async (districtId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'districtId' is not null or undefined
            assertParamExists('adminDeleteElectricDistrict', 'districtId', districtId)
            const localVarPath = `/admin/district/electric/{district_id}`
                .replace(`{${"district_id"}}`, encodeURIComponent(String(districtId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin Delete Fire District
         * @param {string} districtId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteFireDistrict: async (districtId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'districtId' is not null or undefined
            assertParamExists('adminDeleteFireDistrict', 'districtId', districtId)
            const localVarPath = `/admin/district/fire/{district_id}`
                .replace(`{${"district_id"}}`, encodeURIComponent(String(districtId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin Delete Sanitation District
         * @param {string} districtId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteSanitationDistrict: async (districtId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'districtId' is not null or undefined
            assertParamExists('adminDeleteSanitationDistrict', 'districtId', districtId)
            const localVarPath = `/admin/district/sanitation/{district_id}`
                .replace(`{${"district_id"}}`, encodeURIComponent(String(districtId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin Delete School District
         * @param {string} districtId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteSchoolDistrict: async (districtId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'districtId' is not null or undefined
            assertParamExists('adminDeleteSchoolDistrict', 'districtId', districtId)
            const localVarPath = `/admin/district/school/{district_id}`
                .replace(`{${"district_id"}}`, encodeURIComponent(String(districtId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin Delete Water District
         * @param {string} districtId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteWaterDistrict: async (districtId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'districtId' is not null or undefined
            assertParamExists('adminDeleteWaterDistrict', 'districtId', districtId)
            const localVarPath = `/admin/district/water/{district_id}`
                .replace(`{${"district_id"}}`, encodeURIComponent(String(districtId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin Get Electric District
         * @param {string} districtId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetElectricDistrict: async (districtId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'districtId' is not null or undefined
            assertParamExists('adminGetElectricDistrict', 'districtId', districtId)
            const localVarPath = `/admin/district/electric/{district_id}`
                .replace(`{${"district_id"}}`, encodeURIComponent(String(districtId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin Get Electric Districts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetElectricDistricts: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/district/electric`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin Get Fire District
         * @param {string} districtId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetFireDistrict: async (districtId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'districtId' is not null or undefined
            assertParamExists('adminGetFireDistrict', 'districtId', districtId)
            const localVarPath = `/admin/district/fire/{district_id}`
                .replace(`{${"district_id"}}`, encodeURIComponent(String(districtId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin Get Fire Districts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetFireDistricts: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/district/fire`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin Get Sanitation District
         * @param {string} districtId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetSanitationDistrict: async (districtId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'districtId' is not null or undefined
            assertParamExists('adminGetSanitationDistrict', 'districtId', districtId)
            const localVarPath = `/admin/district/sanitation/{district_id}`
                .replace(`{${"district_id"}}`, encodeURIComponent(String(districtId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin Get Sanitation Districts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetSanitationDistricts: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/district/sanitation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin Get School District
         * @param {string} districtId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetSchoolDistrict: async (districtId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'districtId' is not null or undefined
            assertParamExists('adminGetSchoolDistrict', 'districtId', districtId)
            const localVarPath = `/admin/district/school/{district_id}`
                .replace(`{${"district_id"}}`, encodeURIComponent(String(districtId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin Get School Districts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetSchoolDistricts: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/district/school`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin Get Water District
         * @param {string} districtId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetWaterDistrict: async (districtId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'districtId' is not null or undefined
            assertParamExists('adminGetWaterDistrict', 'districtId', districtId)
            const localVarPath = `/admin/district/water/{district_id}`
                .replace(`{${"district_id"}}`, encodeURIComponent(String(districtId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin Get Water Districts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetWaterDistricts: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/district/water`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin Update Electric District
         * @param {string} districtId 
         * @param {UpdateElectricDistrictSchema} updateElectricDistrictSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateElectricDistrict: async (districtId: string, updateElectricDistrictSchema: UpdateElectricDistrictSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'districtId' is not null or undefined
            assertParamExists('adminUpdateElectricDistrict', 'districtId', districtId)
            // verify required parameter 'updateElectricDistrictSchema' is not null or undefined
            assertParamExists('adminUpdateElectricDistrict', 'updateElectricDistrictSchema', updateElectricDistrictSchema)
            const localVarPath = `/admin/district/electric/{district_id}`
                .replace(`{${"district_id"}}`, encodeURIComponent(String(districtId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateElectricDistrictSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin Update Fire District
         * @param {string} districtId 
         * @param {UpdateFireDistrictSchema} updateFireDistrictSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateFireDistrict: async (districtId: string, updateFireDistrictSchema: UpdateFireDistrictSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'districtId' is not null or undefined
            assertParamExists('adminUpdateFireDistrict', 'districtId', districtId)
            // verify required parameter 'updateFireDistrictSchema' is not null or undefined
            assertParamExists('adminUpdateFireDistrict', 'updateFireDistrictSchema', updateFireDistrictSchema)
            const localVarPath = `/admin/district/fire/{district_id}`
                .replace(`{${"district_id"}}`, encodeURIComponent(String(districtId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFireDistrictSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin Update Sanitation District
         * @param {string} districtId 
         * @param {UpdateSanitationDistrictSchema} updateSanitationDistrictSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateSanitationDistrict: async (districtId: string, updateSanitationDistrictSchema: UpdateSanitationDistrictSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'districtId' is not null or undefined
            assertParamExists('adminUpdateSanitationDistrict', 'districtId', districtId)
            // verify required parameter 'updateSanitationDistrictSchema' is not null or undefined
            assertParamExists('adminUpdateSanitationDistrict', 'updateSanitationDistrictSchema', updateSanitationDistrictSchema)
            const localVarPath = `/admin/district/sanitation/{district_id}`
                .replace(`{${"district_id"}}`, encodeURIComponent(String(districtId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSanitationDistrictSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin Update School District
         * @param {string} districtId 
         * @param {UpdateSchoolDistrictSchema} updateSchoolDistrictSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateSchoolDistrict: async (districtId: string, updateSchoolDistrictSchema: UpdateSchoolDistrictSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'districtId' is not null or undefined
            assertParamExists('adminUpdateSchoolDistrict', 'districtId', districtId)
            // verify required parameter 'updateSchoolDistrictSchema' is not null or undefined
            assertParamExists('adminUpdateSchoolDistrict', 'updateSchoolDistrictSchema', updateSchoolDistrictSchema)
            const localVarPath = `/admin/district/school/{district_id}`
                .replace(`{${"district_id"}}`, encodeURIComponent(String(districtId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSchoolDistrictSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin Update Water District
         * @param {string} districtId 
         * @param {UpdateWaterDistrictSchema} updateWaterDistrictSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateWaterDistrict: async (districtId: string, updateWaterDistrictSchema: UpdateWaterDistrictSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'districtId' is not null or undefined
            assertParamExists('adminUpdateWaterDistrict', 'districtId', districtId)
            // verify required parameter 'updateWaterDistrictSchema' is not null or undefined
            assertParamExists('adminUpdateWaterDistrict', 'updateWaterDistrictSchema', updateWaterDistrictSchema)
            const localVarPath = `/admin/district/water/{district_id}`
                .replace(`{${"district_id"}}`, encodeURIComponent(String(districtId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateWaterDistrictSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminDistrictsApi - functional programming interface
 * @export
 */
export const AdminDistrictsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminDistrictsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Admin Create Electric District
         * @param {CreateElectricDistrictSchema} createElectricDistrictSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCreateElectricDistrict(createElectricDistrictSchema: CreateElectricDistrictSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ElectricDistrictSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCreateElectricDistrict(createElectricDistrictSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminDistrictsApi.adminCreateElectricDistrict']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin Create Fire District
         * @param {CreateFireDistrictSchema} createFireDistrictSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCreateFireDistrict(createFireDistrictSchema: CreateFireDistrictSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FireDistrictSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCreateFireDistrict(createFireDistrictSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminDistrictsApi.adminCreateFireDistrict']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin Create Sanitation District
         * @param {CreateSanitationDistrictSchema} createSanitationDistrictSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCreateSanitationDistrict(createSanitationDistrictSchema: CreateSanitationDistrictSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SanitationDistrictSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCreateSanitationDistrict(createSanitationDistrictSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminDistrictsApi.adminCreateSanitationDistrict']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin Create School District
         * @param {CreateSchoolDistrictSchema} createSchoolDistrictSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCreateSchoolDistrict(createSchoolDistrictSchema: CreateSchoolDistrictSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SchoolDistrictSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCreateSchoolDistrict(createSchoolDistrictSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminDistrictsApi.adminCreateSchoolDistrict']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin Create Water District
         * @param {CreateWaterDistrictSchema} createWaterDistrictSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCreateWaterDistrict(createWaterDistrictSchema: CreateWaterDistrictSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterDistrictSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCreateWaterDistrict(createWaterDistrictSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminDistrictsApi.adminCreateWaterDistrict']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin Delete Electric District
         * @param {string} districtId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDeleteElectricDistrict(districtId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDeleteElectricDistrict(districtId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminDistrictsApi.adminDeleteElectricDistrict']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin Delete Fire District
         * @param {string} districtId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDeleteFireDistrict(districtId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDeleteFireDistrict(districtId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminDistrictsApi.adminDeleteFireDistrict']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin Delete Sanitation District
         * @param {string} districtId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDeleteSanitationDistrict(districtId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDeleteSanitationDistrict(districtId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminDistrictsApi.adminDeleteSanitationDistrict']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin Delete School District
         * @param {string} districtId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDeleteSchoolDistrict(districtId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDeleteSchoolDistrict(districtId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminDistrictsApi.adminDeleteSchoolDistrict']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin Delete Water District
         * @param {string} districtId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDeleteWaterDistrict(districtId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDeleteWaterDistrict(districtId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminDistrictsApi.adminDeleteWaterDistrict']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin Get Electric District
         * @param {string} districtId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetElectricDistrict(districtId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ElectricDistrictWithAHJs>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetElectricDistrict(districtId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminDistrictsApi.adminGetElectricDistrict']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin Get Electric Districts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetElectricDistricts(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ElectricDistrictSchema>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetElectricDistricts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminDistrictsApi.adminGetElectricDistricts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin Get Fire District
         * @param {string} districtId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetFireDistrict(districtId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FireDistrictWithAHJs>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetFireDistrict(districtId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminDistrictsApi.adminGetFireDistrict']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin Get Fire Districts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetFireDistricts(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FireDistrictSchema>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetFireDistricts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminDistrictsApi.adminGetFireDistricts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin Get Sanitation District
         * @param {string} districtId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetSanitationDistrict(districtId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SanitationDistrictWithAHJs>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetSanitationDistrict(districtId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminDistrictsApi.adminGetSanitationDistrict']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin Get Sanitation Districts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetSanitationDistricts(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SanitationDistrictSchema>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetSanitationDistricts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminDistrictsApi.adminGetSanitationDistricts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin Get School District
         * @param {string} districtId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetSchoolDistrict(districtId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SchoolDistrictWithAHJs>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetSchoolDistrict(districtId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminDistrictsApi.adminGetSchoolDistrict']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin Get School Districts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetSchoolDistricts(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SchoolDistrictSchema>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetSchoolDistricts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminDistrictsApi.adminGetSchoolDistricts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin Get Water District
         * @param {string} districtId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetWaterDistrict(districtId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterDistrictWithAHJs>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetWaterDistrict(districtId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminDistrictsApi.adminGetWaterDistrict']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin Get Water Districts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetWaterDistricts(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WaterDistrictSchema>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetWaterDistricts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminDistrictsApi.adminGetWaterDistricts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin Update Electric District
         * @param {string} districtId 
         * @param {UpdateElectricDistrictSchema} updateElectricDistrictSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUpdateElectricDistrict(districtId: string, updateElectricDistrictSchema: UpdateElectricDistrictSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ElectricDistrictSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUpdateElectricDistrict(districtId, updateElectricDistrictSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminDistrictsApi.adminUpdateElectricDistrict']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin Update Fire District
         * @param {string} districtId 
         * @param {UpdateFireDistrictSchema} updateFireDistrictSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUpdateFireDistrict(districtId: string, updateFireDistrictSchema: UpdateFireDistrictSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FireDistrictSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUpdateFireDistrict(districtId, updateFireDistrictSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminDistrictsApi.adminUpdateFireDistrict']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin Update Sanitation District
         * @param {string} districtId 
         * @param {UpdateSanitationDistrictSchema} updateSanitationDistrictSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUpdateSanitationDistrict(districtId: string, updateSanitationDistrictSchema: UpdateSanitationDistrictSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SanitationDistrictSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUpdateSanitationDistrict(districtId, updateSanitationDistrictSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminDistrictsApi.adminUpdateSanitationDistrict']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin Update School District
         * @param {string} districtId 
         * @param {UpdateSchoolDistrictSchema} updateSchoolDistrictSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUpdateSchoolDistrict(districtId: string, updateSchoolDistrictSchema: UpdateSchoolDistrictSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SchoolDistrictSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUpdateSchoolDistrict(districtId, updateSchoolDistrictSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminDistrictsApi.adminUpdateSchoolDistrict']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin Update Water District
         * @param {string} districtId 
         * @param {UpdateWaterDistrictSchema} updateWaterDistrictSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUpdateWaterDistrict(districtId: string, updateWaterDistrictSchema: UpdateWaterDistrictSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WaterDistrictSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUpdateWaterDistrict(districtId, updateWaterDistrictSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminDistrictsApi.adminUpdateWaterDistrict']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminDistrictsApi - factory interface
 * @export
 */
export const AdminDistrictsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminDistrictsApiFp(configuration)
    return {
        /**
         * 
         * @summary Admin Create Electric District
         * @param {CreateElectricDistrictSchema} createElectricDistrictSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateElectricDistrict(createElectricDistrictSchema: CreateElectricDistrictSchema, options?: RawAxiosRequestConfig): AxiosPromise<ElectricDistrictSchema> {
            return localVarFp.adminCreateElectricDistrict(createElectricDistrictSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin Create Fire District
         * @param {CreateFireDistrictSchema} createFireDistrictSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateFireDistrict(createFireDistrictSchema: CreateFireDistrictSchema, options?: RawAxiosRequestConfig): AxiosPromise<FireDistrictSchema> {
            return localVarFp.adminCreateFireDistrict(createFireDistrictSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin Create Sanitation District
         * @param {CreateSanitationDistrictSchema} createSanitationDistrictSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateSanitationDistrict(createSanitationDistrictSchema: CreateSanitationDistrictSchema, options?: RawAxiosRequestConfig): AxiosPromise<SanitationDistrictSchema> {
            return localVarFp.adminCreateSanitationDistrict(createSanitationDistrictSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin Create School District
         * @param {CreateSchoolDistrictSchema} createSchoolDistrictSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateSchoolDistrict(createSchoolDistrictSchema: CreateSchoolDistrictSchema, options?: RawAxiosRequestConfig): AxiosPromise<SchoolDistrictSchema> {
            return localVarFp.adminCreateSchoolDistrict(createSchoolDistrictSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin Create Water District
         * @param {CreateWaterDistrictSchema} createWaterDistrictSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateWaterDistrict(createWaterDistrictSchema: CreateWaterDistrictSchema, options?: RawAxiosRequestConfig): AxiosPromise<WaterDistrictSchema> {
            return localVarFp.adminCreateWaterDistrict(createWaterDistrictSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin Delete Electric District
         * @param {string} districtId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteElectricDistrict(districtId: string, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.adminDeleteElectricDistrict(districtId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin Delete Fire District
         * @param {string} districtId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteFireDistrict(districtId: string, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.adminDeleteFireDistrict(districtId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin Delete Sanitation District
         * @param {string} districtId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteSanitationDistrict(districtId: string, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.adminDeleteSanitationDistrict(districtId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin Delete School District
         * @param {string} districtId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteSchoolDistrict(districtId: string, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.adminDeleteSchoolDistrict(districtId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin Delete Water District
         * @param {string} districtId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteWaterDistrict(districtId: string, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.adminDeleteWaterDistrict(districtId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin Get Electric District
         * @param {string} districtId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetElectricDistrict(districtId: string, options?: RawAxiosRequestConfig): AxiosPromise<ElectricDistrictWithAHJs> {
            return localVarFp.adminGetElectricDistrict(districtId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin Get Electric Districts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetElectricDistricts(options?: RawAxiosRequestConfig): AxiosPromise<Array<ElectricDistrictSchema>> {
            return localVarFp.adminGetElectricDistricts(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin Get Fire District
         * @param {string} districtId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetFireDistrict(districtId: string, options?: RawAxiosRequestConfig): AxiosPromise<FireDistrictWithAHJs> {
            return localVarFp.adminGetFireDistrict(districtId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin Get Fire Districts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetFireDistricts(options?: RawAxiosRequestConfig): AxiosPromise<Array<FireDistrictSchema>> {
            return localVarFp.adminGetFireDistricts(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin Get Sanitation District
         * @param {string} districtId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetSanitationDistrict(districtId: string, options?: RawAxiosRequestConfig): AxiosPromise<SanitationDistrictWithAHJs> {
            return localVarFp.adminGetSanitationDistrict(districtId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin Get Sanitation Districts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetSanitationDistricts(options?: RawAxiosRequestConfig): AxiosPromise<Array<SanitationDistrictSchema>> {
            return localVarFp.adminGetSanitationDistricts(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin Get School District
         * @param {string} districtId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetSchoolDistrict(districtId: string, options?: RawAxiosRequestConfig): AxiosPromise<SchoolDistrictWithAHJs> {
            return localVarFp.adminGetSchoolDistrict(districtId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin Get School Districts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetSchoolDistricts(options?: RawAxiosRequestConfig): AxiosPromise<Array<SchoolDistrictSchema>> {
            return localVarFp.adminGetSchoolDistricts(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin Get Water District
         * @param {string} districtId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetWaterDistrict(districtId: string, options?: RawAxiosRequestConfig): AxiosPromise<WaterDistrictWithAHJs> {
            return localVarFp.adminGetWaterDistrict(districtId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin Get Water Districts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetWaterDistricts(options?: RawAxiosRequestConfig): AxiosPromise<Array<WaterDistrictSchema>> {
            return localVarFp.adminGetWaterDistricts(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin Update Electric District
         * @param {string} districtId 
         * @param {UpdateElectricDistrictSchema} updateElectricDistrictSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateElectricDistrict(districtId: string, updateElectricDistrictSchema: UpdateElectricDistrictSchema, options?: RawAxiosRequestConfig): AxiosPromise<ElectricDistrictSchema> {
            return localVarFp.adminUpdateElectricDistrict(districtId, updateElectricDistrictSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin Update Fire District
         * @param {string} districtId 
         * @param {UpdateFireDistrictSchema} updateFireDistrictSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateFireDistrict(districtId: string, updateFireDistrictSchema: UpdateFireDistrictSchema, options?: RawAxiosRequestConfig): AxiosPromise<FireDistrictSchema> {
            return localVarFp.adminUpdateFireDistrict(districtId, updateFireDistrictSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin Update Sanitation District
         * @param {string} districtId 
         * @param {UpdateSanitationDistrictSchema} updateSanitationDistrictSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateSanitationDistrict(districtId: string, updateSanitationDistrictSchema: UpdateSanitationDistrictSchema, options?: RawAxiosRequestConfig): AxiosPromise<SanitationDistrictSchema> {
            return localVarFp.adminUpdateSanitationDistrict(districtId, updateSanitationDistrictSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin Update School District
         * @param {string} districtId 
         * @param {UpdateSchoolDistrictSchema} updateSchoolDistrictSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateSchoolDistrict(districtId: string, updateSchoolDistrictSchema: UpdateSchoolDistrictSchema, options?: RawAxiosRequestConfig): AxiosPromise<SchoolDistrictSchema> {
            return localVarFp.adminUpdateSchoolDistrict(districtId, updateSchoolDistrictSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin Update Water District
         * @param {string} districtId 
         * @param {UpdateWaterDistrictSchema} updateWaterDistrictSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateWaterDistrict(districtId: string, updateWaterDistrictSchema: UpdateWaterDistrictSchema, options?: RawAxiosRequestConfig): AxiosPromise<WaterDistrictSchema> {
            return localVarFp.adminUpdateWaterDistrict(districtId, updateWaterDistrictSchema, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminDistrictsApi - object-oriented interface
 * @export
 * @class AdminDistrictsApi
 * @extends {BaseAPI}
 */
export class AdminDistrictsApi extends BaseAPI {
    /**
     * 
     * @summary Admin Create Electric District
     * @param {CreateElectricDistrictSchema} createElectricDistrictSchema 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDistrictsApi
     */
    public adminCreateElectricDistrict(createElectricDistrictSchema: CreateElectricDistrictSchema, options?: RawAxiosRequestConfig) {
        return AdminDistrictsApiFp(this.configuration).adminCreateElectricDistrict(createElectricDistrictSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin Create Fire District
     * @param {CreateFireDistrictSchema} createFireDistrictSchema 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDistrictsApi
     */
    public adminCreateFireDistrict(createFireDistrictSchema: CreateFireDistrictSchema, options?: RawAxiosRequestConfig) {
        return AdminDistrictsApiFp(this.configuration).adminCreateFireDistrict(createFireDistrictSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin Create Sanitation District
     * @param {CreateSanitationDistrictSchema} createSanitationDistrictSchema 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDistrictsApi
     */
    public adminCreateSanitationDistrict(createSanitationDistrictSchema: CreateSanitationDistrictSchema, options?: RawAxiosRequestConfig) {
        return AdminDistrictsApiFp(this.configuration).adminCreateSanitationDistrict(createSanitationDistrictSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin Create School District
     * @param {CreateSchoolDistrictSchema} createSchoolDistrictSchema 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDistrictsApi
     */
    public adminCreateSchoolDistrict(createSchoolDistrictSchema: CreateSchoolDistrictSchema, options?: RawAxiosRequestConfig) {
        return AdminDistrictsApiFp(this.configuration).adminCreateSchoolDistrict(createSchoolDistrictSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin Create Water District
     * @param {CreateWaterDistrictSchema} createWaterDistrictSchema 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDistrictsApi
     */
    public adminCreateWaterDistrict(createWaterDistrictSchema: CreateWaterDistrictSchema, options?: RawAxiosRequestConfig) {
        return AdminDistrictsApiFp(this.configuration).adminCreateWaterDistrict(createWaterDistrictSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin Delete Electric District
     * @param {string} districtId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDistrictsApi
     */
    public adminDeleteElectricDistrict(districtId: string, options?: RawAxiosRequestConfig) {
        return AdminDistrictsApiFp(this.configuration).adminDeleteElectricDistrict(districtId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin Delete Fire District
     * @param {string} districtId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDistrictsApi
     */
    public adminDeleteFireDistrict(districtId: string, options?: RawAxiosRequestConfig) {
        return AdminDistrictsApiFp(this.configuration).adminDeleteFireDistrict(districtId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin Delete Sanitation District
     * @param {string} districtId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDistrictsApi
     */
    public adminDeleteSanitationDistrict(districtId: string, options?: RawAxiosRequestConfig) {
        return AdminDistrictsApiFp(this.configuration).adminDeleteSanitationDistrict(districtId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin Delete School District
     * @param {string} districtId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDistrictsApi
     */
    public adminDeleteSchoolDistrict(districtId: string, options?: RawAxiosRequestConfig) {
        return AdminDistrictsApiFp(this.configuration).adminDeleteSchoolDistrict(districtId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin Delete Water District
     * @param {string} districtId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDistrictsApi
     */
    public adminDeleteWaterDistrict(districtId: string, options?: RawAxiosRequestConfig) {
        return AdminDistrictsApiFp(this.configuration).adminDeleteWaterDistrict(districtId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin Get Electric District
     * @param {string} districtId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDistrictsApi
     */
    public adminGetElectricDistrict(districtId: string, options?: RawAxiosRequestConfig) {
        return AdminDistrictsApiFp(this.configuration).adminGetElectricDistrict(districtId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin Get Electric Districts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDistrictsApi
     */
    public adminGetElectricDistricts(options?: RawAxiosRequestConfig) {
        return AdminDistrictsApiFp(this.configuration).adminGetElectricDistricts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin Get Fire District
     * @param {string} districtId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDistrictsApi
     */
    public adminGetFireDistrict(districtId: string, options?: RawAxiosRequestConfig) {
        return AdminDistrictsApiFp(this.configuration).adminGetFireDistrict(districtId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin Get Fire Districts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDistrictsApi
     */
    public adminGetFireDistricts(options?: RawAxiosRequestConfig) {
        return AdminDistrictsApiFp(this.configuration).adminGetFireDistricts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin Get Sanitation District
     * @param {string} districtId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDistrictsApi
     */
    public adminGetSanitationDistrict(districtId: string, options?: RawAxiosRequestConfig) {
        return AdminDistrictsApiFp(this.configuration).adminGetSanitationDistrict(districtId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin Get Sanitation Districts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDistrictsApi
     */
    public adminGetSanitationDistricts(options?: RawAxiosRequestConfig) {
        return AdminDistrictsApiFp(this.configuration).adminGetSanitationDistricts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin Get School District
     * @param {string} districtId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDistrictsApi
     */
    public adminGetSchoolDistrict(districtId: string, options?: RawAxiosRequestConfig) {
        return AdminDistrictsApiFp(this.configuration).adminGetSchoolDistrict(districtId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin Get School Districts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDistrictsApi
     */
    public adminGetSchoolDistricts(options?: RawAxiosRequestConfig) {
        return AdminDistrictsApiFp(this.configuration).adminGetSchoolDistricts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin Get Water District
     * @param {string} districtId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDistrictsApi
     */
    public adminGetWaterDistrict(districtId: string, options?: RawAxiosRequestConfig) {
        return AdminDistrictsApiFp(this.configuration).adminGetWaterDistrict(districtId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin Get Water Districts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDistrictsApi
     */
    public adminGetWaterDistricts(options?: RawAxiosRequestConfig) {
        return AdminDistrictsApiFp(this.configuration).adminGetWaterDistricts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin Update Electric District
     * @param {string} districtId 
     * @param {UpdateElectricDistrictSchema} updateElectricDistrictSchema 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDistrictsApi
     */
    public adminUpdateElectricDistrict(districtId: string, updateElectricDistrictSchema: UpdateElectricDistrictSchema, options?: RawAxiosRequestConfig) {
        return AdminDistrictsApiFp(this.configuration).adminUpdateElectricDistrict(districtId, updateElectricDistrictSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin Update Fire District
     * @param {string} districtId 
     * @param {UpdateFireDistrictSchema} updateFireDistrictSchema 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDistrictsApi
     */
    public adminUpdateFireDistrict(districtId: string, updateFireDistrictSchema: UpdateFireDistrictSchema, options?: RawAxiosRequestConfig) {
        return AdminDistrictsApiFp(this.configuration).adminUpdateFireDistrict(districtId, updateFireDistrictSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin Update Sanitation District
     * @param {string} districtId 
     * @param {UpdateSanitationDistrictSchema} updateSanitationDistrictSchema 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDistrictsApi
     */
    public adminUpdateSanitationDistrict(districtId: string, updateSanitationDistrictSchema: UpdateSanitationDistrictSchema, options?: RawAxiosRequestConfig) {
        return AdminDistrictsApiFp(this.configuration).adminUpdateSanitationDistrict(districtId, updateSanitationDistrictSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin Update School District
     * @param {string} districtId 
     * @param {UpdateSchoolDistrictSchema} updateSchoolDistrictSchema 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDistrictsApi
     */
    public adminUpdateSchoolDistrict(districtId: string, updateSchoolDistrictSchema: UpdateSchoolDistrictSchema, options?: RawAxiosRequestConfig) {
        return AdminDistrictsApiFp(this.configuration).adminUpdateSchoolDistrict(districtId, updateSchoolDistrictSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin Update Water District
     * @param {string} districtId 
     * @param {UpdateWaterDistrictSchema} updateWaterDistrictSchema 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDistrictsApi
     */
    public adminUpdateWaterDistrict(districtId: string, updateWaterDistrictSchema: UpdateWaterDistrictSchema, options?: RawAxiosRequestConfig) {
        return AdminDistrictsApiFp(this.configuration).adminUpdateWaterDistrict(districtId, updateWaterDistrictSchema, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminEstimateApi - axios parameter creator
 * @export
 */
export const AdminEstimateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Admin Add Discount
         * @param {string} projectId 
         * @param {string} estimateId 
         * @param {string} budgetSegmentId 
         * @param {AddDiscountSchema} addDiscountSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAddDiscount: async (projectId: string, estimateId: string, budgetSegmentId: string, addDiscountSchema: AddDiscountSchema, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('adminAddDiscount', 'projectId', projectId)
            // verify required parameter 'estimateId' is not null or undefined
            assertParamExists('adminAddDiscount', 'estimateId', estimateId)
            // verify required parameter 'budgetSegmentId' is not null or undefined
            assertParamExists('adminAddDiscount', 'budgetSegmentId', budgetSegmentId)
            // verify required parameter 'addDiscountSchema' is not null or undefined
            assertParamExists('adminAddDiscount', 'addDiscountSchema', addDiscountSchema)
            const localVarPath = `/admin/firestore-project/{project_id}/estimate/{estimate_id}/budget-segment/{budget_segment_id}/discount`
                .replace(`{${"project_id"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"estimate_id"}}`, encodeURIComponent(String(estimateId)))
                .replace(`{${"budget_segment_id"}}`, encodeURIComponent(String(budgetSegmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addDiscountSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin Create Estimate
         * @param {string} projectId 
         * @param {CreateEstimateSchema} createEstimateSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateEstimate: async (projectId: string, createEstimateSchema: CreateEstimateSchema, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('adminCreateEstimate', 'projectId', projectId)
            // verify required parameter 'createEstimateSchema' is not null or undefined
            assertParamExists('adminCreateEstimate', 'createEstimateSchema', createEstimateSchema)
            const localVarPath = `/admin/firestore-project/{project_id}/estimate`
                .replace(`{${"project_id"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEstimateSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a discount from a budget segment.
         * @summary Admin Delete Discount
         * @param {string} projectId 
         * @param {string} estimateId 
         * @param {string} budgetSegmentId 
         * @param {string} discountId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteDiscount: async (projectId: string, estimateId: string, budgetSegmentId: string, discountId: string, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('adminDeleteDiscount', 'projectId', projectId)
            // verify required parameter 'estimateId' is not null or undefined
            assertParamExists('adminDeleteDiscount', 'estimateId', estimateId)
            // verify required parameter 'budgetSegmentId' is not null or undefined
            assertParamExists('adminDeleteDiscount', 'budgetSegmentId', budgetSegmentId)
            // verify required parameter 'discountId' is not null or undefined
            assertParamExists('adminDeleteDiscount', 'discountId', discountId)
            const localVarPath = `/admin/firestore-project/{project_id}/estimate/{estimate_id}/budget-segment/{budget_segment_id}/discount/{discount_id}`
                .replace(`{${"project_id"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"estimate_id"}}`, encodeURIComponent(String(estimateId)))
                .replace(`{${"budget_segment_id"}}`, encodeURIComponent(String(budgetSegmentId)))
                .replace(`{${"discount_id"}}`, encodeURIComponent(String(discountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin Delete Estimate
         * @param {string} projectId 
         * @param {string} estimateId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteEstimate: async (projectId: string, estimateId: string, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('adminDeleteEstimate', 'projectId', projectId)
            // verify required parameter 'estimateId' is not null or undefined
            assertParamExists('adminDeleteEstimate', 'estimateId', estimateId)
            const localVarPath = `/admin/firestore-project/{project_id}/estimate/{estimate_id}`
                .replace(`{${"project_id"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"estimate_id"}}`, encodeURIComponent(String(estimateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a line item (including discounts) from a budget segment.
         * @summary Admin Delete Line Item
         * @param {string} projectId 
         * @param {string} estimateId 
         * @param {string} budgetSegmentId 
         * @param {string} lineItemId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteLineItem: async (projectId: string, estimateId: string, budgetSegmentId: string, lineItemId: string, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('adminDeleteLineItem', 'projectId', projectId)
            // verify required parameter 'estimateId' is not null or undefined
            assertParamExists('adminDeleteLineItem', 'estimateId', estimateId)
            // verify required parameter 'budgetSegmentId' is not null or undefined
            assertParamExists('adminDeleteLineItem', 'budgetSegmentId', budgetSegmentId)
            // verify required parameter 'lineItemId' is not null or undefined
            assertParamExists('adminDeleteLineItem', 'lineItemId', lineItemId)
            const localVarPath = `/admin/firestore-project/{project_id}/estimate/{estimate_id}/budget-segment/{budget_segment_id}/line-item/{line_item_id}`
                .replace(`{${"project_id"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"estimate_id"}}`, encodeURIComponent(String(estimateId)))
                .replace(`{${"budget_segment_id"}}`, encodeURIComponent(String(budgetSegmentId)))
                .replace(`{${"line_item_id"}}`, encodeURIComponent(String(lineItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin Get Estimate Budget Segment Summary
         * @param {string} estimateId 
         * @param {string} projectId 
         * @param {boolean} [oAndPOnly] 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetEstimateBudgetSegmentSummary: async (estimateId: string, projectId: string, oAndPOnly?: boolean, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'estimateId' is not null or undefined
            assertParamExists('adminGetEstimateBudgetSegmentSummary', 'estimateId', estimateId)
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('adminGetEstimateBudgetSegmentSummary', 'projectId', projectId)
            const localVarPath = `/admin/firestore-project/{project_id}/estimate/{estimate_id}/budget-segment-summary`
                .replace(`{${"estimate_id"}}`, encodeURIComponent(String(estimateId)))
                .replace(`{${"project_id"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)

            if (oAndPOnly !== undefined) {
                localVarQueryParameter['o_and_p_only'] = oAndPOnly;
            }


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin Get Estimate By Id
         * @param {string} projectId 
         * @param {string} estimateId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetEstimateById: async (projectId: string, estimateId: string, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('adminGetEstimateById', 'projectId', projectId)
            // verify required parameter 'estimateId' is not null or undefined
            assertParamExists('adminGetEstimateById', 'estimateId', estimateId)
            const localVarPath = `/admin/firestore-project/{project_id}/estimate/{estimate_id}`
                .replace(`{${"project_id"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"estimate_id"}}`, encodeURIComponent(String(estimateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin Get Estimate Ids For Project
         * @param {string} projectId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetEstimateIdsForProject: async (projectId: string, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('adminGetEstimateIdsForProject', 'projectId', projectId)
            const localVarPath = `/admin/firestore-project/{project_id}/estimate/ids`
                .replace(`{${"project_id"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get cost code budget items for an estimate in Procore format.  This endpoint retrieves the estimate and its budget segments, and returns a list of budget items with the required fields in Procore format. It includes all line items and discounts from the estimate.  Args:     project_id: The ID of the project     estimate_id: The ID of the estimate  Returns:     A response containing budget items with division, villa budget section, cost code, etc.
         * @summary Admin Get Estimate Procore Budget
         * @param {string} projectId 
         * @param {string} estimateId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetEstimateProcoreBudget: async (projectId: string, estimateId: string, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('adminGetEstimateProcoreBudget', 'projectId', projectId)
            // verify required parameter 'estimateId' is not null or undefined
            assertParamExists('adminGetEstimateProcoreBudget', 'estimateId', estimateId)
            const localVarPath = `/admin/firestore-project/{project_id}/estimate/{estimate_id}/procore-budget`
                .replace(`{${"project_id"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"estimate_id"}}`, encodeURIComponent(String(estimateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin Get Phase Fees
         * @param {string} projectId 
         * @param {string} estimateId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetPhaseFees: async (projectId: string, estimateId: string, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('adminGetPhaseFees', 'projectId', projectId)
            // verify required parameter 'estimateId' is not null or undefined
            assertParamExists('adminGetPhaseFees', 'estimateId', estimateId)
            const localVarPath = `/admin/firestore-project/{project_id}/estimate/{estimate_id}/phase-fees`
                .replace(`{${"project_id"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"estimate_id"}}`, encodeURIComponent(String(estimateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin Get Recent Estimates
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetRecentEstimates: async (requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/estimates/recent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin Get Sales Tax
         * @param {string} projectId 
         * @param {string} estimateId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetSalesTax: async (projectId: string, estimateId: string, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('adminGetSalesTax', 'projectId', projectId)
            // verify required parameter 'estimateId' is not null or undefined
            assertParamExists('adminGetSalesTax', 'estimateId', estimateId)
            const localVarPath = `/admin/firestore-project/{project_id}/estimate/{estimate_id}/sales-tax-modifiers`
                .replace(`{${"project_id"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"estimate_id"}}`, encodeURIComponent(String(estimateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin Get Total Current Month Estimates
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetTotalCurrentMonthEstimates: async (requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/estimates/total-current-month`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin Update Estimate Mode
         * @param {string} projectId 
         * @param {string} estimateId 
         * @param {UpdateModeSchema} updateModeSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateEstimateMode: async (projectId: string, estimateId: string, updateModeSchema: UpdateModeSchema, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('adminUpdateEstimateMode', 'projectId', projectId)
            // verify required parameter 'estimateId' is not null or undefined
            assertParamExists('adminUpdateEstimateMode', 'estimateId', estimateId)
            // verify required parameter 'updateModeSchema' is not null or undefined
            assertParamExists('adminUpdateEstimateMode', 'updateModeSchema', updateModeSchema)
            const localVarPath = `/admin/firestore-project/{project_id}/estimate/{estimate_id}/mode`
                .replace(`{${"project_id"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"estimate_id"}}`, encodeURIComponent(String(estimateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateModeSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin Update Estimate Published Status
         * @param {string} projectId 
         * @param {string} estimateId 
         * @param {UpdatePublishedSchema} updatePublishedSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateEstimatePublishedStatus: async (projectId: string, estimateId: string, updatePublishedSchema: UpdatePublishedSchema, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('adminUpdateEstimatePublishedStatus', 'projectId', projectId)
            // verify required parameter 'estimateId' is not null or undefined
            assertParamExists('adminUpdateEstimatePublishedStatus', 'estimateId', estimateId)
            // verify required parameter 'updatePublishedSchema' is not null or undefined
            assertParamExists('adminUpdateEstimatePublishedStatus', 'updatePublishedSchema', updatePublishedSchema)
            const localVarPath = `/admin/firestore-project/{project_id}/estimate/{estimate_id}/published`
                .replace(`{${"project_id"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"estimate_id"}}`, encodeURIComponent(String(estimateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePublishedSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin Update O And P
         * @param {string} projectId 
         * @param {string} estimateId 
         * @param {string} budgetSegmentId 
         * @param {UpdateOandPSchema} updateOandPSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateOAndP: async (projectId: string, estimateId: string, budgetSegmentId: string, updateOandPSchema: UpdateOandPSchema, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('adminUpdateOAndP', 'projectId', projectId)
            // verify required parameter 'estimateId' is not null or undefined
            assertParamExists('adminUpdateOAndP', 'estimateId', estimateId)
            // verify required parameter 'budgetSegmentId' is not null or undefined
            assertParamExists('adminUpdateOAndP', 'budgetSegmentId', budgetSegmentId)
            // verify required parameter 'updateOandPSchema' is not null or undefined
            assertParamExists('adminUpdateOAndP', 'updateOandPSchema', updateOandPSchema)
            const localVarPath = `/admin/firestore-project/{project_id}/estimate/{estimate_id}/budget-segment/{budget_segment_id}/o-and-p`
                .replace(`{${"project_id"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"estimate_id"}}`, encodeURIComponent(String(estimateId)))
                .replace(`{${"budget_segment_id"}}`, encodeURIComponent(String(budgetSegmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOandPSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin Update Phase 1 Fee
         * @param {string} projectId 
         * @param {string} estimateId 
         * @param {UpdatePhaseFeesSchema} updatePhaseFeesSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdatePhase1Fee: async (projectId: string, estimateId: string, updatePhaseFeesSchema: UpdatePhaseFeesSchema, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('adminUpdatePhase1Fee', 'projectId', projectId)
            // verify required parameter 'estimateId' is not null or undefined
            assertParamExists('adminUpdatePhase1Fee', 'estimateId', estimateId)
            // verify required parameter 'updatePhaseFeesSchema' is not null or undefined
            assertParamExists('adminUpdatePhase1Fee', 'updatePhaseFeesSchema', updatePhaseFeesSchema)
            const localVarPath = `/admin/firestore-project/{project_id}/estimate/{estimate_id}/phase-fees`
                .replace(`{${"project_id"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"estimate_id"}}`, encodeURIComponent(String(estimateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePhaseFeesSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin Update Sales Tax
         * @param {string} projectId 
         * @param {string} estimateId 
         * @param {UpdateSalesTaxSchema} updateSalesTaxSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateSalesTax: async (projectId: string, estimateId: string, updateSalesTaxSchema: UpdateSalesTaxSchema, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('adminUpdateSalesTax', 'projectId', projectId)
            // verify required parameter 'estimateId' is not null or undefined
            assertParamExists('adminUpdateSalesTax', 'estimateId', estimateId)
            // verify required parameter 'updateSalesTaxSchema' is not null or undefined
            assertParamExists('adminUpdateSalesTax', 'updateSalesTaxSchema', updateSalesTaxSchema)
            const localVarPath = `/admin/firestore-project/{project_id}/estimate/{estimate_id}/sales-tax`
                .replace(`{${"project_id"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"estimate_id"}}`, encodeURIComponent(String(estimateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSalesTaxSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminEstimateApi - functional programming interface
 * @export
 */
export const AdminEstimateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminEstimateApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Admin Add Discount
         * @param {string} projectId 
         * @param {string} estimateId 
         * @param {string} budgetSegmentId 
         * @param {AddDiscountSchema} addDiscountSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminAddDiscount(projectId: string, estimateId: string, budgetSegmentId: string, addDiscountSchema: AddDiscountSchema, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminAddDiscount(projectId, estimateId, budgetSegmentId, addDiscountSchema, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEstimateApi.adminAddDiscount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin Create Estimate
         * @param {string} projectId 
         * @param {CreateEstimateSchema} createEstimateSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCreateEstimate(projectId: string, createEstimateSchema: CreateEstimateSchema, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCreateEstimate(projectId, createEstimateSchema, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEstimateApi.adminCreateEstimate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a discount from a budget segment.
         * @summary Admin Delete Discount
         * @param {string} projectId 
         * @param {string} estimateId 
         * @param {string} budgetSegmentId 
         * @param {string} discountId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDeleteDiscount(projectId: string, estimateId: string, budgetSegmentId: string, discountId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDeleteDiscount(projectId, estimateId, budgetSegmentId, discountId, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEstimateApi.adminDeleteDiscount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin Delete Estimate
         * @param {string} projectId 
         * @param {string} estimateId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDeleteEstimate(projectId: string, estimateId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDeleteEstimate(projectId, estimateId, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEstimateApi.adminDeleteEstimate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a line item (including discounts) from a budget segment.
         * @summary Admin Delete Line Item
         * @param {string} projectId 
         * @param {string} estimateId 
         * @param {string} budgetSegmentId 
         * @param {string} lineItemId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDeleteLineItem(projectId: string, estimateId: string, budgetSegmentId: string, lineItemId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDeleteLineItem(projectId, estimateId, budgetSegmentId, lineItemId, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEstimateApi.adminDeleteLineItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin Get Estimate Budget Segment Summary
         * @param {string} estimateId 
         * @param {string} projectId 
         * @param {boolean} [oAndPOnly] 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetEstimateBudgetSegmentSummary(estimateId: string, projectId: string, oAndPOnly?: boolean, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetEstimateBudgetSegmentSummary(estimateId, projectId, oAndPOnly, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEstimateApi.adminGetEstimateBudgetSegmentSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin Get Estimate By Id
         * @param {string} projectId 
         * @param {string} estimateId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetEstimateById(projectId: string, estimateId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetEstimateById(projectId, estimateId, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEstimateApi.adminGetEstimateById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin Get Estimate Ids For Project
         * @param {string} projectId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetEstimateIdsForProject(projectId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EstimateId>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetEstimateIdsForProject(projectId, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEstimateApi.adminGetEstimateIdsForProject']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get cost code budget items for an estimate in Procore format.  This endpoint retrieves the estimate and its budget segments, and returns a list of budget items with the required fields in Procore format. It includes all line items and discounts from the estimate.  Args:     project_id: The ID of the project     estimate_id: The ID of the estimate  Returns:     A response containing budget items with division, villa budget section, cost code, etc.
         * @summary Admin Get Estimate Procore Budget
         * @param {string} projectId 
         * @param {string} estimateId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetEstimateProcoreBudget(projectId: string, estimateId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcoreBudgetResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetEstimateProcoreBudget(projectId, estimateId, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEstimateApi.adminGetEstimateProcoreBudget']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin Get Phase Fees
         * @param {string} projectId 
         * @param {string} estimateId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetPhaseFees(projectId: string, estimateId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetPhaseFees(projectId, estimateId, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEstimateApi.adminGetPhaseFees']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin Get Recent Estimates
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetRecentEstimates(requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetRecentEstimates(requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEstimateApi.adminGetRecentEstimates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin Get Sales Tax
         * @param {string} projectId 
         * @param {string} estimateId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetSalesTax(projectId: string, estimateId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetSalesTax(projectId, estimateId, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEstimateApi.adminGetSalesTax']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin Get Total Current Month Estimates
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetTotalCurrentMonthEstimates(requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetTotalCurrentMonthEstimates(requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEstimateApi.adminGetTotalCurrentMonthEstimates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin Update Estimate Mode
         * @param {string} projectId 
         * @param {string} estimateId 
         * @param {UpdateModeSchema} updateModeSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUpdateEstimateMode(projectId: string, estimateId: string, updateModeSchema: UpdateModeSchema, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUpdateEstimateMode(projectId, estimateId, updateModeSchema, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEstimateApi.adminUpdateEstimateMode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin Update Estimate Published Status
         * @param {string} projectId 
         * @param {string} estimateId 
         * @param {UpdatePublishedSchema} updatePublishedSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUpdateEstimatePublishedStatus(projectId: string, estimateId: string, updatePublishedSchema: UpdatePublishedSchema, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUpdateEstimatePublishedStatus(projectId, estimateId, updatePublishedSchema, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEstimateApi.adminUpdateEstimatePublishedStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin Update O And P
         * @param {string} projectId 
         * @param {string} estimateId 
         * @param {string} budgetSegmentId 
         * @param {UpdateOandPSchema} updateOandPSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUpdateOAndP(projectId: string, estimateId: string, budgetSegmentId: string, updateOandPSchema: UpdateOandPSchema, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUpdateOAndP(projectId, estimateId, budgetSegmentId, updateOandPSchema, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEstimateApi.adminUpdateOAndP']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin Update Phase 1 Fee
         * @param {string} projectId 
         * @param {string} estimateId 
         * @param {UpdatePhaseFeesSchema} updatePhaseFeesSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUpdatePhase1Fee(projectId: string, estimateId: string, updatePhaseFeesSchema: UpdatePhaseFeesSchema, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUpdatePhase1Fee(projectId, estimateId, updatePhaseFeesSchema, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEstimateApi.adminUpdatePhase1Fee']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin Update Sales Tax
         * @param {string} projectId 
         * @param {string} estimateId 
         * @param {UpdateSalesTaxSchema} updateSalesTaxSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUpdateSalesTax(projectId: string, estimateId: string, updateSalesTaxSchema: UpdateSalesTaxSchema, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUpdateSalesTax(projectId, estimateId, updateSalesTaxSchema, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEstimateApi.adminUpdateSalesTax']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminEstimateApi - factory interface
 * @export
 */
export const AdminEstimateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminEstimateApiFp(configuration)
    return {
        /**
         * 
         * @summary Admin Add Discount
         * @param {string} projectId 
         * @param {string} estimateId 
         * @param {string} budgetSegmentId 
         * @param {AddDiscountSchema} addDiscountSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAddDiscount(projectId: string, estimateId: string, budgetSegmentId: string, addDiscountSchema: AddDiscountSchema, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.adminAddDiscount(projectId, estimateId, budgetSegmentId, addDiscountSchema, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin Create Estimate
         * @param {string} projectId 
         * @param {CreateEstimateSchema} createEstimateSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateEstimate(projectId: string, createEstimateSchema: CreateEstimateSchema, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.adminCreateEstimate(projectId, createEstimateSchema, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a discount from a budget segment.
         * @summary Admin Delete Discount
         * @param {string} projectId 
         * @param {string} estimateId 
         * @param {string} budgetSegmentId 
         * @param {string} discountId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteDiscount(projectId: string, estimateId: string, budgetSegmentId: string, discountId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.adminDeleteDiscount(projectId, estimateId, budgetSegmentId, discountId, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin Delete Estimate
         * @param {string} projectId 
         * @param {string} estimateId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteEstimate(projectId: string, estimateId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.adminDeleteEstimate(projectId, estimateId, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a line item (including discounts) from a budget segment.
         * @summary Admin Delete Line Item
         * @param {string} projectId 
         * @param {string} estimateId 
         * @param {string} budgetSegmentId 
         * @param {string} lineItemId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteLineItem(projectId: string, estimateId: string, budgetSegmentId: string, lineItemId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.adminDeleteLineItem(projectId, estimateId, budgetSegmentId, lineItemId, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin Get Estimate Budget Segment Summary
         * @param {string} estimateId 
         * @param {string} projectId 
         * @param {boolean} [oAndPOnly] 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetEstimateBudgetSegmentSummary(estimateId: string, projectId: string, oAndPOnly?: boolean, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.adminGetEstimateBudgetSegmentSummary(estimateId, projectId, oAndPOnly, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin Get Estimate By Id
         * @param {string} projectId 
         * @param {string} estimateId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetEstimateById(projectId: string, estimateId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.adminGetEstimateById(projectId, estimateId, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin Get Estimate Ids For Project
         * @param {string} projectId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetEstimateIdsForProject(projectId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<Array<EstimateId>> {
            return localVarFp.adminGetEstimateIdsForProject(projectId, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Get cost code budget items for an estimate in Procore format.  This endpoint retrieves the estimate and its budget segments, and returns a list of budget items with the required fields in Procore format. It includes all line items and discounts from the estimate.  Args:     project_id: The ID of the project     estimate_id: The ID of the estimate  Returns:     A response containing budget items with division, villa budget section, cost code, etc.
         * @summary Admin Get Estimate Procore Budget
         * @param {string} projectId 
         * @param {string} estimateId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetEstimateProcoreBudget(projectId: string, estimateId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<ProcoreBudgetResponse> {
            return localVarFp.adminGetEstimateProcoreBudget(projectId, estimateId, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin Get Phase Fees
         * @param {string} projectId 
         * @param {string} estimateId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetPhaseFees(projectId: string, estimateId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.adminGetPhaseFees(projectId, estimateId, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin Get Recent Estimates
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetRecentEstimates(requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.adminGetRecentEstimates(requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin Get Sales Tax
         * @param {string} projectId 
         * @param {string} estimateId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetSalesTax(projectId: string, estimateId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.adminGetSalesTax(projectId, estimateId, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin Get Total Current Month Estimates
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetTotalCurrentMonthEstimates(requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.adminGetTotalCurrentMonthEstimates(requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin Update Estimate Mode
         * @param {string} projectId 
         * @param {string} estimateId 
         * @param {UpdateModeSchema} updateModeSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateEstimateMode(projectId: string, estimateId: string, updateModeSchema: UpdateModeSchema, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.adminUpdateEstimateMode(projectId, estimateId, updateModeSchema, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin Update Estimate Published Status
         * @param {string} projectId 
         * @param {string} estimateId 
         * @param {UpdatePublishedSchema} updatePublishedSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateEstimatePublishedStatus(projectId: string, estimateId: string, updatePublishedSchema: UpdatePublishedSchema, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.adminUpdateEstimatePublishedStatus(projectId, estimateId, updatePublishedSchema, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin Update O And P
         * @param {string} projectId 
         * @param {string} estimateId 
         * @param {string} budgetSegmentId 
         * @param {UpdateOandPSchema} updateOandPSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateOAndP(projectId: string, estimateId: string, budgetSegmentId: string, updateOandPSchema: UpdateOandPSchema, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.adminUpdateOAndP(projectId, estimateId, budgetSegmentId, updateOandPSchema, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin Update Phase 1 Fee
         * @param {string} projectId 
         * @param {string} estimateId 
         * @param {UpdatePhaseFeesSchema} updatePhaseFeesSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdatePhase1Fee(projectId: string, estimateId: string, updatePhaseFeesSchema: UpdatePhaseFeesSchema, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.adminUpdatePhase1Fee(projectId, estimateId, updatePhaseFeesSchema, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin Update Sales Tax
         * @param {string} projectId 
         * @param {string} estimateId 
         * @param {UpdateSalesTaxSchema} updateSalesTaxSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateSalesTax(projectId: string, estimateId: string, updateSalesTaxSchema: UpdateSalesTaxSchema, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.adminUpdateSalesTax(projectId, estimateId, updateSalesTaxSchema, requestSource, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminEstimateApi - object-oriented interface
 * @export
 * @class AdminEstimateApi
 * @extends {BaseAPI}
 */
export class AdminEstimateApi extends BaseAPI {
    /**
     * 
     * @summary Admin Add Discount
     * @param {string} projectId 
     * @param {string} estimateId 
     * @param {string} budgetSegmentId 
     * @param {AddDiscountSchema} addDiscountSchema 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEstimateApi
     */
    public adminAddDiscount(projectId: string, estimateId: string, budgetSegmentId: string, addDiscountSchema: AddDiscountSchema, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminEstimateApiFp(this.configuration).adminAddDiscount(projectId, estimateId, budgetSegmentId, addDiscountSchema, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin Create Estimate
     * @param {string} projectId 
     * @param {CreateEstimateSchema} createEstimateSchema 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEstimateApi
     */
    public adminCreateEstimate(projectId: string, createEstimateSchema: CreateEstimateSchema, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminEstimateApiFp(this.configuration).adminCreateEstimate(projectId, createEstimateSchema, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a discount from a budget segment.
     * @summary Admin Delete Discount
     * @param {string} projectId 
     * @param {string} estimateId 
     * @param {string} budgetSegmentId 
     * @param {string} discountId 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEstimateApi
     */
    public adminDeleteDiscount(projectId: string, estimateId: string, budgetSegmentId: string, discountId: string, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminEstimateApiFp(this.configuration).adminDeleteDiscount(projectId, estimateId, budgetSegmentId, discountId, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin Delete Estimate
     * @param {string} projectId 
     * @param {string} estimateId 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEstimateApi
     */
    public adminDeleteEstimate(projectId: string, estimateId: string, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminEstimateApiFp(this.configuration).adminDeleteEstimate(projectId, estimateId, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a line item (including discounts) from a budget segment.
     * @summary Admin Delete Line Item
     * @param {string} projectId 
     * @param {string} estimateId 
     * @param {string} budgetSegmentId 
     * @param {string} lineItemId 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEstimateApi
     */
    public adminDeleteLineItem(projectId: string, estimateId: string, budgetSegmentId: string, lineItemId: string, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminEstimateApiFp(this.configuration).adminDeleteLineItem(projectId, estimateId, budgetSegmentId, lineItemId, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin Get Estimate Budget Segment Summary
     * @param {string} estimateId 
     * @param {string} projectId 
     * @param {boolean} [oAndPOnly] 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEstimateApi
     */
    public adminGetEstimateBudgetSegmentSummary(estimateId: string, projectId: string, oAndPOnly?: boolean, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminEstimateApiFp(this.configuration).adminGetEstimateBudgetSegmentSummary(estimateId, projectId, oAndPOnly, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin Get Estimate By Id
     * @param {string} projectId 
     * @param {string} estimateId 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEstimateApi
     */
    public adminGetEstimateById(projectId: string, estimateId: string, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminEstimateApiFp(this.configuration).adminGetEstimateById(projectId, estimateId, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin Get Estimate Ids For Project
     * @param {string} projectId 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEstimateApi
     */
    public adminGetEstimateIdsForProject(projectId: string, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminEstimateApiFp(this.configuration).adminGetEstimateIdsForProject(projectId, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get cost code budget items for an estimate in Procore format.  This endpoint retrieves the estimate and its budget segments, and returns a list of budget items with the required fields in Procore format. It includes all line items and discounts from the estimate.  Args:     project_id: The ID of the project     estimate_id: The ID of the estimate  Returns:     A response containing budget items with division, villa budget section, cost code, etc.
     * @summary Admin Get Estimate Procore Budget
     * @param {string} projectId 
     * @param {string} estimateId 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEstimateApi
     */
    public adminGetEstimateProcoreBudget(projectId: string, estimateId: string, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminEstimateApiFp(this.configuration).adminGetEstimateProcoreBudget(projectId, estimateId, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin Get Phase Fees
     * @param {string} projectId 
     * @param {string} estimateId 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEstimateApi
     */
    public adminGetPhaseFees(projectId: string, estimateId: string, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminEstimateApiFp(this.configuration).adminGetPhaseFees(projectId, estimateId, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin Get Recent Estimates
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEstimateApi
     */
    public adminGetRecentEstimates(requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminEstimateApiFp(this.configuration).adminGetRecentEstimates(requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin Get Sales Tax
     * @param {string} projectId 
     * @param {string} estimateId 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEstimateApi
     */
    public adminGetSalesTax(projectId: string, estimateId: string, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminEstimateApiFp(this.configuration).adminGetSalesTax(projectId, estimateId, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin Get Total Current Month Estimates
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEstimateApi
     */
    public adminGetTotalCurrentMonthEstimates(requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminEstimateApiFp(this.configuration).adminGetTotalCurrentMonthEstimates(requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin Update Estimate Mode
     * @param {string} projectId 
     * @param {string} estimateId 
     * @param {UpdateModeSchema} updateModeSchema 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEstimateApi
     */
    public adminUpdateEstimateMode(projectId: string, estimateId: string, updateModeSchema: UpdateModeSchema, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminEstimateApiFp(this.configuration).adminUpdateEstimateMode(projectId, estimateId, updateModeSchema, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin Update Estimate Published Status
     * @param {string} projectId 
     * @param {string} estimateId 
     * @param {UpdatePublishedSchema} updatePublishedSchema 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEstimateApi
     */
    public adminUpdateEstimatePublishedStatus(projectId: string, estimateId: string, updatePublishedSchema: UpdatePublishedSchema, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminEstimateApiFp(this.configuration).adminUpdateEstimatePublishedStatus(projectId, estimateId, updatePublishedSchema, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin Update O And P
     * @param {string} projectId 
     * @param {string} estimateId 
     * @param {string} budgetSegmentId 
     * @param {UpdateOandPSchema} updateOandPSchema 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEstimateApi
     */
    public adminUpdateOAndP(projectId: string, estimateId: string, budgetSegmentId: string, updateOandPSchema: UpdateOandPSchema, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminEstimateApiFp(this.configuration).adminUpdateOAndP(projectId, estimateId, budgetSegmentId, updateOandPSchema, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin Update Phase 1 Fee
     * @param {string} projectId 
     * @param {string} estimateId 
     * @param {UpdatePhaseFeesSchema} updatePhaseFeesSchema 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEstimateApi
     */
    public adminUpdatePhase1Fee(projectId: string, estimateId: string, updatePhaseFeesSchema: UpdatePhaseFeesSchema, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminEstimateApiFp(this.configuration).adminUpdatePhase1Fee(projectId, estimateId, updatePhaseFeesSchema, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin Update Sales Tax
     * @param {string} projectId 
     * @param {string} estimateId 
     * @param {UpdateSalesTaxSchema} updateSalesTaxSchema 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEstimateApi
     */
    public adminUpdateSalesTax(projectId: string, estimateId: string, updateSalesTaxSchema: UpdateSalesTaxSchema, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminEstimateApiFp(this.configuration).adminUpdateSalesTax(projectId, estimateId, updateSalesTaxSchema, requestSource, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminFeasibilityApi - axios parameter creator
 * @export
 */
export const AdminFeasibilityApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a new feasible zipcode with optional marketing region.
         * @summary Add Feasible Zipcode
         * @param {FeasibleZipcodeCreate} feasibleZipcodeCreate 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFeasibleZipcode: async (feasibleZipcodeCreate: FeasibleZipcodeCreate, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'feasibleZipcodeCreate' is not null or undefined
            assertParamExists('addFeasibleZipcode', 'feasibleZipcodeCreate', feasibleZipcodeCreate)
            const localVarPath = `/admin/zip`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(feasibleZipcodeCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a single feasible zipcode.
         * @summary Delete Feasible Zipcode
         * @param {string} zipcode 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFeasibleZipcode: async (zipcode: string, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'zipcode' is not null or undefined
            assertParamExists('deleteFeasibleZipcode', 'zipcode', zipcode)
            const localVarPath = `/admin/zip/{zipcode}`
                .replace(`{${"zipcode"}}`, encodeURIComponent(String(zipcode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete multiple feasible zipcodes at once.
         * @summary Delete Feasible Zipcodes
         * @param {Array<string | null>} requestBody 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFeasibleZipcodes: async (requestBody: Array<string | null>, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('deleteFeasibleZipcodes', 'requestBody', requestBody)
            const localVarPath = `/admin/zips`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all feasible zipcodes with their marketing regions.
         * @summary Get Feasible Zips
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeasibleZips: async (requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/zips`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a feasible zipcode\'s properties including marketing region.
         * @summary Update Feasible Zipcode
         * @param {string} zipcode 
         * @param {FeasibleZipcodeUpdate} feasibleZipcodeUpdate 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFeasibleZipcode: async (zipcode: string, feasibleZipcodeUpdate: FeasibleZipcodeUpdate, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'zipcode' is not null or undefined
            assertParamExists('updateFeasibleZipcode', 'zipcode', zipcode)
            // verify required parameter 'feasibleZipcodeUpdate' is not null or undefined
            assertParamExists('updateFeasibleZipcode', 'feasibleZipcodeUpdate', feasibleZipcodeUpdate)
            const localVarPath = `/admin/zip/{zipcode}`
                .replace(`{${"zipcode"}}`, encodeURIComponent(String(zipcode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(feasibleZipcodeUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminFeasibilityApi - functional programming interface
 * @export
 */
export const AdminFeasibilityApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminFeasibilityApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a new feasible zipcode with optional marketing region.
         * @summary Add Feasible Zipcode
         * @param {FeasibleZipcodeCreate} feasibleZipcodeCreate 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addFeasibleZipcode(feasibleZipcodeCreate: FeasibleZipcodeCreate, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeasibleZipcodeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addFeasibleZipcode(feasibleZipcodeCreate, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminFeasibilityApi.addFeasibleZipcode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a single feasible zipcode.
         * @summary Delete Feasible Zipcode
         * @param {string} zipcode 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFeasibleZipcode(zipcode: string, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFeasibleZipcode(zipcode, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminFeasibilityApi.deleteFeasibleZipcode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete multiple feasible zipcodes at once.
         * @summary Delete Feasible Zipcodes
         * @param {Array<string | null>} requestBody 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFeasibleZipcodes(requestBody: Array<string | null>, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFeasibleZipcodes(requestBody, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminFeasibilityApi.deleteFeasibleZipcodes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all feasible zipcodes with their marketing regions.
         * @summary Get Feasible Zips
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFeasibleZips(requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FeasibleZipcodeResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFeasibleZips(requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminFeasibilityApi.getFeasibleZips']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a feasible zipcode\'s properties including marketing region.
         * @summary Update Feasible Zipcode
         * @param {string} zipcode 
         * @param {FeasibleZipcodeUpdate} feasibleZipcodeUpdate 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFeasibleZipcode(zipcode: string, feasibleZipcodeUpdate: FeasibleZipcodeUpdate, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeasibleZipcodeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFeasibleZipcode(zipcode, feasibleZipcodeUpdate, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminFeasibilityApi.updateFeasibleZipcode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminFeasibilityApi - factory interface
 * @export
 */
export const AdminFeasibilityApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminFeasibilityApiFp(configuration)
    return {
        /**
         * Add a new feasible zipcode with optional marketing region.
         * @summary Add Feasible Zipcode
         * @param {FeasibleZipcodeCreate} feasibleZipcodeCreate 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFeasibleZipcode(feasibleZipcodeCreate: FeasibleZipcodeCreate, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<FeasibleZipcodeResponse> {
            return localVarFp.addFeasibleZipcode(feasibleZipcodeCreate, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a single feasible zipcode.
         * @summary Delete Feasible Zipcode
         * @param {string} zipcode 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFeasibleZipcode(zipcode: string, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteFeasibleZipcode(zipcode, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete multiple feasible zipcodes at once.
         * @summary Delete Feasible Zipcodes
         * @param {Array<string | null>} requestBody 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFeasibleZipcodes(requestBody: Array<string | null>, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteFeasibleZipcodes(requestBody, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all feasible zipcodes with their marketing regions.
         * @summary Get Feasible Zips
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeasibleZips(requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<Array<FeasibleZipcodeResponse>> {
            return localVarFp.getFeasibleZips(requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a feasible zipcode\'s properties including marketing region.
         * @summary Update Feasible Zipcode
         * @param {string} zipcode 
         * @param {FeasibleZipcodeUpdate} feasibleZipcodeUpdate 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFeasibleZipcode(zipcode: string, feasibleZipcodeUpdate: FeasibleZipcodeUpdate, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<FeasibleZipcodeResponse> {
            return localVarFp.updateFeasibleZipcode(zipcode, feasibleZipcodeUpdate, requestSource, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminFeasibilityApi - object-oriented interface
 * @export
 * @class AdminFeasibilityApi
 * @extends {BaseAPI}
 */
export class AdminFeasibilityApi extends BaseAPI {
    /**
     * Add a new feasible zipcode with optional marketing region.
     * @summary Add Feasible Zipcode
     * @param {FeasibleZipcodeCreate} feasibleZipcodeCreate 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFeasibilityApi
     */
    public addFeasibleZipcode(feasibleZipcodeCreate: FeasibleZipcodeCreate, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminFeasibilityApiFp(this.configuration).addFeasibleZipcode(feasibleZipcodeCreate, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a single feasible zipcode.
     * @summary Delete Feasible Zipcode
     * @param {string} zipcode 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFeasibilityApi
     */
    public deleteFeasibleZipcode(zipcode: string, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminFeasibilityApiFp(this.configuration).deleteFeasibleZipcode(zipcode, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete multiple feasible zipcodes at once.
     * @summary Delete Feasible Zipcodes
     * @param {Array<string | null>} requestBody 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFeasibilityApi
     */
    public deleteFeasibleZipcodes(requestBody: Array<string | null>, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminFeasibilityApiFp(this.configuration).deleteFeasibleZipcodes(requestBody, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all feasible zipcodes with their marketing regions.
     * @summary Get Feasible Zips
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFeasibilityApi
     */
    public getFeasibleZips(requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminFeasibilityApiFp(this.configuration).getFeasibleZips(requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a feasible zipcode\'s properties including marketing region.
     * @summary Update Feasible Zipcode
     * @param {string} zipcode 
     * @param {FeasibleZipcodeUpdate} feasibleZipcodeUpdate 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFeasibilityApi
     */
    public updateFeasibleZipcode(zipcode: string, feasibleZipcodeUpdate: FeasibleZipcodeUpdate, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminFeasibilityApiFp(this.configuration).updateFeasibleZipcode(zipcode, feasibleZipcodeUpdate, requestSource, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminFirestoreFactoryApi - axios parameter creator
 * @export
 */
export const AdminFirestoreFactoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get all Firestore factories.
         * @summary Get Firestore Factories
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFirestoreFactories: async (requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/firestore/factories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a Firestore factory by ID.
         * @summary Get Firestore Factory
         * @param {string} factoryId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFirestoreFactory: async (factoryId: string, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'factoryId' is not null or undefined
            assertParamExists('getFirestoreFactory', 'factoryId', factoryId)
            const localVarPath = `/admin/firestore/factories/{factory_id}`
                .replace(`{${"factory_id"}}`, encodeURIComponent(String(factoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminFirestoreFactoryApi - functional programming interface
 * @export
 */
export const AdminFirestoreFactoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminFirestoreFactoryApiAxiosParamCreator(configuration)
    return {
        /**
         * Get all Firestore factories.
         * @summary Get Firestore Factories
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFirestoreFactories(requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FirestoreFactoriesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFirestoreFactories(requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminFirestoreFactoryApi.getFirestoreFactories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a Firestore factory by ID.
         * @summary Get Firestore Factory
         * @param {string} factoryId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFirestoreFactory(factoryId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FirestoreFactorySchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFirestoreFactory(factoryId, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminFirestoreFactoryApi.getFirestoreFactory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminFirestoreFactoryApi - factory interface
 * @export
 */
export const AdminFirestoreFactoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminFirestoreFactoryApiFp(configuration)
    return {
        /**
         * Get all Firestore factories.
         * @summary Get Firestore Factories
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFirestoreFactories(requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<FirestoreFactoriesResponse> {
            return localVarFp.getFirestoreFactories(requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a Firestore factory by ID.
         * @summary Get Firestore Factory
         * @param {string} factoryId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFirestoreFactory(factoryId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<FirestoreFactorySchema> {
            return localVarFp.getFirestoreFactory(factoryId, requestSource, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminFirestoreFactoryApi - object-oriented interface
 * @export
 * @class AdminFirestoreFactoryApi
 * @extends {BaseAPI}
 */
export class AdminFirestoreFactoryApi extends BaseAPI {
    /**
     * Get all Firestore factories.
     * @summary Get Firestore Factories
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFirestoreFactoryApi
     */
    public getFirestoreFactories(requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminFirestoreFactoryApiFp(this.configuration).getFirestoreFactories(requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a Firestore factory by ID.
     * @summary Get Firestore Factory
     * @param {string} factoryId 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFirestoreFactoryApi
     */
    public getFirestoreFactory(factoryId: string, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminFirestoreFactoryApiFp(this.configuration).getFirestoreFactory(factoryId, requestSource, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminFirestoreFactoryAduApi - axios parameter creator
 * @export
 */
export const AdminFirestoreFactoryAduApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new firestore factory ADU.
         * @summary Create Firestore Factory Adu
         * @param {CreateFirestoreFactoryADUSchema} createFirestoreFactoryADUSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFirestoreFactoryAdu: async (createFirestoreFactoryADUSchema: CreateFirestoreFactoryADUSchema, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createFirestoreFactoryADUSchema' is not null or undefined
            assertParamExists('createFirestoreFactoryAdu', 'createFirestoreFactoryADUSchema', createFirestoreFactoryADUSchema)
            const localVarPath = `/admin/firestore/factory-adus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFirestoreFactoryADUSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a firestore factory ADU.  The factory_adu_id is the document ID in the products collection (e.g., 31tFZrmxb7SIylBaCy4b)
         * @summary Delete Firestore Factory Adu
         * @param {string} factoryAduId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFirestoreFactoryAdu: async (factoryAduId: string, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'factoryAduId' is not null or undefined
            assertParamExists('deleteFirestoreFactoryAdu', 'factoryAduId', factoryAduId)
            const localVarPath = `/admin/firestore/factory-adus/{factory_adu_id}`
                .replace(`{${"factory_adu_id"}}`, encodeURIComponent(String(factoryAduId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete multiple firestore factory ADUs.  The factory_adu_ids are document IDs in the products collection (e.g., 31tFZrmxb7SIylBaCy4b)
         * @summary Delete Firestore Factory Adus
         * @param {DeleteMultipleFirestoreFactoryADUsSchema} deleteMultipleFirestoreFactoryADUsSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFirestoreFactoryAdus: async (deleteMultipleFirestoreFactoryADUsSchema: DeleteMultipleFirestoreFactoryADUsSchema, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteMultipleFirestoreFactoryADUsSchema' is not null or undefined
            assertParamExists('deleteFirestoreFactoryAdus', 'deleteMultipleFirestoreFactoryADUsSchema', deleteMultipleFirestoreFactoryADUsSchema)
            const localVarPath = `/admin/firestore/factory-adus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteMultipleFirestoreFactoryADUsSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a firestore factory ADU by ID.  This endpoint searches for a document by its ID in the products collection.  The path to a product in Firestore follows this structure: /natomas/v1/catalog/{factory_id}/version/{version_id}/products/{product_id}  Parameters: - include_unlisted: If True, includes products from unlisted versions
         * @summary Get Firestore Factory Adu
         * @param {string} factoryAduId 
         * @param {boolean} [includeUnlisted] Include unlisted versions in the results
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFirestoreFactoryAdu: async (factoryAduId: string, includeUnlisted?: boolean, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'factoryAduId' is not null or undefined
            assertParamExists('getFirestoreFactoryAdu', 'factoryAduId', factoryAduId)
            const localVarPath = `/admin/firestore/factory-adus/{factory_adu_id}`
                .replace(`{${"factory_adu_id"}}`, encodeURIComponent(String(factoryAduId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)

            if (includeUnlisted !== undefined) {
                localVarQueryParameter['include_unlisted'] = includeUnlisted;
            }


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all published firestore factory products (ADUs).  This endpoint retrieves all products from all published factory versions.  Parameters: - factory_id: Optional filter to get products from a specific factory only - product_id: Optional filter to get a product with a specific document ID - include_unlisted: If True, includes products from unlisted versions  Returns: - List of FirestoreFactoryADUSchema objects representing all published products
         * @summary Get Firestore Factory Adus
         * @param {string | null} [factoryId] Filter ADUs by factory ID
         * @param {string | null} [productId] Filter by product document ID
         * @param {boolean} [includeUnlisted] Include unlisted versions in the results
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFirestoreFactoryAdus: async (factoryId?: string | null, productId?: string | null, includeUnlisted?: boolean, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/firestore/factory-adus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)

            if (factoryId !== undefined) {
                localVarQueryParameter['factory_id'] = factoryId;
            }

            if (productId !== undefined) {
                localVarQueryParameter['product_id'] = productId;
            }

            if (includeUnlisted !== undefined) {
                localVarQueryParameter['include_unlisted'] = includeUnlisted;
            }


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a firestore factory ADU.  The factory_adu_id can be either: 1. The document ID in the products collection (e.g., 31tFZrmxb7SIylBaCy4b) 2. A UUID field in the document (if it exists)
         * @summary Update Firestore Factory Adu
         * @param {string} factoryAduId 
         * @param {UpdateFirestoreFactoryADUSchema} updateFirestoreFactoryADUSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFirestoreFactoryAdu: async (factoryAduId: string, updateFirestoreFactoryADUSchema: UpdateFirestoreFactoryADUSchema, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'factoryAduId' is not null or undefined
            assertParamExists('updateFirestoreFactoryAdu', 'factoryAduId', factoryAduId)
            // verify required parameter 'updateFirestoreFactoryADUSchema' is not null or undefined
            assertParamExists('updateFirestoreFactoryAdu', 'updateFirestoreFactoryADUSchema', updateFirestoreFactoryADUSchema)
            const localVarPath = `/admin/firestore/factory-adus/{factory_adu_id}`
                .replace(`{${"factory_adu_id"}}`, encodeURIComponent(String(factoryAduId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFirestoreFactoryADUSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminFirestoreFactoryAduApi - functional programming interface
 * @export
 */
export const AdminFirestoreFactoryAduApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminFirestoreFactoryAduApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new firestore factory ADU.
         * @summary Create Firestore Factory Adu
         * @param {CreateFirestoreFactoryADUSchema} createFirestoreFactoryADUSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFirestoreFactoryAdu(createFirestoreFactoryADUSchema: CreateFirestoreFactoryADUSchema, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FirestoreFactoryADUSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFirestoreFactoryAdu(createFirestoreFactoryADUSchema, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminFirestoreFactoryAduApi.createFirestoreFactoryAdu']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a firestore factory ADU.  The factory_adu_id is the document ID in the products collection (e.g., 31tFZrmxb7SIylBaCy4b)
         * @summary Delete Firestore Factory Adu
         * @param {string} factoryAduId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFirestoreFactoryAdu(factoryAduId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FirestoreFactoryADUDeleteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFirestoreFactoryAdu(factoryAduId, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminFirestoreFactoryAduApi.deleteFirestoreFactoryAdu']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete multiple firestore factory ADUs.  The factory_adu_ids are document IDs in the products collection (e.g., 31tFZrmxb7SIylBaCy4b)
         * @summary Delete Firestore Factory Adus
         * @param {DeleteMultipleFirestoreFactoryADUsSchema} deleteMultipleFirestoreFactoryADUsSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFirestoreFactoryAdus(deleteMultipleFirestoreFactoryADUsSchema: DeleteMultipleFirestoreFactoryADUsSchema, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FirestoreFactoryADUDeleteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFirestoreFactoryAdus(deleteMultipleFirestoreFactoryADUsSchema, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminFirestoreFactoryAduApi.deleteFirestoreFactoryAdus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a firestore factory ADU by ID.  This endpoint searches for a document by its ID in the products collection.  The path to a product in Firestore follows this structure: /natomas/v1/catalog/{factory_id}/version/{version_id}/products/{product_id}  Parameters: - include_unlisted: If True, includes products from unlisted versions
         * @summary Get Firestore Factory Adu
         * @param {string} factoryAduId 
         * @param {boolean} [includeUnlisted] Include unlisted versions in the results
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFirestoreFactoryAdu(factoryAduId: string, includeUnlisted?: boolean, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FirestoreFactoryADUSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFirestoreFactoryAdu(factoryAduId, includeUnlisted, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminFirestoreFactoryAduApi.getFirestoreFactoryAdu']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all published firestore factory products (ADUs).  This endpoint retrieves all products from all published factory versions.  Parameters: - factory_id: Optional filter to get products from a specific factory only - product_id: Optional filter to get a product with a specific document ID - include_unlisted: If True, includes products from unlisted versions  Returns: - List of FirestoreFactoryADUSchema objects representing all published products
         * @summary Get Firestore Factory Adus
         * @param {string | null} [factoryId] Filter ADUs by factory ID
         * @param {string | null} [productId] Filter by product document ID
         * @param {boolean} [includeUnlisted] Include unlisted versions in the results
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFirestoreFactoryAdus(factoryId?: string | null, productId?: string | null, includeUnlisted?: boolean, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FirestoreFactoryADUSchema>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFirestoreFactoryAdus(factoryId, productId, includeUnlisted, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminFirestoreFactoryAduApi.getFirestoreFactoryAdus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a firestore factory ADU.  The factory_adu_id can be either: 1. The document ID in the products collection (e.g., 31tFZrmxb7SIylBaCy4b) 2. A UUID field in the document (if it exists)
         * @summary Update Firestore Factory Adu
         * @param {string} factoryAduId 
         * @param {UpdateFirestoreFactoryADUSchema} updateFirestoreFactoryADUSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFirestoreFactoryAdu(factoryAduId: string, updateFirestoreFactoryADUSchema: UpdateFirestoreFactoryADUSchema, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FirestoreFactoryADUSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFirestoreFactoryAdu(factoryAduId, updateFirestoreFactoryADUSchema, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminFirestoreFactoryAduApi.updateFirestoreFactoryAdu']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminFirestoreFactoryAduApi - factory interface
 * @export
 */
export const AdminFirestoreFactoryAduApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminFirestoreFactoryAduApiFp(configuration)
    return {
        /**
         * Create a new firestore factory ADU.
         * @summary Create Firestore Factory Adu
         * @param {CreateFirestoreFactoryADUSchema} createFirestoreFactoryADUSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFirestoreFactoryAdu(createFirestoreFactoryADUSchema: CreateFirestoreFactoryADUSchema, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<FirestoreFactoryADUSchema> {
            return localVarFp.createFirestoreFactoryAdu(createFirestoreFactoryADUSchema, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a firestore factory ADU.  The factory_adu_id is the document ID in the products collection (e.g., 31tFZrmxb7SIylBaCy4b)
         * @summary Delete Firestore Factory Adu
         * @param {string} factoryAduId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFirestoreFactoryAdu(factoryAduId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<FirestoreFactoryADUDeleteResponse> {
            return localVarFp.deleteFirestoreFactoryAdu(factoryAduId, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete multiple firestore factory ADUs.  The factory_adu_ids are document IDs in the products collection (e.g., 31tFZrmxb7SIylBaCy4b)
         * @summary Delete Firestore Factory Adus
         * @param {DeleteMultipleFirestoreFactoryADUsSchema} deleteMultipleFirestoreFactoryADUsSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFirestoreFactoryAdus(deleteMultipleFirestoreFactoryADUsSchema: DeleteMultipleFirestoreFactoryADUsSchema, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<FirestoreFactoryADUDeleteResponse> {
            return localVarFp.deleteFirestoreFactoryAdus(deleteMultipleFirestoreFactoryADUsSchema, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a firestore factory ADU by ID.  This endpoint searches for a document by its ID in the products collection.  The path to a product in Firestore follows this structure: /natomas/v1/catalog/{factory_id}/version/{version_id}/products/{product_id}  Parameters: - include_unlisted: If True, includes products from unlisted versions
         * @summary Get Firestore Factory Adu
         * @param {string} factoryAduId 
         * @param {boolean} [includeUnlisted] Include unlisted versions in the results
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFirestoreFactoryAdu(factoryAduId: string, includeUnlisted?: boolean, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<FirestoreFactoryADUSchema> {
            return localVarFp.getFirestoreFactoryAdu(factoryAduId, includeUnlisted, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all published firestore factory products (ADUs).  This endpoint retrieves all products from all published factory versions.  Parameters: - factory_id: Optional filter to get products from a specific factory only - product_id: Optional filter to get a product with a specific document ID - include_unlisted: If True, includes products from unlisted versions  Returns: - List of FirestoreFactoryADUSchema objects representing all published products
         * @summary Get Firestore Factory Adus
         * @param {string | null} [factoryId] Filter ADUs by factory ID
         * @param {string | null} [productId] Filter by product document ID
         * @param {boolean} [includeUnlisted] Include unlisted versions in the results
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFirestoreFactoryAdus(factoryId?: string | null, productId?: string | null, includeUnlisted?: boolean, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<Array<FirestoreFactoryADUSchema>> {
            return localVarFp.getFirestoreFactoryAdus(factoryId, productId, includeUnlisted, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a firestore factory ADU.  The factory_adu_id can be either: 1. The document ID in the products collection (e.g., 31tFZrmxb7SIylBaCy4b) 2. A UUID field in the document (if it exists)
         * @summary Update Firestore Factory Adu
         * @param {string} factoryAduId 
         * @param {UpdateFirestoreFactoryADUSchema} updateFirestoreFactoryADUSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFirestoreFactoryAdu(factoryAduId: string, updateFirestoreFactoryADUSchema: UpdateFirestoreFactoryADUSchema, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<FirestoreFactoryADUSchema> {
            return localVarFp.updateFirestoreFactoryAdu(factoryAduId, updateFirestoreFactoryADUSchema, requestSource, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminFirestoreFactoryAduApi - object-oriented interface
 * @export
 * @class AdminFirestoreFactoryAduApi
 * @extends {BaseAPI}
 */
export class AdminFirestoreFactoryAduApi extends BaseAPI {
    /**
     * Create a new firestore factory ADU.
     * @summary Create Firestore Factory Adu
     * @param {CreateFirestoreFactoryADUSchema} createFirestoreFactoryADUSchema 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFirestoreFactoryAduApi
     */
    public createFirestoreFactoryAdu(createFirestoreFactoryADUSchema: CreateFirestoreFactoryADUSchema, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminFirestoreFactoryAduApiFp(this.configuration).createFirestoreFactoryAdu(createFirestoreFactoryADUSchema, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a firestore factory ADU.  The factory_adu_id is the document ID in the products collection (e.g., 31tFZrmxb7SIylBaCy4b)
     * @summary Delete Firestore Factory Adu
     * @param {string} factoryAduId 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFirestoreFactoryAduApi
     */
    public deleteFirestoreFactoryAdu(factoryAduId: string, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminFirestoreFactoryAduApiFp(this.configuration).deleteFirestoreFactoryAdu(factoryAduId, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete multiple firestore factory ADUs.  The factory_adu_ids are document IDs in the products collection (e.g., 31tFZrmxb7SIylBaCy4b)
     * @summary Delete Firestore Factory Adus
     * @param {DeleteMultipleFirestoreFactoryADUsSchema} deleteMultipleFirestoreFactoryADUsSchema 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFirestoreFactoryAduApi
     */
    public deleteFirestoreFactoryAdus(deleteMultipleFirestoreFactoryADUsSchema: DeleteMultipleFirestoreFactoryADUsSchema, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminFirestoreFactoryAduApiFp(this.configuration).deleteFirestoreFactoryAdus(deleteMultipleFirestoreFactoryADUsSchema, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a firestore factory ADU by ID.  This endpoint searches for a document by its ID in the products collection.  The path to a product in Firestore follows this structure: /natomas/v1/catalog/{factory_id}/version/{version_id}/products/{product_id}  Parameters: - include_unlisted: If True, includes products from unlisted versions
     * @summary Get Firestore Factory Adu
     * @param {string} factoryAduId 
     * @param {boolean} [includeUnlisted] Include unlisted versions in the results
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFirestoreFactoryAduApi
     */
    public getFirestoreFactoryAdu(factoryAduId: string, includeUnlisted?: boolean, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminFirestoreFactoryAduApiFp(this.configuration).getFirestoreFactoryAdu(factoryAduId, includeUnlisted, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all published firestore factory products (ADUs).  This endpoint retrieves all products from all published factory versions.  Parameters: - factory_id: Optional filter to get products from a specific factory only - product_id: Optional filter to get a product with a specific document ID - include_unlisted: If True, includes products from unlisted versions  Returns: - List of FirestoreFactoryADUSchema objects representing all published products
     * @summary Get Firestore Factory Adus
     * @param {string | null} [factoryId] Filter ADUs by factory ID
     * @param {string | null} [productId] Filter by product document ID
     * @param {boolean} [includeUnlisted] Include unlisted versions in the results
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFirestoreFactoryAduApi
     */
    public getFirestoreFactoryAdus(factoryId?: string | null, productId?: string | null, includeUnlisted?: boolean, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminFirestoreFactoryAduApiFp(this.configuration).getFirestoreFactoryAdus(factoryId, productId, includeUnlisted, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a firestore factory ADU.  The factory_adu_id can be either: 1. The document ID in the products collection (e.g., 31tFZrmxb7SIylBaCy4b) 2. A UUID field in the document (if it exists)
     * @summary Update Firestore Factory Adu
     * @param {string} factoryAduId 
     * @param {UpdateFirestoreFactoryADUSchema} updateFirestoreFactoryADUSchema 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFirestoreFactoryAduApi
     */
    public updateFirestoreFactoryAdu(factoryAduId: string, updateFirestoreFactoryADUSchema: UpdateFirestoreFactoryADUSchema, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminFirestoreFactoryAduApiFp(this.configuration).updateFirestoreFactoryAdu(factoryAduId, updateFirestoreFactoryADUSchema, requestSource, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminFirestoreProjectApi - axios parameter creator
 * @export
 */
export const AdminFirestoreProjectApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Firestore Project
         * @param {string} authUserId 
         * @param {string} firstName 
         * @param {string} lastName 
         * @param {string} email 
         * @param {string} phone 
         * @param {ProjectAddressSchema} projectAddressSchema 
         * @param {string | null} [projectId] 
         * @param {boolean | null} [cartEnabled] 
         * @param {string | null} [portalType] 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFirestoreProject: async (authUserId: string, firstName: string, lastName: string, email: string, phone: string, projectAddressSchema: ProjectAddressSchema, projectId?: string | null, cartEnabled?: boolean | null, portalType?: string | null, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authUserId' is not null or undefined
            assertParamExists('createFirestoreProject', 'authUserId', authUserId)
            // verify required parameter 'firstName' is not null or undefined
            assertParamExists('createFirestoreProject', 'firstName', firstName)
            // verify required parameter 'lastName' is not null or undefined
            assertParamExists('createFirestoreProject', 'lastName', lastName)
            // verify required parameter 'email' is not null or undefined
            assertParamExists('createFirestoreProject', 'email', email)
            // verify required parameter 'phone' is not null or undefined
            assertParamExists('createFirestoreProject', 'phone', phone)
            // verify required parameter 'projectAddressSchema' is not null or undefined
            assertParamExists('createFirestoreProject', 'projectAddressSchema', projectAddressSchema)
            const localVarPath = `/admin/firestore-project`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)

            if (projectId !== undefined) {
                localVarQueryParameter['project_id'] = projectId;
            }

            if (authUserId !== undefined) {
                localVarQueryParameter['auth_user_id'] = authUserId;
            }

            if (firstName !== undefined) {
                localVarQueryParameter['first_name'] = firstName;
            }

            if (lastName !== undefined) {
                localVarQueryParameter['last_name'] = lastName;
            }

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (phone !== undefined) {
                localVarQueryParameter['phone'] = phone;
            }

            if (cartEnabled !== undefined) {
                localVarQueryParameter['cart_enabled'] = cartEnabled;
            }

            if (portalType !== undefined) {
                localVarQueryParameter['portal_type'] = portalType;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectAddressSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Firestore Projects
         * @param {string | null} [include] 
         * @param {string | null} [email] 
         * @param {boolean | null} [depositPaid] 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFirestoreProjects: async (include?: string | null, email?: string | null, depositPaid?: boolean | null, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/firestore-projects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)

            if (include !== undefined) {
                localVarQueryParameter['include'] = include;
            }

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (depositPaid !== undefined) {
                localVarQueryParameter['deposit_paid'] = depositPaid;
            }


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Project By Id
         * @param {string} projectId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectById: async (projectId: string, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getProjectById', 'projectId', projectId)
            const localVarPath = `/admin/firestore-project/{project_id}`
                .replace(`{${"project_id"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Project Cart By Id
         * @param {string} projectId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectCartById: async (projectId: string, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getProjectCartById', 'projectId', projectId)
            const localVarPath = `/admin/firestore-project/{project_id}/cart`
                .replace(`{${"project_id"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Project Design Summary
         * @param {string} projectId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectDesignSummary: async (projectId: string, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getProjectDesignSummary', 'projectId', projectId)
            const localVarPath = `/admin/firestore-project/{project_id}/design_summary`
                .replace(`{${"project_id"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Project Owner
         * @param {string} projectId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectOwner: async (projectId: string, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getProjectOwner', 'projectId', projectId)
            const localVarPath = `/admin/firestore-project/{project_id}/owner`
                .replace(`{${"project_id"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Toggle Complex Preconstruction Diligence Fee
         * @param {string} projectId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleComplexPreconstructionDiligenceFee: async (projectId: string, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('toggleComplexPreconstructionDiligenceFee', 'projectId', projectId)
            const localVarPath = `/admin/firestore-project/{project_id}/toggle-complex-preconstruction-diligence-fee`
                .replace(`{${"project_id"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Project Portal Type
         * @param {string} portalType 
         * @param {string} projectId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProjectPortalType: async (portalType: string, projectId: string, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'portalType' is not null or undefined
            assertParamExists('updateProjectPortalType', 'portalType', portalType)
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('updateProjectPortalType', 'projectId', projectId)
            const localVarPath = `/admin/firestore-project/portal-type`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)

            if (portalType !== undefined) {
                localVarQueryParameter['portal_type'] = portalType;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['project_id'] = projectId;
            }


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminFirestoreProjectApi - functional programming interface
 * @export
 */
export const AdminFirestoreProjectApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminFirestoreProjectApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Firestore Project
         * @param {string} authUserId 
         * @param {string} firstName 
         * @param {string} lastName 
         * @param {string} email 
         * @param {string} phone 
         * @param {ProjectAddressSchema} projectAddressSchema 
         * @param {string | null} [projectId] 
         * @param {boolean | null} [cartEnabled] 
         * @param {string | null} [portalType] 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFirestoreProject(authUserId: string, firstName: string, lastName: string, email: string, phone: string, projectAddressSchema: ProjectAddressSchema, projectId?: string | null, cartEnabled?: boolean | null, portalType?: string | null, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFirestoreProject(authUserId, firstName, lastName, email, phone, projectAddressSchema, projectId, cartEnabled, portalType, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminFirestoreProjectApi.createFirestoreProject']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Firestore Projects
         * @param {string | null} [include] 
         * @param {string | null} [email] 
         * @param {boolean | null} [depositPaid] 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFirestoreProjects(include?: string | null, email?: string | null, depositPaid?: boolean | null, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFirestoreProjects(include, email, depositPaid, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminFirestoreProjectApi.getFirestoreProjects']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Project By Id
         * @param {string} projectId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjectById(projectId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FirestoreProject>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProjectById(projectId, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminFirestoreProjectApi.getProjectById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Project Cart By Id
         * @param {string} projectId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjectCartById(projectId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProjectCartById(projectId, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminFirestoreProjectApi.getProjectCartById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Project Design Summary
         * @param {string} projectId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjectDesignSummary(projectId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProjectDesignSummary(projectId, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminFirestoreProjectApi.getProjectDesignSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Project Owner
         * @param {string} projectId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjectOwner(projectId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProjectOwner(projectId, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminFirestoreProjectApi.getProjectOwner']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Toggle Complex Preconstruction Diligence Fee
         * @param {string} projectId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async toggleComplexPreconstructionDiligenceFee(projectId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.toggleComplexPreconstructionDiligenceFee(projectId, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminFirestoreProjectApi.toggleComplexPreconstructionDiligenceFee']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Project Portal Type
         * @param {string} portalType 
         * @param {string} projectId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProjectPortalType(portalType: string, projectId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProjectPortalType(portalType, projectId, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminFirestoreProjectApi.updateProjectPortalType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminFirestoreProjectApi - factory interface
 * @export
 */
export const AdminFirestoreProjectApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminFirestoreProjectApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Firestore Project
         * @param {string} authUserId 
         * @param {string} firstName 
         * @param {string} lastName 
         * @param {string} email 
         * @param {string} phone 
         * @param {ProjectAddressSchema} projectAddressSchema 
         * @param {string | null} [projectId] 
         * @param {boolean | null} [cartEnabled] 
         * @param {string | null} [portalType] 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFirestoreProject(authUserId: string, firstName: string, lastName: string, email: string, phone: string, projectAddressSchema: ProjectAddressSchema, projectId?: string | null, cartEnabled?: boolean | null, portalType?: string | null, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.createFirestoreProject(authUserId, firstName, lastName, email, phone, projectAddressSchema, projectId, cartEnabled, portalType, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Firestore Projects
         * @param {string | null} [include] 
         * @param {string | null} [email] 
         * @param {boolean | null} [depositPaid] 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFirestoreProjects(include?: string | null, email?: string | null, depositPaid?: boolean | null, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getFirestoreProjects(include, email, depositPaid, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Project By Id
         * @param {string} projectId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectById(projectId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<FirestoreProject> {
            return localVarFp.getProjectById(projectId, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Project Cart By Id
         * @param {string} projectId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectCartById(projectId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getProjectCartById(projectId, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Project Design Summary
         * @param {string} projectId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectDesignSummary(projectId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getProjectDesignSummary(projectId, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Project Owner
         * @param {string} projectId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectOwner(projectId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getProjectOwner(projectId, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Toggle Complex Preconstruction Diligence Fee
         * @param {string} projectId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleComplexPreconstructionDiligenceFee(projectId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.toggleComplexPreconstructionDiligenceFee(projectId, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Project Portal Type
         * @param {string} portalType 
         * @param {string} projectId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProjectPortalType(portalType: string, projectId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.updateProjectPortalType(portalType, projectId, requestSource, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminFirestoreProjectApi - object-oriented interface
 * @export
 * @class AdminFirestoreProjectApi
 * @extends {BaseAPI}
 */
export class AdminFirestoreProjectApi extends BaseAPI {
    /**
     * 
     * @summary Create Firestore Project
     * @param {string} authUserId 
     * @param {string} firstName 
     * @param {string} lastName 
     * @param {string} email 
     * @param {string} phone 
     * @param {ProjectAddressSchema} projectAddressSchema 
     * @param {string | null} [projectId] 
     * @param {boolean | null} [cartEnabled] 
     * @param {string | null} [portalType] 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFirestoreProjectApi
     */
    public createFirestoreProject(authUserId: string, firstName: string, lastName: string, email: string, phone: string, projectAddressSchema: ProjectAddressSchema, projectId?: string | null, cartEnabled?: boolean | null, portalType?: string | null, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminFirestoreProjectApiFp(this.configuration).createFirestoreProject(authUserId, firstName, lastName, email, phone, projectAddressSchema, projectId, cartEnabled, portalType, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Firestore Projects
     * @param {string | null} [include] 
     * @param {string | null} [email] 
     * @param {boolean | null} [depositPaid] 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFirestoreProjectApi
     */
    public getFirestoreProjects(include?: string | null, email?: string | null, depositPaid?: boolean | null, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminFirestoreProjectApiFp(this.configuration).getFirestoreProjects(include, email, depositPaid, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Project By Id
     * @param {string} projectId 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFirestoreProjectApi
     */
    public getProjectById(projectId: string, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminFirestoreProjectApiFp(this.configuration).getProjectById(projectId, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Project Cart By Id
     * @param {string} projectId 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFirestoreProjectApi
     */
    public getProjectCartById(projectId: string, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminFirestoreProjectApiFp(this.configuration).getProjectCartById(projectId, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Project Design Summary
     * @param {string} projectId 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFirestoreProjectApi
     */
    public getProjectDesignSummary(projectId: string, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminFirestoreProjectApiFp(this.configuration).getProjectDesignSummary(projectId, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Project Owner
     * @param {string} projectId 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFirestoreProjectApi
     */
    public getProjectOwner(projectId: string, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminFirestoreProjectApiFp(this.configuration).getProjectOwner(projectId, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Toggle Complex Preconstruction Diligence Fee
     * @param {string} projectId 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFirestoreProjectApi
     */
    public toggleComplexPreconstructionDiligenceFee(projectId: string, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminFirestoreProjectApiFp(this.configuration).toggleComplexPreconstructionDiligenceFee(projectId, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Project Portal Type
     * @param {string} portalType 
     * @param {string} projectId 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFirestoreProjectApi
     */
    public updateProjectPortalType(portalType: string, projectId: string, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminFirestoreProjectApiFp(this.configuration).updateProjectPortalType(portalType, projectId, requestSource, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminGeohazardsApi - axios parameter creator
 * @export
 */
export const AdminGeohazardsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Admin Get Geohazards
         * @param {number} latitude 
         * @param {number} longitude 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetGeohazards: async (latitude: number, longitude: number, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'latitude' is not null or undefined
            assertParamExists('adminGetGeohazards', 'latitude', latitude)
            // verify required parameter 'longitude' is not null or undefined
            assertParamExists('adminGetGeohazards', 'longitude', longitude)
            const localVarPath = `/admin/geohazards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)

            if (latitude !== undefined) {
                localVarQueryParameter['latitude'] = latitude;
            }

            if (longitude !== undefined) {
                localVarQueryParameter['longitude'] = longitude;
            }


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminGeohazardsApi - functional programming interface
 * @export
 */
export const AdminGeohazardsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminGeohazardsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Admin Get Geohazards
         * @param {number} latitude 
         * @param {number} longitude 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetGeohazards(latitude: number, longitude: number, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeohazardsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetGeohazards(latitude, longitude, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminGeohazardsApi.adminGetGeohazards']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminGeohazardsApi - factory interface
 * @export
 */
export const AdminGeohazardsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminGeohazardsApiFp(configuration)
    return {
        /**
         * 
         * @summary Admin Get Geohazards
         * @param {number} latitude 
         * @param {number} longitude 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetGeohazards(latitude: number, longitude: number, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<GeohazardsResponse> {
            return localVarFp.adminGetGeohazards(latitude, longitude, requestSource, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminGeohazardsApi - object-oriented interface
 * @export
 * @class AdminGeohazardsApi
 * @extends {BaseAPI}
 */
export class AdminGeohazardsApi extends BaseAPI {
    /**
     * 
     * @summary Admin Get Geohazards
     * @param {number} latitude 
     * @param {number} longitude 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminGeohazardsApi
     */
    public adminGetGeohazards(latitude: number, longitude: number, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminGeohazardsApiFp(this.configuration).adminGetGeohazards(latitude, longitude, requestSource, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminLeadsApi - axios parameter creator
 * @export
 */
export const AdminLeadsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Delete a duplicate lead record.
         * @summary Admin Delete Duplicate Lead
         * @param {string} duplicateLeadId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteDuplicateLead: async (duplicateLeadId: string, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'duplicateLeadId' is not null or undefined
            assertParamExists('adminDeleteDuplicateLead', 'duplicateLeadId', duplicateLeadId)
            const localVarPath = `/admin/leads/duplicates/{duplicate_lead_id}`
                .replace(`{${"duplicate_lead_id"}}`, encodeURIComponent(String(duplicateLeadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific duplicate lead by ID.
         * @summary Admin Get Duplicate Lead By Id
         * @param {string} duplicateLeadId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetDuplicateLeadById: async (duplicateLeadId: string, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'duplicateLeadId' is not null or undefined
            assertParamExists('adminGetDuplicateLeadById', 'duplicateLeadId', duplicateLeadId)
            const localVarPath = `/admin/leads/duplicates/{duplicate_lead_id}`
                .replace(`{${"duplicate_lead_id"}}`, encodeURIComponent(String(duplicateLeadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get paginated list of duplicate leads.
         * @summary Admin Get Duplicate Leads
         * @param {number} [limit] Number of records to return
         * @param {number} [offset] Number of records to skip
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetDuplicateLeads: async (limit?: number, offset?: number, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/leads/duplicates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all duplicate leads for a specific email.
         * @summary Admin Get Duplicate Leads By Email
         * @param {string} email 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetDuplicateLeadsByEmail: async (email: string, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('adminGetDuplicateLeadsByEmail', 'email', email)
            const localVarPath = `/admin/leads/duplicates/email/{email}`
                .replace(`{${"email"}}`, encodeURIComponent(String(email)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin Get Lead
         * @param {string | null} [email] 
         * @param {string | null} [sfLeadId] 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetLead: async (email?: string | null, sfLeadId?: string | null, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/lead`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (sfLeadId !== undefined) {
                localVarQueryParameter['sf_lead_id'] = sfLeadId;
            }


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin Get Leads Needs Repush
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetLeadsNeedsRepush: async (requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/leads/needs-repush`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin Get Recent Leads
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetRecentLeads: async (requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/leads/recent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin Repush Leads
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRepushLeads: async (requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/leads/repush`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminLeadsApi - functional programming interface
 * @export
 */
export const AdminLeadsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminLeadsApiAxiosParamCreator(configuration)
    return {
        /**
         * Delete a duplicate lead record.
         * @summary Admin Delete Duplicate Lead
         * @param {string} duplicateLeadId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDeleteDuplicateLead(duplicateLeadId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDeleteDuplicateLead(duplicateLeadId, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminLeadsApi.adminDeleteDuplicateLead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a specific duplicate lead by ID.
         * @summary Admin Get Duplicate Lead By Id
         * @param {string} duplicateLeadId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetDuplicateLeadById(duplicateLeadId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetDuplicateLeadById(duplicateLeadId, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminLeadsApi.adminGetDuplicateLeadById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get paginated list of duplicate leads.
         * @summary Admin Get Duplicate Leads
         * @param {number} [limit] Number of records to return
         * @param {number} [offset] Number of records to skip
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetDuplicateLeads(limit?: number, offset?: number, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetDuplicateLeads(limit, offset, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminLeadsApi.adminGetDuplicateLeads']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all duplicate leads for a specific email.
         * @summary Admin Get Duplicate Leads By Email
         * @param {string} email 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetDuplicateLeadsByEmail(email: string, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetDuplicateLeadsByEmail(email, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminLeadsApi.adminGetDuplicateLeadsByEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin Get Lead
         * @param {string | null} [email] 
         * @param {string | null} [sfLeadId] 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetLead(email?: string | null, sfLeadId?: string | null, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetLead(email, sfLeadId, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminLeadsApi.adminGetLead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin Get Leads Needs Repush
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetLeadsNeedsRepush(requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetLeadsNeedsRepush(requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminLeadsApi.adminGetLeadsNeedsRepush']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin Get Recent Leads
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetRecentLeads(requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetRecentLeads(requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminLeadsApi.adminGetRecentLeads']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin Repush Leads
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminRepushLeads(requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminRepushLeads(requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminLeadsApi.adminRepushLeads']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminLeadsApi - factory interface
 * @export
 */
export const AdminLeadsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminLeadsApiFp(configuration)
    return {
        /**
         * Delete a duplicate lead record.
         * @summary Admin Delete Duplicate Lead
         * @param {string} duplicateLeadId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteDuplicateLead(duplicateLeadId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.adminDeleteDuplicateLead(duplicateLeadId, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific duplicate lead by ID.
         * @summary Admin Get Duplicate Lead By Id
         * @param {string} duplicateLeadId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetDuplicateLeadById(duplicateLeadId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.adminGetDuplicateLeadById(duplicateLeadId, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Get paginated list of duplicate leads.
         * @summary Admin Get Duplicate Leads
         * @param {number} [limit] Number of records to return
         * @param {number} [offset] Number of records to skip
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetDuplicateLeads(limit?: number, offset?: number, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.adminGetDuplicateLeads(limit, offset, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all duplicate leads for a specific email.
         * @summary Admin Get Duplicate Leads By Email
         * @param {string} email 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetDuplicateLeadsByEmail(email: string, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.adminGetDuplicateLeadsByEmail(email, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin Get Lead
         * @param {string | null} [email] 
         * @param {string | null} [sfLeadId] 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetLead(email?: string | null, sfLeadId?: string | null, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.adminGetLead(email, sfLeadId, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin Get Leads Needs Repush
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetLeadsNeedsRepush(requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.adminGetLeadsNeedsRepush(requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin Get Recent Leads
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetRecentLeads(requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.adminGetRecentLeads(requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin Repush Leads
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRepushLeads(requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.adminRepushLeads(requestSource, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminLeadsApi - object-oriented interface
 * @export
 * @class AdminLeadsApi
 * @extends {BaseAPI}
 */
export class AdminLeadsApi extends BaseAPI {
    /**
     * Delete a duplicate lead record.
     * @summary Admin Delete Duplicate Lead
     * @param {string} duplicateLeadId 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminLeadsApi
     */
    public adminDeleteDuplicateLead(duplicateLeadId: string, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminLeadsApiFp(this.configuration).adminDeleteDuplicateLead(duplicateLeadId, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific duplicate lead by ID.
     * @summary Admin Get Duplicate Lead By Id
     * @param {string} duplicateLeadId 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminLeadsApi
     */
    public adminGetDuplicateLeadById(duplicateLeadId: string, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminLeadsApiFp(this.configuration).adminGetDuplicateLeadById(duplicateLeadId, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get paginated list of duplicate leads.
     * @summary Admin Get Duplicate Leads
     * @param {number} [limit] Number of records to return
     * @param {number} [offset] Number of records to skip
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminLeadsApi
     */
    public adminGetDuplicateLeads(limit?: number, offset?: number, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminLeadsApiFp(this.configuration).adminGetDuplicateLeads(limit, offset, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all duplicate leads for a specific email.
     * @summary Admin Get Duplicate Leads By Email
     * @param {string} email 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminLeadsApi
     */
    public adminGetDuplicateLeadsByEmail(email: string, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminLeadsApiFp(this.configuration).adminGetDuplicateLeadsByEmail(email, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin Get Lead
     * @param {string | null} [email] 
     * @param {string | null} [sfLeadId] 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminLeadsApi
     */
    public adminGetLead(email?: string | null, sfLeadId?: string | null, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminLeadsApiFp(this.configuration).adminGetLead(email, sfLeadId, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin Get Leads Needs Repush
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminLeadsApi
     */
    public adminGetLeadsNeedsRepush(requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminLeadsApiFp(this.configuration).adminGetLeadsNeedsRepush(requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin Get Recent Leads
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminLeadsApi
     */
    public adminGetRecentLeads(requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminLeadsApiFp(this.configuration).adminGetRecentLeads(requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin Repush Leads
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminLeadsApi
     */
    public adminRepushLeads(requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminLeadsApiFp(this.configuration).adminRepushLeads(requestSource, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminMarketingRegionsApi - axios parameter creator
 * @export
 */
export const AdminMarketingRegionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new marketing region.
         * @summary Create Marketing Region
         * @param {MarketingRegionCreate} marketingRegionCreate 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMarketingRegion: async (marketingRegionCreate: MarketingRegionCreate, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'marketingRegionCreate' is not null or undefined
            assertParamExists('createMarketingRegion', 'marketingRegionCreate', marketingRegionCreate)
            const localVarPath = `/admin/marketing-regions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(marketingRegionCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a marketing region and remove its association from zipcodes.
         * @summary Delete Marketing Region
         * @param {string} uuid 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMarketingRegion: async (uuid: string, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('deleteMarketingRegion', 'uuid', uuid)
            const localVarPath = `/admin/marketing-regions/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single marketing region by UUID.
         * @summary Get Marketing Region
         * @param {string} uuid 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarketingRegion: async (uuid: string, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('getMarketingRegion', 'uuid', uuid)
            const localVarPath = `/admin/marketing-regions/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all marketing regions.
         * @summary Get Marketing Regions
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarketingRegions: async (requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/marketing-regions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a marketing region.
         * @summary Update Marketing Region
         * @param {string} uuid 
         * @param {MarketingRegionUpdate} marketingRegionUpdate 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMarketingRegion: async (uuid: string, marketingRegionUpdate: MarketingRegionUpdate, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('updateMarketingRegion', 'uuid', uuid)
            // verify required parameter 'marketingRegionUpdate' is not null or undefined
            assertParamExists('updateMarketingRegion', 'marketingRegionUpdate', marketingRegionUpdate)
            const localVarPath = `/admin/marketing-regions/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(marketingRegionUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminMarketingRegionsApi - functional programming interface
 * @export
 */
export const AdminMarketingRegionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminMarketingRegionsApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new marketing region.
         * @summary Create Marketing Region
         * @param {MarketingRegionCreate} marketingRegionCreate 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMarketingRegion(marketingRegionCreate: MarketingRegionCreate, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SrcApiAdminSystemFeasibilityMarketingRegionSchemaMarketingRegionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMarketingRegion(marketingRegionCreate, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminMarketingRegionsApi.createMarketingRegion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a marketing region and remove its association from zipcodes.
         * @summary Delete Marketing Region
         * @param {string} uuid 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMarketingRegion(uuid: string, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMarketingRegion(uuid, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminMarketingRegionsApi.deleteMarketingRegion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a single marketing region by UUID.
         * @summary Get Marketing Region
         * @param {string} uuid 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMarketingRegion(uuid: string, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SrcApiAdminSystemFeasibilityMarketingRegionSchemaMarketingRegionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMarketingRegion(uuid, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminMarketingRegionsApi.getMarketingRegion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all marketing regions.
         * @summary Get Marketing Regions
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMarketingRegions(requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SrcApiAdminSystemFeasibilityMarketingRegionSchemaMarketingRegionResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMarketingRegions(requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminMarketingRegionsApi.getMarketingRegions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a marketing region.
         * @summary Update Marketing Region
         * @param {string} uuid 
         * @param {MarketingRegionUpdate} marketingRegionUpdate 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMarketingRegion(uuid: string, marketingRegionUpdate: MarketingRegionUpdate, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SrcApiAdminSystemFeasibilityMarketingRegionSchemaMarketingRegionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMarketingRegion(uuid, marketingRegionUpdate, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminMarketingRegionsApi.updateMarketingRegion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminMarketingRegionsApi - factory interface
 * @export
 */
export const AdminMarketingRegionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminMarketingRegionsApiFp(configuration)
    return {
        /**
         * Create a new marketing region.
         * @summary Create Marketing Region
         * @param {MarketingRegionCreate} marketingRegionCreate 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMarketingRegion(marketingRegionCreate: MarketingRegionCreate, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<SrcApiAdminSystemFeasibilityMarketingRegionSchemaMarketingRegionResponse> {
            return localVarFp.createMarketingRegion(marketingRegionCreate, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a marketing region and remove its association from zipcodes.
         * @summary Delete Marketing Region
         * @param {string} uuid 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMarketingRegion(uuid: string, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteMarketingRegion(uuid, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a single marketing region by UUID.
         * @summary Get Marketing Region
         * @param {string} uuid 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarketingRegion(uuid: string, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<SrcApiAdminSystemFeasibilityMarketingRegionSchemaMarketingRegionResponse> {
            return localVarFp.getMarketingRegion(uuid, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all marketing regions.
         * @summary Get Marketing Regions
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarketingRegions(requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<Array<SrcApiAdminSystemFeasibilityMarketingRegionSchemaMarketingRegionResponse>> {
            return localVarFp.getMarketingRegions(requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a marketing region.
         * @summary Update Marketing Region
         * @param {string} uuid 
         * @param {MarketingRegionUpdate} marketingRegionUpdate 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMarketingRegion(uuid: string, marketingRegionUpdate: MarketingRegionUpdate, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<SrcApiAdminSystemFeasibilityMarketingRegionSchemaMarketingRegionResponse> {
            return localVarFp.updateMarketingRegion(uuid, marketingRegionUpdate, requestSource, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminMarketingRegionsApi - object-oriented interface
 * @export
 * @class AdminMarketingRegionsApi
 * @extends {BaseAPI}
 */
export class AdminMarketingRegionsApi extends BaseAPI {
    /**
     * Create a new marketing region.
     * @summary Create Marketing Region
     * @param {MarketingRegionCreate} marketingRegionCreate 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminMarketingRegionsApi
     */
    public createMarketingRegion(marketingRegionCreate: MarketingRegionCreate, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminMarketingRegionsApiFp(this.configuration).createMarketingRegion(marketingRegionCreate, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a marketing region and remove its association from zipcodes.
     * @summary Delete Marketing Region
     * @param {string} uuid 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminMarketingRegionsApi
     */
    public deleteMarketingRegion(uuid: string, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminMarketingRegionsApiFp(this.configuration).deleteMarketingRegion(uuid, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a single marketing region by UUID.
     * @summary Get Marketing Region
     * @param {string} uuid 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminMarketingRegionsApi
     */
    public getMarketingRegion(uuid: string, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminMarketingRegionsApiFp(this.configuration).getMarketingRegion(uuid, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all marketing regions.
     * @summary Get Marketing Regions
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminMarketingRegionsApi
     */
    public getMarketingRegions(requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminMarketingRegionsApiFp(this.configuration).getMarketingRegions(requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a marketing region.
     * @summary Update Marketing Region
     * @param {string} uuid 
     * @param {MarketingRegionUpdate} marketingRegionUpdate 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminMarketingRegionsApi
     */
    public updateMarketingRegion(uuid: string, marketingRegionUpdate: MarketingRegionUpdate, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminMarketingRegionsApiFp(this.configuration).updateMarketingRegion(uuid, marketingRegionUpdate, requestSource, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminOpportunityApi - axios parameter creator
 * @export
 */
export const AdminOpportunityApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get closed won opportunities.
         * @summary Admin Get Closed Won Opportunities
         * @param {boolean} [useCache] 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetClosedWonOpportunities: async (useCache?: boolean, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/opportunity/closed-won`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)

            if (useCache !== undefined) {
                localVarQueryParameter['use_cache'] = useCache;
            }


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get recent opportunities.
         * @summary Admin Get Recent Opportunities
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetRecentOpportunities: async (requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/opportunities/recent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search for opportunities by email or ID.
         * @summary Admin Search Customer Opportunities
         * @param {string | null} [email] 
         * @param {string | null} [id] 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSearchCustomerOpportunities: async (email?: string | null, id?: string | null, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/opportunity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminOpportunityApi - functional programming interface
 * @export
 */
export const AdminOpportunityApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminOpportunityApiAxiosParamCreator(configuration)
    return {
        /**
         * Get closed won opportunities.
         * @summary Admin Get Closed Won Opportunities
         * @param {boolean} [useCache] 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetClosedWonOpportunities(useCache?: boolean, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetClosedWonOpportunities(useCache, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOpportunityApi.adminGetClosedWonOpportunities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get recent opportunities.
         * @summary Admin Get Recent Opportunities
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetRecentOpportunities(requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetRecentOpportunities(requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOpportunityApi.adminGetRecentOpportunities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search for opportunities by email or ID.
         * @summary Admin Search Customer Opportunities
         * @param {string | null} [email] 
         * @param {string | null} [id] 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminSearchCustomerOpportunities(email?: string | null, id?: string | null, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminSearchCustomerOpportunities(email, id, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOpportunityApi.adminSearchCustomerOpportunities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminOpportunityApi - factory interface
 * @export
 */
export const AdminOpportunityApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminOpportunityApiFp(configuration)
    return {
        /**
         * Get closed won opportunities.
         * @summary Admin Get Closed Won Opportunities
         * @param {boolean} [useCache] 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetClosedWonOpportunities(useCache?: boolean, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.adminGetClosedWonOpportunities(useCache, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Get recent opportunities.
         * @summary Admin Get Recent Opportunities
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetRecentOpportunities(requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.adminGetRecentOpportunities(requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Search for opportunities by email or ID.
         * @summary Admin Search Customer Opportunities
         * @param {string | null} [email] 
         * @param {string | null} [id] 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSearchCustomerOpportunities(email?: string | null, id?: string | null, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.adminSearchCustomerOpportunities(email, id, requestSource, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminOpportunityApi - object-oriented interface
 * @export
 * @class AdminOpportunityApi
 * @extends {BaseAPI}
 */
export class AdminOpportunityApi extends BaseAPI {
    /**
     * Get closed won opportunities.
     * @summary Admin Get Closed Won Opportunities
     * @param {boolean} [useCache] 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOpportunityApi
     */
    public adminGetClosedWonOpportunities(useCache?: boolean, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminOpportunityApiFp(this.configuration).adminGetClosedWonOpportunities(useCache, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get recent opportunities.
     * @summary Admin Get Recent Opportunities
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOpportunityApi
     */
    public adminGetRecentOpportunities(requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminOpportunityApiFp(this.configuration).adminGetRecentOpportunities(requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search for opportunities by email or ID.
     * @summary Admin Search Customer Opportunities
     * @param {string | null} [email] 
     * @param {string | null} [id] 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOpportunityApi
     */
    public adminSearchCustomerOpportunities(email?: string | null, id?: string | null, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminOpportunityApiFp(this.configuration).adminSearchCustomerOpportunities(email, id, requestSource, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminPrefabFactoryApi - axios parameter creator
 * @export
 */
export const AdminPrefabFactoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new prefab factory.
         * @summary Create Prefab Factory
         * @param {CreatePrefabFactorySchema} createPrefabFactorySchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPrefabFactory: async (createPrefabFactorySchema: CreatePrefabFactorySchema, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createPrefabFactorySchema' is not null or undefined
            assertParamExists('createPrefabFactory', 'createPrefabFactorySchema', createPrefabFactorySchema)
            const localVarPath = `/admin/prefab-factories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPrefabFactorySchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete multiple prefab factories by IDs.  Expects a JSON object with format: {\"prefab_factory_ids\": [uuid1, uuid2, ...]}
         * @summary Delete Prefab Factories
         * @param {DeleteMultiplePrefabFactoriesSchema} deleteMultiplePrefabFactoriesSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePrefabFactories: async (deleteMultiplePrefabFactoriesSchema: DeleteMultiplePrefabFactoriesSchema, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteMultiplePrefabFactoriesSchema' is not null or undefined
            assertParamExists('deletePrefabFactories', 'deleteMultiplePrefabFactoriesSchema', deleteMultiplePrefabFactoriesSchema)
            const localVarPath = `/admin/prefab-factories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteMultiplePrefabFactoriesSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a prefab factory by ID.
         * @summary Delete Prefab Factory
         * @param {string} prefabFactoryId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePrefabFactory: async (prefabFactoryId: string, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'prefabFactoryId' is not null or undefined
            assertParamExists('deletePrefabFactory', 'prefabFactoryId', prefabFactoryId)
            const localVarPath = `/admin/prefab-factories/{prefab_factory_id}`
                .replace(`{${"prefab_factory_id"}}`, encodeURIComponent(String(prefabFactoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all prefab factories.
         * @summary Get Prefab Factories
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrefabFactories: async (requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/prefab-factories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a prefab factory by ID.
         * @summary Get Prefab Factory
         * @param {string} prefabFactoryId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrefabFactory: async (prefabFactoryId: string, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'prefabFactoryId' is not null or undefined
            assertParamExists('getPrefabFactory', 'prefabFactoryId', prefabFactoryId)
            const localVarPath = `/admin/prefab-factories/{prefab_factory_id}`
                .replace(`{${"prefab_factory_id"}}`, encodeURIComponent(String(prefabFactoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing prefab factory.
         * @summary Update Prefab Factory
         * @param {string} prefabFactoryId 
         * @param {UpdatePrefabFactorySchema} updatePrefabFactorySchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePrefabFactory: async (prefabFactoryId: string, updatePrefabFactorySchema: UpdatePrefabFactorySchema, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'prefabFactoryId' is not null or undefined
            assertParamExists('updatePrefabFactory', 'prefabFactoryId', prefabFactoryId)
            // verify required parameter 'updatePrefabFactorySchema' is not null or undefined
            assertParamExists('updatePrefabFactory', 'updatePrefabFactorySchema', updatePrefabFactorySchema)
            const localVarPath = `/admin/prefab-factories/{prefab_factory_id}`
                .replace(`{${"prefab_factory_id"}}`, encodeURIComponent(String(prefabFactoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePrefabFactorySchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminPrefabFactoryApi - functional programming interface
 * @export
 */
export const AdminPrefabFactoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminPrefabFactoryApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new prefab factory.
         * @summary Create Prefab Factory
         * @param {CreatePrefabFactorySchema} createPrefabFactorySchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPrefabFactory(createPrefabFactorySchema: CreatePrefabFactorySchema, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrefabFactorySchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPrefabFactory(createPrefabFactorySchema, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminPrefabFactoryApi.createPrefabFactory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete multiple prefab factories by IDs.  Expects a JSON object with format: {\"prefab_factory_ids\": [uuid1, uuid2, ...]}
         * @summary Delete Prefab Factories
         * @param {DeleteMultiplePrefabFactoriesSchema} deleteMultiplePrefabFactoriesSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePrefabFactories(deleteMultiplePrefabFactoriesSchema: DeleteMultiplePrefabFactoriesSchema, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrefabFactoryDeleteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePrefabFactories(deleteMultiplePrefabFactoriesSchema, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminPrefabFactoryApi.deletePrefabFactories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a prefab factory by ID.
         * @summary Delete Prefab Factory
         * @param {string} prefabFactoryId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePrefabFactory(prefabFactoryId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrefabFactoryDeleteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePrefabFactory(prefabFactoryId, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminPrefabFactoryApi.deletePrefabFactory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all prefab factories.
         * @summary Get Prefab Factories
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPrefabFactories(requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PrefabFactorySchema>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPrefabFactories(requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminPrefabFactoryApi.getPrefabFactories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a prefab factory by ID.
         * @summary Get Prefab Factory
         * @param {string} prefabFactoryId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPrefabFactory(prefabFactoryId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrefabFactorySchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPrefabFactory(prefabFactoryId, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminPrefabFactoryApi.getPrefabFactory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing prefab factory.
         * @summary Update Prefab Factory
         * @param {string} prefabFactoryId 
         * @param {UpdatePrefabFactorySchema} updatePrefabFactorySchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePrefabFactory(prefabFactoryId: string, updatePrefabFactorySchema: UpdatePrefabFactorySchema, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrefabFactorySchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePrefabFactory(prefabFactoryId, updatePrefabFactorySchema, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminPrefabFactoryApi.updatePrefabFactory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminPrefabFactoryApi - factory interface
 * @export
 */
export const AdminPrefabFactoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminPrefabFactoryApiFp(configuration)
    return {
        /**
         * Create a new prefab factory.
         * @summary Create Prefab Factory
         * @param {CreatePrefabFactorySchema} createPrefabFactorySchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPrefabFactory(createPrefabFactorySchema: CreatePrefabFactorySchema, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<PrefabFactorySchema> {
            return localVarFp.createPrefabFactory(createPrefabFactorySchema, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete multiple prefab factories by IDs.  Expects a JSON object with format: {\"prefab_factory_ids\": [uuid1, uuid2, ...]}
         * @summary Delete Prefab Factories
         * @param {DeleteMultiplePrefabFactoriesSchema} deleteMultiplePrefabFactoriesSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePrefabFactories(deleteMultiplePrefabFactoriesSchema: DeleteMultiplePrefabFactoriesSchema, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<PrefabFactoryDeleteResponse> {
            return localVarFp.deletePrefabFactories(deleteMultiplePrefabFactoriesSchema, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a prefab factory by ID.
         * @summary Delete Prefab Factory
         * @param {string} prefabFactoryId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePrefabFactory(prefabFactoryId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<PrefabFactoryDeleteResponse> {
            return localVarFp.deletePrefabFactory(prefabFactoryId, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all prefab factories.
         * @summary Get Prefab Factories
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrefabFactories(requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<Array<PrefabFactorySchema>> {
            return localVarFp.getPrefabFactories(requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a prefab factory by ID.
         * @summary Get Prefab Factory
         * @param {string} prefabFactoryId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrefabFactory(prefabFactoryId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<PrefabFactorySchema> {
            return localVarFp.getPrefabFactory(prefabFactoryId, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing prefab factory.
         * @summary Update Prefab Factory
         * @param {string} prefabFactoryId 
         * @param {UpdatePrefabFactorySchema} updatePrefabFactorySchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePrefabFactory(prefabFactoryId: string, updatePrefabFactorySchema: UpdatePrefabFactorySchema, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<PrefabFactorySchema> {
            return localVarFp.updatePrefabFactory(prefabFactoryId, updatePrefabFactorySchema, requestSource, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminPrefabFactoryApi - object-oriented interface
 * @export
 * @class AdminPrefabFactoryApi
 * @extends {BaseAPI}
 */
export class AdminPrefabFactoryApi extends BaseAPI {
    /**
     * Create a new prefab factory.
     * @summary Create Prefab Factory
     * @param {CreatePrefabFactorySchema} createPrefabFactorySchema 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPrefabFactoryApi
     */
    public createPrefabFactory(createPrefabFactorySchema: CreatePrefabFactorySchema, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminPrefabFactoryApiFp(this.configuration).createPrefabFactory(createPrefabFactorySchema, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete multiple prefab factories by IDs.  Expects a JSON object with format: {\"prefab_factory_ids\": [uuid1, uuid2, ...]}
     * @summary Delete Prefab Factories
     * @param {DeleteMultiplePrefabFactoriesSchema} deleteMultiplePrefabFactoriesSchema 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPrefabFactoryApi
     */
    public deletePrefabFactories(deleteMultiplePrefabFactoriesSchema: DeleteMultiplePrefabFactoriesSchema, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminPrefabFactoryApiFp(this.configuration).deletePrefabFactories(deleteMultiplePrefabFactoriesSchema, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a prefab factory by ID.
     * @summary Delete Prefab Factory
     * @param {string} prefabFactoryId 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPrefabFactoryApi
     */
    public deletePrefabFactory(prefabFactoryId: string, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminPrefabFactoryApiFp(this.configuration).deletePrefabFactory(prefabFactoryId, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all prefab factories.
     * @summary Get Prefab Factories
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPrefabFactoryApi
     */
    public getPrefabFactories(requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminPrefabFactoryApiFp(this.configuration).getPrefabFactories(requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a prefab factory by ID.
     * @summary Get Prefab Factory
     * @param {string} prefabFactoryId 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPrefabFactoryApi
     */
    public getPrefabFactory(prefabFactoryId: string, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminPrefabFactoryApiFp(this.configuration).getPrefabFactory(prefabFactoryId, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing prefab factory.
     * @summary Update Prefab Factory
     * @param {string} prefabFactoryId 
     * @param {UpdatePrefabFactorySchema} updatePrefabFactorySchema 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPrefabFactoryApi
     */
    public updatePrefabFactory(prefabFactoryId: string, updatePrefabFactorySchema: UpdatePrefabFactorySchema, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminPrefabFactoryApiFp(this.configuration).updatePrefabFactory(prefabFactoryId, updatePrefabFactorySchema, requestSource, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminSmartsheetApi - axios parameter creator
 * @export
 */
export const AdminSmartsheetApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Calculates the next available project ID based on existing numbered folders in the main project workspace.
         * @summary Get Next Available Smartsheet Project ID
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNextAvailableSmartsheetProjectId: async (requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/smartsheet/next-project-id`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Accepts project provisioning data, creates Smartsheet folder, and updates metadata.
         * @summary Provision Smartsheet Project
         * @param {ProjectProvisioningPayload} projectProvisioningPayload 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        provisionSmartsheetProject: async (projectProvisioningPayload: ProjectProvisioningPayload, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectProvisioningPayload' is not null or undefined
            assertParamExists('provisionSmartsheetProject', 'projectProvisioningPayload', projectProvisioningPayload)
            const localVarPath = `/admin/smartsheet/provisioned-project`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectProvisioningPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminSmartsheetApi - functional programming interface
 * @export
 */
export const AdminSmartsheetApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminSmartsheetApiAxiosParamCreator(configuration)
    return {
        /**
         * Calculates the next available project ID based on existing numbered folders in the main project workspace.
         * @summary Get Next Available Smartsheet Project ID
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNextAvailableSmartsheetProjectId(requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: number; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNextAvailableSmartsheetProjectId(requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSmartsheetApi.getNextAvailableSmartsheetProjectId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Accepts project provisioning data, creates Smartsheet folder, and updates metadata.
         * @summary Provision Smartsheet Project
         * @param {ProjectProvisioningPayload} projectProvisioningPayload 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async provisionSmartsheetProject(projectProvisioningPayload: ProjectProvisioningPayload, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.provisionSmartsheetProject(projectProvisioningPayload, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSmartsheetApi.provisionSmartsheetProject']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminSmartsheetApi - factory interface
 * @export
 */
export const AdminSmartsheetApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminSmartsheetApiFp(configuration)
    return {
        /**
         * Calculates the next available project ID based on existing numbered folders in the main project workspace.
         * @summary Get Next Available Smartsheet Project ID
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNextAvailableSmartsheetProjectId(requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: number; }> {
            return localVarFp.getNextAvailableSmartsheetProjectId(requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Accepts project provisioning data, creates Smartsheet folder, and updates metadata.
         * @summary Provision Smartsheet Project
         * @param {ProjectProvisioningPayload} projectProvisioningPayload 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        provisionSmartsheetProject(projectProvisioningPayload: ProjectProvisioningPayload, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.provisionSmartsheetProject(projectProvisioningPayload, requestSource, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminSmartsheetApi - object-oriented interface
 * @export
 * @class AdminSmartsheetApi
 * @extends {BaseAPI}
 */
export class AdminSmartsheetApi extends BaseAPI {
    /**
     * Calculates the next available project ID based on existing numbered folders in the main project workspace.
     * @summary Get Next Available Smartsheet Project ID
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSmartsheetApi
     */
    public getNextAvailableSmartsheetProjectId(requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminSmartsheetApiFp(this.configuration).getNextAvailableSmartsheetProjectId(requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Accepts project provisioning data, creates Smartsheet folder, and updates metadata.
     * @summary Provision Smartsheet Project
     * @param {ProjectProvisioningPayload} projectProvisioningPayload 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSmartsheetApi
     */
    public provisionSmartsheetProject(projectProvisioningPayload: ProjectProvisioningPayload, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminSmartsheetApiFp(this.configuration).provisionSmartsheetProject(projectProvisioningPayload, requestSource, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminSystemApi - axios parameter creator
 * @export
 */
export const AdminSystemApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves the count of total and D2C leads created per month from Salesforce. Optionally filters for a specific month or a range of months using query parameters. - If neither start_month nor end_month is provided, returns all months. - If only one is provided, filters for that specific month. - If both are provided, filters for the inclusive range.
         * @summary Get Number of Leads Created by Month
         * @param {string | null} [startMonth] Filter results starting from this month (YYYY-MM). If only start_month is provided, filters for this specific month.
         * @param {string | null} [endMonth] Filter results ending at this month (YYYY-MM, inclusive). If only end_month is provided, filters for this specific month.
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNumberOfLeadsCreatedByMonth: async (startMonth?: string | null, endMonth?: string | null, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/salesforce/reporting/cohorts/leads-by-month`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)

            if (startMonth !== undefined) {
                localVarQueryParameter['start_month'] = startMonth;
            }

            if (endMonth !== undefined) {
                localVarQueryParameter['end_month'] = endMonth;
            }


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the count of total and D2C leads created per month from Salesforce. Optionally filters for a specific month or a range of months using query parameters. - If neither start_month nor end_month is provided, returns all months. - If only one is provided, filters for that specific month. - If both are provided, filters for the inclusive range.
         * @summary Get Number of Leads Created by Month
         * @param {string | null} [startMonth] Filter results starting from this month (YYYY-MM). If only start_month is provided, filters for this specific month.
         * @param {string | null} [endMonth] Filter results ending at this month (YYYY-MM, inclusive). If only end_month is provided, filters for this specific month.
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNumberOfLeadsCreatedByMonth_1: async (startMonth?: string | null, endMonth?: string | null, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/salesforce/reporting/cohorts/leads-by-month`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)

            if (startMonth !== undefined) {
                localVarQueryParameter['start_month'] = startMonth;
            }

            if (endMonth !== undefined) {
                localVarQueryParameter['end_month'] = endMonth;
            }


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Placeholder Salesforce Reporting Endpoint
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placeholderSalesforceReportingEndpoint: async (requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/salesforce/reporting/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminSystemApi - functional programming interface
 * @export
 */
export const AdminSystemApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminSystemApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves the count of total and D2C leads created per month from Salesforce. Optionally filters for a specific month or a range of months using query parameters. - If neither start_month nor end_month is provided, returns all months. - If only one is provided, filters for that specific month. - If both are provided, filters for the inclusive range.
         * @summary Get Number of Leads Created by Month
         * @param {string | null} [startMonth] Filter results starting from this month (YYYY-MM). If only start_month is provided, filters for this specific month.
         * @param {string | null} [endMonth] Filter results ending at this month (YYYY-MM, inclusive). If only end_month is provided, filters for this specific month.
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNumberOfLeadsCreatedByMonth(startMonth?: string | null, endMonth?: string | null, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LeadsByMonthResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNumberOfLeadsCreatedByMonth(startMonth, endMonth, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSystemApi.getNumberOfLeadsCreatedByMonth']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the count of total and D2C leads created per month from Salesforce. Optionally filters for a specific month or a range of months using query parameters. - If neither start_month nor end_month is provided, returns all months. - If only one is provided, filters for that specific month. - If both are provided, filters for the inclusive range.
         * @summary Get Number of Leads Created by Month
         * @param {string | null} [startMonth] Filter results starting from this month (YYYY-MM). If only start_month is provided, filters for this specific month.
         * @param {string | null} [endMonth] Filter results ending at this month (YYYY-MM, inclusive). If only end_month is provided, filters for this specific month.
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNumberOfLeadsCreatedByMonth_1(startMonth?: string | null, endMonth?: string | null, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LeadsByMonthResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNumberOfLeadsCreatedByMonth_1(startMonth, endMonth, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSystemApi.getNumberOfLeadsCreatedByMonth_1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Placeholder Salesforce Reporting Endpoint
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async placeholderSalesforceReportingEndpoint(requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.placeholderSalesforceReportingEndpoint(requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSystemApi.placeholderSalesforceReportingEndpoint']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminSystemApi - factory interface
 * @export
 */
export const AdminSystemApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminSystemApiFp(configuration)
    return {
        /**
         * Retrieves the count of total and D2C leads created per month from Salesforce. Optionally filters for a specific month or a range of months using query parameters. - If neither start_month nor end_month is provided, returns all months. - If only one is provided, filters for that specific month. - If both are provided, filters for the inclusive range.
         * @summary Get Number of Leads Created by Month
         * @param {string | null} [startMonth] Filter results starting from this month (YYYY-MM). If only start_month is provided, filters for this specific month.
         * @param {string | null} [endMonth] Filter results ending at this month (YYYY-MM, inclusive). If only end_month is provided, filters for this specific month.
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNumberOfLeadsCreatedByMonth(startMonth?: string | null, endMonth?: string | null, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<LeadsByMonthResponse> {
            return localVarFp.getNumberOfLeadsCreatedByMonth(startMonth, endMonth, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the count of total and D2C leads created per month from Salesforce. Optionally filters for a specific month or a range of months using query parameters. - If neither start_month nor end_month is provided, returns all months. - If only one is provided, filters for that specific month. - If both are provided, filters for the inclusive range.
         * @summary Get Number of Leads Created by Month
         * @param {string | null} [startMonth] Filter results starting from this month (YYYY-MM). If only start_month is provided, filters for this specific month.
         * @param {string | null} [endMonth] Filter results ending at this month (YYYY-MM, inclusive). If only end_month is provided, filters for this specific month.
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNumberOfLeadsCreatedByMonth_1(startMonth?: string | null, endMonth?: string | null, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<LeadsByMonthResponse> {
            return localVarFp.getNumberOfLeadsCreatedByMonth_1(startMonth, endMonth, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Placeholder Salesforce Reporting Endpoint
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placeholderSalesforceReportingEndpoint(requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.placeholderSalesforceReportingEndpoint(requestSource, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminSystemApi - object-oriented interface
 * @export
 * @class AdminSystemApi
 * @extends {BaseAPI}
 */
export class AdminSystemApi extends BaseAPI {
    /**
     * Retrieves the count of total and D2C leads created per month from Salesforce. Optionally filters for a specific month or a range of months using query parameters. - If neither start_month nor end_month is provided, returns all months. - If only one is provided, filters for that specific month. - If both are provided, filters for the inclusive range.
     * @summary Get Number of Leads Created by Month
     * @param {string | null} [startMonth] Filter results starting from this month (YYYY-MM). If only start_month is provided, filters for this specific month.
     * @param {string | null} [endMonth] Filter results ending at this month (YYYY-MM, inclusive). If only end_month is provided, filters for this specific month.
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSystemApi
     */
    public getNumberOfLeadsCreatedByMonth(startMonth?: string | null, endMonth?: string | null, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminSystemApiFp(this.configuration).getNumberOfLeadsCreatedByMonth(startMonth, endMonth, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the count of total and D2C leads created per month from Salesforce. Optionally filters for a specific month or a range of months using query parameters. - If neither start_month nor end_month is provided, returns all months. - If only one is provided, filters for that specific month. - If both are provided, filters for the inclusive range.
     * @summary Get Number of Leads Created by Month
     * @param {string | null} [startMonth] Filter results starting from this month (YYYY-MM). If only start_month is provided, filters for this specific month.
     * @param {string | null} [endMonth] Filter results ending at this month (YYYY-MM, inclusive). If only end_month is provided, filters for this specific month.
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSystemApi
     */
    public getNumberOfLeadsCreatedByMonth_1(startMonth?: string | null, endMonth?: string | null, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminSystemApiFp(this.configuration).getNumberOfLeadsCreatedByMonth_1(startMonth, endMonth, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Placeholder Salesforce Reporting Endpoint
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSystemApi
     */
    public placeholderSalesforceReportingEndpoint(requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminSystemApiFp(this.configuration).placeholderSalesforceReportingEndpoint(requestSource, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminVendorApi - axios parameter creator
 * @export
 */
export const AdminVendorApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add Software Vendor
         * @param {SoftwareVendorSchema} softwareVendorSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSoftwareVendor: async (softwareVendorSchema: SoftwareVendorSchema, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'softwareVendorSchema' is not null or undefined
            assertParamExists('addSoftwareVendor', 'softwareVendorSchema', softwareVendorSchema)
            const localVarPath = `/admin/vendor/software`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(softwareVendorSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Software Vendor
         * @param {string} vendorId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSoftwareVendor: async (vendorId: string, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vendorId' is not null or undefined
            assertParamExists('deleteSoftwareVendor', 'vendorId', vendorId)
            const localVarPath = `/admin/vendor/software`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)

            if (vendorId !== undefined) {
                localVarQueryParameter['vendor_id'] = vendorId;
            }


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Software Vendors
         * @param {Array<string | null>} requestBody 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSoftwareVendors: async (requestBody: Array<string | null>, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('deleteSoftwareVendors', 'requestBody', requestBody)
            const localVarPath = `/admin/vendor/software/multiple`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Software Vendors
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSoftwareVendors: async (requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/vendor/software`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminVendorApi - functional programming interface
 * @export
 */
export const AdminVendorApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminVendorApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add Software Vendor
         * @param {SoftwareVendorSchema} softwareVendorSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addSoftwareVendor(softwareVendorSchema: SoftwareVendorSchema, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SoftwareVendorSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addSoftwareVendor(softwareVendorSchema, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminVendorApi.addSoftwareVendor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Software Vendor
         * @param {string} vendorId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSoftwareVendor(vendorId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSoftwareVendor(vendorId, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminVendorApi.deleteSoftwareVendor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Software Vendors
         * @param {Array<string | null>} requestBody 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSoftwareVendors(requestBody: Array<string | null>, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSoftwareVendors(requestBody, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminVendorApi.deleteSoftwareVendors']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Software Vendors
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSoftwareVendors(requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SoftwareVendorSchema>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSoftwareVendors(requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminVendorApi.getSoftwareVendors']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminVendorApi - factory interface
 * @export
 */
export const AdminVendorApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminVendorApiFp(configuration)
    return {
        /**
         * 
         * @summary Add Software Vendor
         * @param {SoftwareVendorSchema} softwareVendorSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSoftwareVendor(softwareVendorSchema: SoftwareVendorSchema, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<SoftwareVendorSchema> {
            return localVarFp.addSoftwareVendor(softwareVendorSchema, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Software Vendor
         * @param {string} vendorId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSoftwareVendor(vendorId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteSoftwareVendor(vendorId, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Software Vendors
         * @param {Array<string | null>} requestBody 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSoftwareVendors(requestBody: Array<string | null>, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteSoftwareVendors(requestBody, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Software Vendors
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSoftwareVendors(requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<Array<SoftwareVendorSchema>> {
            return localVarFp.getSoftwareVendors(requestSource, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminVendorApi - object-oriented interface
 * @export
 * @class AdminVendorApi
 * @extends {BaseAPI}
 */
export class AdminVendorApi extends BaseAPI {
    /**
     * 
     * @summary Add Software Vendor
     * @param {SoftwareVendorSchema} softwareVendorSchema 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminVendorApi
     */
    public addSoftwareVendor(softwareVendorSchema: SoftwareVendorSchema, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminVendorApiFp(this.configuration).addSoftwareVendor(softwareVendorSchema, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Software Vendor
     * @param {string} vendorId 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminVendorApi
     */
    public deleteSoftwareVendor(vendorId: string, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminVendorApiFp(this.configuration).deleteSoftwareVendor(vendorId, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Software Vendors
     * @param {Array<string | null>} requestBody 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminVendorApi
     */
    public deleteSoftwareVendors(requestBody: Array<string | null>, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminVendorApiFp(this.configuration).deleteSoftwareVendors(requestBody, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Software Vendors
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminVendorApi
     */
    public getSoftwareVendors(requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AdminVendorApiFp(this.configuration).getSoftwareVendors(requestSource, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AppAhjsApi - axios parameter creator
 * @export
 */
export const AppAhjsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get App Ahjs
         * @param {number} latitude 
         * @param {number} longitude 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppAhjs: async (latitude: number, longitude: number, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'latitude' is not null or undefined
            assertParamExists('getAppAhjs', 'latitude', latitude)
            // verify required parameter 'longitude' is not null or undefined
            assertParamExists('getAppAhjs', 'longitude', longitude)
            const localVarPath = `/ahjs-by-lat-long`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (latitude !== undefined) {
                localVarQueryParameter['latitude'] = latitude;
            }

            if (longitude !== undefined) {
                localVarQueryParameter['longitude'] = longitude;
            }


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AppAhjsApi - functional programming interface
 * @export
 */
export const AppAhjsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AppAhjsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get App Ahjs
         * @param {number} latitude 
         * @param {number} longitude 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppAhjs(latitude: number, longitude: number, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppAhjs(latitude, longitude, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppAhjsApi.getAppAhjs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AppAhjsApi - factory interface
 * @export
 */
export const AppAhjsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AppAhjsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get App Ahjs
         * @param {number} latitude 
         * @param {number} longitude 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppAhjs(latitude: number, longitude: number, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getAppAhjs(latitude, longitude, requestSource, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AppAhjsApi - object-oriented interface
 * @export
 * @class AppAhjsApi
 * @extends {BaseAPI}
 */
export class AppAhjsApi extends BaseAPI {
    /**
     * 
     * @summary Get App Ahjs
     * @param {number} latitude 
     * @param {number} longitude 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppAhjsApi
     */
    public getAppAhjs(latitude: number, longitude: number, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return AppAhjsApiFp(this.configuration).getAppAhjs(latitude, longitude, requestSource, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CohortsApi - axios parameter creator
 * @export
 */
export const CohortsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves the count of total and D2C leads created per month from Salesforce. Optionally filters for a specific month or a range of months using query parameters. - If neither start_month nor end_month is provided, returns all months. - If only one is provided, filters for that specific month. - If both are provided, filters for the inclusive range.
         * @summary Get Number of Leads Created by Month
         * @param {string | null} [startMonth] Filter results starting from this month (YYYY-MM). If only start_month is provided, filters for this specific month.
         * @param {string | null} [endMonth] Filter results ending at this month (YYYY-MM, inclusive). If only end_month is provided, filters for this specific month.
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNumberOfLeadsCreatedByMonth: async (startMonth?: string | null, endMonth?: string | null, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/salesforce/reporting/cohorts/leads-by-month`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)

            if (startMonth !== undefined) {
                localVarQueryParameter['start_month'] = startMonth;
            }

            if (endMonth !== undefined) {
                localVarQueryParameter['end_month'] = endMonth;
            }


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CohortsApi - functional programming interface
 * @export
 */
export const CohortsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CohortsApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves the count of total and D2C leads created per month from Salesforce. Optionally filters for a specific month or a range of months using query parameters. - If neither start_month nor end_month is provided, returns all months. - If only one is provided, filters for that specific month. - If both are provided, filters for the inclusive range.
         * @summary Get Number of Leads Created by Month
         * @param {string | null} [startMonth] Filter results starting from this month (YYYY-MM). If only start_month is provided, filters for this specific month.
         * @param {string | null} [endMonth] Filter results ending at this month (YYYY-MM, inclusive). If only end_month is provided, filters for this specific month.
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNumberOfLeadsCreatedByMonth(startMonth?: string | null, endMonth?: string | null, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LeadsByMonthResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNumberOfLeadsCreatedByMonth(startMonth, endMonth, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CohortsApi.getNumberOfLeadsCreatedByMonth']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CohortsApi - factory interface
 * @export
 */
export const CohortsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CohortsApiFp(configuration)
    return {
        /**
         * Retrieves the count of total and D2C leads created per month from Salesforce. Optionally filters for a specific month or a range of months using query parameters. - If neither start_month nor end_month is provided, returns all months. - If only one is provided, filters for that specific month. - If both are provided, filters for the inclusive range.
         * @summary Get Number of Leads Created by Month
         * @param {string | null} [startMonth] Filter results starting from this month (YYYY-MM). If only start_month is provided, filters for this specific month.
         * @param {string | null} [endMonth] Filter results ending at this month (YYYY-MM, inclusive). If only end_month is provided, filters for this specific month.
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNumberOfLeadsCreatedByMonth(startMonth?: string | null, endMonth?: string | null, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<LeadsByMonthResponse> {
            return localVarFp.getNumberOfLeadsCreatedByMonth(startMonth, endMonth, requestSource, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CohortsApi - object-oriented interface
 * @export
 * @class CohortsApi
 * @extends {BaseAPI}
 */
export class CohortsApi extends BaseAPI {
    /**
     * Retrieves the count of total and D2C leads created per month from Salesforce. Optionally filters for a specific month or a range of months using query parameters. - If neither start_month nor end_month is provided, returns all months. - If only one is provided, filters for that specific month. - If both are provided, filters for the inclusive range.
     * @summary Get Number of Leads Created by Month
     * @param {string | null} [startMonth] Filter results starting from this month (YYYY-MM). If only start_month is provided, filters for this specific month.
     * @param {string | null} [endMonth] Filter results ending at this month (YYYY-MM, inclusive). If only end_month is provided, filters for this specific month.
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CohortsApi
     */
    public getNumberOfLeadsCreatedByMonth(startMonth?: string | null, endMonth?: string | null, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return CohortsApiFp(this.configuration).getNumberOfLeadsCreatedByMonth(startMonth, endMonth, requestSource, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CostCodesApi - axios parameter creator
 * @export
 */
export const CostCodesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new cost code.
         * @summary Create Cost Code
         * @param {CreateCostCodeSchema} createCostCodeSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCostCode: async (createCostCodeSchema: CreateCostCodeSchema, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCostCodeSchema' is not null or undefined
            assertParamExists('createCostCode', 'createCostCodeSchema', createCostCodeSchema)
            const localVarPath = `/admin/cost-codes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCostCodeSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new Segment 1 entry.
         * @summary Create Segment1
         * @param {CreateSegment1Schema} createSegment1Schema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSegment1: async (createSegment1Schema: CreateSegment1Schema, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createSegment1Schema' is not null or undefined
            assertParamExists('createSegment1', 'createSegment1Schema', createSegment1Schema)
            const localVarPath = `/admin/cost-codes/segment1`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSegment1Schema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new Segment 2 entry.
         * @summary Create Segment2
         * @param {CreateSegment2Schema} createSegment2Schema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSegment2: async (createSegment2Schema: CreateSegment2Schema, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createSegment2Schema' is not null or undefined
            assertParamExists('createSegment2', 'createSegment2Schema', createSegment2Schema)
            const localVarPath = `/admin/cost-codes/segment2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSegment2Schema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a cost code.
         * @summary Delete Cost Code
         * @param {string} codeId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCostCode: async (codeId: string, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'codeId' is not null or undefined
            assertParamExists('deleteCostCode', 'codeId', codeId)
            const localVarPath = `/admin/cost-codes/{code_id}`
                .replace(`{${"code_id"}}`, encodeURIComponent(String(codeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a Segment 1 entry.
         * @summary Delete Segment1
         * @param {string} code 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSegment1: async (code: string, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('deleteSegment1', 'code', code)
            const localVarPath = `/admin/cost-codes/segment1/{code}`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all cost codes.
         * @summary Get All Cost Codes
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCostCodes: async (requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/cost-codes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all segment 1 entries.
         * @summary Get All Segments1
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSegments1: async (requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/cost-codes/segment1`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all segment 2 entries.
         * @summary Get All Segments2
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSegments2: async (requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/cost-codes/segment2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific cost code by ID.
         * @summary Get Cost Code
         * @param {string} codeId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCostCode: async (codeId: string, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'codeId' is not null or undefined
            assertParamExists('getCostCode', 'codeId', codeId)
            const localVarPath = `/admin/cost-codes/{code_id}`
                .replace(`{${"code_id"}}`, encodeURIComponent(String(codeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all cost codes related to units (segment1=50, segment2=04).
         * @summary Get Unit Cost Codes
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnitCostCodes: async (requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/cost-codes/units`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing cost code.
         * @summary Update Cost Code
         * @param {string} codeId 
         * @param {{ [key: string]: any; }} requestBody 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCostCode: async (codeId: string, requestBody: { [key: string]: any; }, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'codeId' is not null or undefined
            assertParamExists('updateCostCode', 'codeId', codeId)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('updateCostCode', 'requestBody', requestBody)
            const localVarPath = `/admin/cost-codes/{code_id}`
                .replace(`{${"code_id"}}`, encodeURIComponent(String(codeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a Segment 1 entry.
         * @summary Update Segment1
         * @param {string} uuid 
         * @param {UpdateSegment1Schema} updateSegment1Schema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSegment1: async (uuid: string, updateSegment1Schema: UpdateSegment1Schema, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('updateSegment1', 'uuid', uuid)
            // verify required parameter 'updateSegment1Schema' is not null or undefined
            assertParamExists('updateSegment1', 'updateSegment1Schema', updateSegment1Schema)
            const localVarPath = `/admin/cost-codes/segment1/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSegment1Schema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a Segment 2 entry.
         * @summary Update Segment2
         * @param {string} uuid 
         * @param {UpdateSegment2Schema} updateSegment2Schema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSegment2: async (uuid: string, updateSegment2Schema: UpdateSegment2Schema, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('updateSegment2', 'uuid', uuid)
            // verify required parameter 'updateSegment2Schema' is not null or undefined
            assertParamExists('updateSegment2', 'updateSegment2Schema', updateSegment2Schema)
            const localVarPath = `/admin/cost-codes/segment2/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSegment2Schema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CostCodesApi - functional programming interface
 * @export
 */
export const CostCodesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CostCodesApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new cost code.
         * @summary Create Cost Code
         * @param {CreateCostCodeSchema} createCostCodeSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCostCode(createCostCodeSchema: CreateCostCodeSchema, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCostCode(createCostCodeSchema, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CostCodesApi.createCostCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new Segment 1 entry.
         * @summary Create Segment1
         * @param {CreateSegment1Schema} createSegment1Schema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSegment1(createSegment1Schema: CreateSegment1Schema, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSegment1(createSegment1Schema, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CostCodesApi.createSegment1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new Segment 2 entry.
         * @summary Create Segment2
         * @param {CreateSegment2Schema} createSegment2Schema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSegment2(createSegment2Schema: CreateSegment2Schema, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSegment2(createSegment2Schema, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CostCodesApi.createSegment2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a cost code.
         * @summary Delete Cost Code
         * @param {string} codeId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCostCode(codeId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCostCode(codeId, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CostCodesApi.deleteCostCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a Segment 1 entry.
         * @summary Delete Segment1
         * @param {string} code 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSegment1(code: string, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSegment1(code, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CostCodesApi.deleteSegment1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all cost codes.
         * @summary Get All Cost Codes
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllCostCodes(requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllCostCodes(requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CostCodesApi.getAllCostCodes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all segment 1 entries.
         * @summary Get All Segments1
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllSegments1(requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllSegments1(requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CostCodesApi.getAllSegments1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all segment 2 entries.
         * @summary Get All Segments2
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllSegments2(requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllSegments2(requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CostCodesApi.getAllSegments2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a specific cost code by ID.
         * @summary Get Cost Code
         * @param {string} codeId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCostCode(codeId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCostCode(codeId, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CostCodesApi.getCostCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all cost codes related to units (segment1=50, segment2=04).
         * @summary Get Unit Cost Codes
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUnitCostCodes(requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUnitCostCodes(requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CostCodesApi.getUnitCostCodes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing cost code.
         * @summary Update Cost Code
         * @param {string} codeId 
         * @param {{ [key: string]: any; }} requestBody 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCostCode(codeId: string, requestBody: { [key: string]: any; }, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCostCode(codeId, requestBody, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CostCodesApi.updateCostCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a Segment 1 entry.
         * @summary Update Segment1
         * @param {string} uuid 
         * @param {UpdateSegment1Schema} updateSegment1Schema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSegment1(uuid: string, updateSegment1Schema: UpdateSegment1Schema, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSegment1(uuid, updateSegment1Schema, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CostCodesApi.updateSegment1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a Segment 2 entry.
         * @summary Update Segment2
         * @param {string} uuid 
         * @param {UpdateSegment2Schema} updateSegment2Schema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSegment2(uuid: string, updateSegment2Schema: UpdateSegment2Schema, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSegment2(uuid, updateSegment2Schema, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CostCodesApi.updateSegment2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CostCodesApi - factory interface
 * @export
 */
export const CostCodesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CostCodesApiFp(configuration)
    return {
        /**
         * Create a new cost code.
         * @summary Create Cost Code
         * @param {CreateCostCodeSchema} createCostCodeSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCostCode(createCostCodeSchema: CreateCostCodeSchema, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.createCostCode(createCostCodeSchema, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new Segment 1 entry.
         * @summary Create Segment1
         * @param {CreateSegment1Schema} createSegment1Schema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSegment1(createSegment1Schema: CreateSegment1Schema, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.createSegment1(createSegment1Schema, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new Segment 2 entry.
         * @summary Create Segment2
         * @param {CreateSegment2Schema} createSegment2Schema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSegment2(createSegment2Schema: CreateSegment2Schema, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.createSegment2(createSegment2Schema, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a cost code.
         * @summary Delete Cost Code
         * @param {string} codeId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCostCode(codeId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteCostCode(codeId, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a Segment 1 entry.
         * @summary Delete Segment1
         * @param {string} code 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSegment1(code: string, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteSegment1(code, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all cost codes.
         * @summary Get All Cost Codes
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCostCodes(requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getAllCostCodes(requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all segment 1 entries.
         * @summary Get All Segments1
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSegments1(requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getAllSegments1(requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all segment 2 entries.
         * @summary Get All Segments2
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSegments2(requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getAllSegments2(requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific cost code by ID.
         * @summary Get Cost Code
         * @param {string} codeId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCostCode(codeId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getCostCode(codeId, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all cost codes related to units (segment1=50, segment2=04).
         * @summary Get Unit Cost Codes
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnitCostCodes(requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getUnitCostCodes(requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing cost code.
         * @summary Update Cost Code
         * @param {string} codeId 
         * @param {{ [key: string]: any; }} requestBody 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCostCode(codeId: string, requestBody: { [key: string]: any; }, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.updateCostCode(codeId, requestBody, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a Segment 1 entry.
         * @summary Update Segment1
         * @param {string} uuid 
         * @param {UpdateSegment1Schema} updateSegment1Schema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSegment1(uuid: string, updateSegment1Schema: UpdateSegment1Schema, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.updateSegment1(uuid, updateSegment1Schema, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a Segment 2 entry.
         * @summary Update Segment2
         * @param {string} uuid 
         * @param {UpdateSegment2Schema} updateSegment2Schema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSegment2(uuid: string, updateSegment2Schema: UpdateSegment2Schema, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.updateSegment2(uuid, updateSegment2Schema, requestSource, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CostCodesApi - object-oriented interface
 * @export
 * @class CostCodesApi
 * @extends {BaseAPI}
 */
export class CostCodesApi extends BaseAPI {
    /**
     * Create a new cost code.
     * @summary Create Cost Code
     * @param {CreateCostCodeSchema} createCostCodeSchema 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CostCodesApi
     */
    public createCostCode(createCostCodeSchema: CreateCostCodeSchema, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return CostCodesApiFp(this.configuration).createCostCode(createCostCodeSchema, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new Segment 1 entry.
     * @summary Create Segment1
     * @param {CreateSegment1Schema} createSegment1Schema 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CostCodesApi
     */
    public createSegment1(createSegment1Schema: CreateSegment1Schema, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return CostCodesApiFp(this.configuration).createSegment1(createSegment1Schema, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new Segment 2 entry.
     * @summary Create Segment2
     * @param {CreateSegment2Schema} createSegment2Schema 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CostCodesApi
     */
    public createSegment2(createSegment2Schema: CreateSegment2Schema, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return CostCodesApiFp(this.configuration).createSegment2(createSegment2Schema, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a cost code.
     * @summary Delete Cost Code
     * @param {string} codeId 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CostCodesApi
     */
    public deleteCostCode(codeId: string, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return CostCodesApiFp(this.configuration).deleteCostCode(codeId, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a Segment 1 entry.
     * @summary Delete Segment1
     * @param {string} code 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CostCodesApi
     */
    public deleteSegment1(code: string, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return CostCodesApiFp(this.configuration).deleteSegment1(code, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all cost codes.
     * @summary Get All Cost Codes
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CostCodesApi
     */
    public getAllCostCodes(requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return CostCodesApiFp(this.configuration).getAllCostCodes(requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all segment 1 entries.
     * @summary Get All Segments1
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CostCodesApi
     */
    public getAllSegments1(requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return CostCodesApiFp(this.configuration).getAllSegments1(requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all segment 2 entries.
     * @summary Get All Segments2
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CostCodesApi
     */
    public getAllSegments2(requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return CostCodesApiFp(this.configuration).getAllSegments2(requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific cost code by ID.
     * @summary Get Cost Code
     * @param {string} codeId 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CostCodesApi
     */
    public getCostCode(codeId: string, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return CostCodesApiFp(this.configuration).getCostCode(codeId, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all cost codes related to units (segment1=50, segment2=04).
     * @summary Get Unit Cost Codes
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CostCodesApi
     */
    public getUnitCostCodes(requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return CostCodesApiFp(this.configuration).getUnitCostCodes(requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing cost code.
     * @summary Update Cost Code
     * @param {string} codeId 
     * @param {{ [key: string]: any; }} requestBody 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CostCodesApi
     */
    public updateCostCode(codeId: string, requestBody: { [key: string]: any; }, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return CostCodesApiFp(this.configuration).updateCostCode(codeId, requestBody, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a Segment 1 entry.
     * @summary Update Segment1
     * @param {string} uuid 
     * @param {UpdateSegment1Schema} updateSegment1Schema 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CostCodesApi
     */
    public updateSegment1(uuid: string, updateSegment1Schema: UpdateSegment1Schema, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return CostCodesApiFp(this.configuration).updateSegment1(uuid, updateSegment1Schema, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a Segment 2 entry.
     * @summary Update Segment2
     * @param {string} uuid 
     * @param {UpdateSegment2Schema} updateSegment2Schema 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CostCodesApi
     */
    public updateSegment2(uuid: string, updateSegment2Schema: UpdateSegment2Schema, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return CostCodesApiFp(this.configuration).updateSegment2(uuid, updateSegment2Schema, requestSource, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Documentation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentation: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/docs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBasic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Openapi
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openapi: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/openapi.json`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBasic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Documentation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocumentation(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocumentation(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getDocumentation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Openapi
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async openapi(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.openapi(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.openapi']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Documentation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentation(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getDocumentation(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Openapi
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openapi(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.openapi(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * 
     * @summary Get Documentation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getDocumentation(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getDocumentation(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Openapi
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public openapi(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).openapi(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FactoryAdusApi - axios parameter creator
 * @export
 */
export const FactoryAdusApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Delete multiple factory ADUs.
         * @summary Bulk Delete Factory Adus
         * @param {FactoryADUBulkDeleteRequest} factoryADUBulkDeleteRequest 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDeleteFactoryAdus: async (factoryADUBulkDeleteRequest: FactoryADUBulkDeleteRequest, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'factoryADUBulkDeleteRequest' is not null or undefined
            assertParamExists('bulkDeleteFactoryAdus', 'factoryADUBulkDeleteRequest', factoryADUBulkDeleteRequest)
            const localVarPath = `/admin/factory-adus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(factoryADUBulkDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new factory ADU.
         * @summary Create Factory Adu
         * @param {FactoryADUCreate} factoryADUCreate 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFactoryAdu: async (factoryADUCreate: FactoryADUCreate, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'factoryADUCreate' is not null or undefined
            assertParamExists('createFactoryAdu', 'factoryADUCreate', factoryADUCreate)
            const localVarPath = `/admin/factory-adus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(factoryADUCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a factory ADU.
         * @summary Delete Factory Adu
         * @param {string} factoryAduId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFactoryAdu: async (factoryAduId: string, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'factoryAduId' is not null or undefined
            assertParamExists('deleteFactoryAdu', 'factoryAduId', factoryAduId)
            const localVarPath = `/admin/factory-adus/{factory_adu_id}`
                .replace(`{${"factory_adu_id"}}`, encodeURIComponent(String(factoryAduId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific factory ADU by ID.
         * @summary Get Factory Adu
         * @param {string} factoryAduId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFactoryAdu: async (factoryAduId: string, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'factoryAduId' is not null or undefined
            assertParamExists('getFactoryAdu', 'factoryAduId', factoryAduId)
            const localVarPath = `/admin/factory-adus/{factory_adu_id}`
                .replace(`{${"factory_adu_id"}}`, encodeURIComponent(String(factoryAduId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all factory ADUs.
         * @summary List Factory Adus
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFactoryAdus: async (requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/factory-adus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all factory ADUs for a specific factory.
         * @summary List Factory Adus By Factory
         * @param {string} factoryId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFactoryAdusByFactory: async (factoryId: string, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'factoryId' is not null or undefined
            assertParamExists('listFactoryAdusByFactory', 'factoryId', factoryId)
            const localVarPath = `/admin/factory-adus/factory/{factory_id}`
                .replace(`{${"factory_id"}}`, encodeURIComponent(String(factoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing factory ADU.
         * @summary Update Factory Adu
         * @param {string} factoryAduId 
         * @param {FactoryADUUpdate} factoryADUUpdate 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFactoryAdu: async (factoryAduId: string, factoryADUUpdate: FactoryADUUpdate, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'factoryAduId' is not null or undefined
            assertParamExists('updateFactoryAdu', 'factoryAduId', factoryAduId)
            // verify required parameter 'factoryADUUpdate' is not null or undefined
            assertParamExists('updateFactoryAdu', 'factoryADUUpdate', factoryADUUpdate)
            const localVarPath = `/admin/factory-adus/{factory_adu_id}`
                .replace(`{${"factory_adu_id"}}`, encodeURIComponent(String(factoryAduId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(factoryADUUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FactoryAdusApi - functional programming interface
 * @export
 */
export const FactoryAdusApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FactoryAdusApiAxiosParamCreator(configuration)
    return {
        /**
         * Delete multiple factory ADUs.
         * @summary Bulk Delete Factory Adus
         * @param {FactoryADUBulkDeleteRequest} factoryADUBulkDeleteRequest 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkDeleteFactoryAdus(factoryADUBulkDeleteRequest: FactoryADUBulkDeleteRequest, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FactoryADUBulkDeleteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkDeleteFactoryAdus(factoryADUBulkDeleteRequest, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FactoryAdusApi.bulkDeleteFactoryAdus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new factory ADU.
         * @summary Create Factory Adu
         * @param {FactoryADUCreate} factoryADUCreate 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFactoryAdu(factoryADUCreate: FactoryADUCreate, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FactoryADUResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFactoryAdu(factoryADUCreate, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FactoryAdusApi.createFactoryAdu']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a factory ADU.
         * @summary Delete Factory Adu
         * @param {string} factoryAduId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFactoryAdu(factoryAduId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FactoryADUDeleteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFactoryAdu(factoryAduId, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FactoryAdusApi.deleteFactoryAdu']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a specific factory ADU by ID.
         * @summary Get Factory Adu
         * @param {string} factoryAduId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFactoryAdu(factoryAduId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FactoryADUResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFactoryAdu(factoryAduId, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FactoryAdusApi.getFactoryAdu']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all factory ADUs.
         * @summary List Factory Adus
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listFactoryAdus(requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FactoryADUListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listFactoryAdus(requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FactoryAdusApi.listFactoryAdus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all factory ADUs for a specific factory.
         * @summary List Factory Adus By Factory
         * @param {string} factoryId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listFactoryAdusByFactory(factoryId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FactoryADUListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listFactoryAdusByFactory(factoryId, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FactoryAdusApi.listFactoryAdusByFactory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing factory ADU.
         * @summary Update Factory Adu
         * @param {string} factoryAduId 
         * @param {FactoryADUUpdate} factoryADUUpdate 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFactoryAdu(factoryAduId: string, factoryADUUpdate: FactoryADUUpdate, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FactoryADUResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFactoryAdu(factoryAduId, factoryADUUpdate, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FactoryAdusApi.updateFactoryAdu']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FactoryAdusApi - factory interface
 * @export
 */
export const FactoryAdusApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FactoryAdusApiFp(configuration)
    return {
        /**
         * Delete multiple factory ADUs.
         * @summary Bulk Delete Factory Adus
         * @param {FactoryADUBulkDeleteRequest} factoryADUBulkDeleteRequest 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDeleteFactoryAdus(factoryADUBulkDeleteRequest: FactoryADUBulkDeleteRequest, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<FactoryADUBulkDeleteResponse> {
            return localVarFp.bulkDeleteFactoryAdus(factoryADUBulkDeleteRequest, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new factory ADU.
         * @summary Create Factory Adu
         * @param {FactoryADUCreate} factoryADUCreate 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFactoryAdu(factoryADUCreate: FactoryADUCreate, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<FactoryADUResponse> {
            return localVarFp.createFactoryAdu(factoryADUCreate, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a factory ADU.
         * @summary Delete Factory Adu
         * @param {string} factoryAduId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFactoryAdu(factoryAduId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<FactoryADUDeleteResponse> {
            return localVarFp.deleteFactoryAdu(factoryAduId, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific factory ADU by ID.
         * @summary Get Factory Adu
         * @param {string} factoryAduId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFactoryAdu(factoryAduId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<FactoryADUResponse> {
            return localVarFp.getFactoryAdu(factoryAduId, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * List all factory ADUs.
         * @summary List Factory Adus
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFactoryAdus(requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<FactoryADUListResponse> {
            return localVarFp.listFactoryAdus(requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * List all factory ADUs for a specific factory.
         * @summary List Factory Adus By Factory
         * @param {string} factoryId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFactoryAdusByFactory(factoryId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<FactoryADUListResponse> {
            return localVarFp.listFactoryAdusByFactory(factoryId, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing factory ADU.
         * @summary Update Factory Adu
         * @param {string} factoryAduId 
         * @param {FactoryADUUpdate} factoryADUUpdate 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFactoryAdu(factoryAduId: string, factoryADUUpdate: FactoryADUUpdate, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<FactoryADUResponse> {
            return localVarFp.updateFactoryAdu(factoryAduId, factoryADUUpdate, requestSource, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FactoryAdusApi - object-oriented interface
 * @export
 * @class FactoryAdusApi
 * @extends {BaseAPI}
 */
export class FactoryAdusApi extends BaseAPI {
    /**
     * Delete multiple factory ADUs.
     * @summary Bulk Delete Factory Adus
     * @param {FactoryADUBulkDeleteRequest} factoryADUBulkDeleteRequest 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FactoryAdusApi
     */
    public bulkDeleteFactoryAdus(factoryADUBulkDeleteRequest: FactoryADUBulkDeleteRequest, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return FactoryAdusApiFp(this.configuration).bulkDeleteFactoryAdus(factoryADUBulkDeleteRequest, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new factory ADU.
     * @summary Create Factory Adu
     * @param {FactoryADUCreate} factoryADUCreate 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FactoryAdusApi
     */
    public createFactoryAdu(factoryADUCreate: FactoryADUCreate, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return FactoryAdusApiFp(this.configuration).createFactoryAdu(factoryADUCreate, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a factory ADU.
     * @summary Delete Factory Adu
     * @param {string} factoryAduId 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FactoryAdusApi
     */
    public deleteFactoryAdu(factoryAduId: string, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return FactoryAdusApiFp(this.configuration).deleteFactoryAdu(factoryAduId, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific factory ADU by ID.
     * @summary Get Factory Adu
     * @param {string} factoryAduId 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FactoryAdusApi
     */
    public getFactoryAdu(factoryAduId: string, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return FactoryAdusApiFp(this.configuration).getFactoryAdu(factoryAduId, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all factory ADUs.
     * @summary List Factory Adus
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FactoryAdusApi
     */
    public listFactoryAdus(requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return FactoryAdusApiFp(this.configuration).listFactoryAdus(requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all factory ADUs for a specific factory.
     * @summary List Factory Adus By Factory
     * @param {string} factoryId 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FactoryAdusApi
     */
    public listFactoryAdusByFactory(factoryId: string, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return FactoryAdusApiFp(this.configuration).listFactoryAdusByFactory(factoryId, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing factory ADU.
     * @summary Update Factory Adu
     * @param {string} factoryAduId 
     * @param {FactoryADUUpdate} factoryADUUpdate 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FactoryAdusApi
     */
    public updateFactoryAdu(factoryAduId: string, factoryADUUpdate: FactoryADUUpdate, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return FactoryAdusApiFp(this.configuration).updateFactoryAdu(factoryAduId, factoryADUUpdate, requestSource, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GrafanaApi - axios parameter creator
 * @export
 */
export const GrafanaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Distinct Salesforce Customer Segments
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDistinctSalesforceCustomerSegments: async (requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/grafana/salesforce/lead/customer_segments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Grafana required
            await setApiKeyToObject(localVarHeaderParameter, "x-grafana-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Distinct Salesforce Lead Sources
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDistinctSalesforceLeadSources: async (requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/grafana/salesforce/lead/lead_sources`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Grafana required
            await setApiKeyToObject(localVarHeaderParameter, "x-grafana-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Distinct Salesforce Multifamily
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDistinctSalesforceMultifamily: async (requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/grafana/salesforce/lead/multifamily`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Grafana required
            await setApiKeyToObject(localVarHeaderParameter, "x-grafana-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Serviceable Zip Codes
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceableZipCodes: async (requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/grafana/zip-codes/serviceable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Grafana required
            await setApiKeyToObject(localVarHeaderParameter, "x-grafana-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GrafanaApi - functional programming interface
 * @export
 */
export const GrafanaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GrafanaApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Distinct Salesforce Customer Segments
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDistinctSalesforceCustomerSegments(requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDistinctSalesforceCustomerSegments(requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GrafanaApi.getDistinctSalesforceCustomerSegments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Distinct Salesforce Lead Sources
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDistinctSalesforceLeadSources(requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDistinctSalesforceLeadSources(requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GrafanaApi.getDistinctSalesforceLeadSources']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Distinct Salesforce Multifamily
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDistinctSalesforceMultifamily(requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDistinctSalesforceMultifamily(requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GrafanaApi.getDistinctSalesforceMultifamily']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Serviceable Zip Codes
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getServiceableZipCodes(requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getServiceableZipCodes(requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GrafanaApi.getServiceableZipCodes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GrafanaApi - factory interface
 * @export
 */
export const GrafanaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GrafanaApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Distinct Salesforce Customer Segments
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDistinctSalesforceCustomerSegments(requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getDistinctSalesforceCustomerSegments(requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Distinct Salesforce Lead Sources
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDistinctSalesforceLeadSources(requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getDistinctSalesforceLeadSources(requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Distinct Salesforce Multifamily
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDistinctSalesforceMultifamily(requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getDistinctSalesforceMultifamily(requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Serviceable Zip Codes
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceableZipCodes(requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getServiceableZipCodes(requestSource, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GrafanaApi - object-oriented interface
 * @export
 * @class GrafanaApi
 * @extends {BaseAPI}
 */
export class GrafanaApi extends BaseAPI {
    /**
     * 
     * @summary Get Distinct Salesforce Customer Segments
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GrafanaApi
     */
    public getDistinctSalesforceCustomerSegments(requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return GrafanaApiFp(this.configuration).getDistinctSalesforceCustomerSegments(requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Distinct Salesforce Lead Sources
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GrafanaApi
     */
    public getDistinctSalesforceLeadSources(requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return GrafanaApiFp(this.configuration).getDistinctSalesforceLeadSources(requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Distinct Salesforce Multifamily
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GrafanaApi
     */
    public getDistinctSalesforceMultifamily(requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return GrafanaApiFp(this.configuration).getDistinctSalesforceMultifamily(requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Serviceable Zip Codes
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GrafanaApi
     */
    public getServiceableZipCodes(requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return GrafanaApiFp(this.configuration).getServiceableZipCodes(requestSource, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * HealthApi - axios parameter creator
 * @export
 */
export const HealthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Error
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        error: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/error`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Error
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        error_1: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/error`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Health
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        health: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Health
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        health_2: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Hello World
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        helloWorld: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HealthApi - functional programming interface
 * @export
 */
export const HealthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HealthApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Error
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async error(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.error(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HealthApi.error']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Error
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async error_1(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.error_1(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HealthApi.error_1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Health
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async health(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.health(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HealthApi.health']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Health
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async health_2(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.health_2(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HealthApi.health_2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Hello World
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async helloWorld(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.helloWorld(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HealthApi.helloWorld']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * HealthApi - factory interface
 * @export
 */
export const HealthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HealthApiFp(configuration)
    return {
        /**
         * 
         * @summary Error
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        error(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.error(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Error
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        error_1(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.error_1(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Health
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        health(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.health(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Health
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        health_2(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.health_2(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Hello World
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        helloWorld(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.helloWorld(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HealthApi - object-oriented interface
 * @export
 * @class HealthApi
 * @extends {BaseAPI}
 */
export class HealthApi extends BaseAPI {
    /**
     * 
     * @summary Error
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthApi
     */
    public error(options?: RawAxiosRequestConfig) {
        return HealthApiFp(this.configuration).error(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Error
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthApi
     */
    public error_1(options?: RawAxiosRequestConfig) {
        return HealthApiFp(this.configuration).error_1(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Health
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthApi
     */
    public health(options?: RawAxiosRequestConfig) {
        return HealthApiFp(this.configuration).health(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Health
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthApi
     */
    public health_2(options?: RawAxiosRequestConfig) {
        return HealthApiFp(this.configuration).health_2(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Hello World
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthApi
     */
    public helloWorld(options?: RawAxiosRequestConfig) {
        return HealthApiFp(this.configuration).helloWorld(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InstantQuoteApi - axios parameter creator
 * @export
 */
export const InstantQuoteApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Instant Quote Product Pricing
         * @param {string} productId 
         * @param {InstantQuoteProductLocationSchema} instantQuoteProductLocationSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInstantQuoteProductPricing: async (productId: string, instantQuoteProductLocationSchema: InstantQuoteProductLocationSchema, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('createInstantQuoteProductPricing', 'productId', productId)
            // verify required parameter 'instantQuoteProductLocationSchema' is not null or undefined
            assertParamExists('createInstantQuoteProductPricing', 'instantQuoteProductLocationSchema', instantQuoteProductLocationSchema)
            const localVarPath = `/admin/products/{product_id}/instant-quote/pricing`
                .replace(`{${"product_id"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Firebase-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-firebase-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(instantQuoteProductLocationSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get All Listed Products Csv
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllListedProductsCsv: async (requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/products/instant-quote/listed/csv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Firebase-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-firebase-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Closest Instant Quote Location Items By Product Id
         * @param {string} productId 
         * @param {number} latitude 
         * @param {number} longitude 
         * @param {string} [searchType] 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClosestInstantQuoteLocationItemsByProductId: async (productId: string, latitude: number, longitude: number, searchType?: string, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('getClosestInstantQuoteLocationItemsByProductId', 'productId', productId)
            // verify required parameter 'latitude' is not null or undefined
            assertParamExists('getClosestInstantQuoteLocationItemsByProductId', 'latitude', latitude)
            // verify required parameter 'longitude' is not null or undefined
            assertParamExists('getClosestInstantQuoteLocationItemsByProductId', 'longitude', longitude)
            const localVarPath = `/instant-quote/items/{product_id}/search`
                .replace(`{${"product_id"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (latitude !== undefined) {
                localVarQueryParameter['latitude'] = latitude;
            }

            if (longitude !== undefined) {
                localVarQueryParameter['longitude'] = longitude;
            }

            if (searchType !== undefined) {
                localVarQueryParameter['search_type'] = searchType;
            }


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Instant Quote Locations For Product
         * @param {string} productId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInstantQuoteLocationsForProduct: async (productId: string, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('getInstantQuoteLocationsForProduct', 'productId', productId)
            const localVarPath = `/admin/products/{product_id}/instant-quote/locations`
                .replace(`{${"product_id"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Firebase-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-firebase-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Instant Quote Pricing Location Items
         * @param {string} locationId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInstantQuotePricingLocationItems: async (locationId: string, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getInstantQuotePricingLocationItems', 'locationId', locationId)
            const localVarPath = `/admin/instant-quote/locations/{location_id}/items`
                .replace(`{${"location_id"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Firebase-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-firebase-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Instant Quote Product Pricing
         * @param {string} productId 
         * @param {InstantQuoteProductLocationSchema} instantQuoteProductLocationSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInstantQuoteProductPricing: async (productId: string, instantQuoteProductLocationSchema: InstantQuoteProductLocationSchema, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('updateInstantQuoteProductPricing', 'productId', productId)
            // verify required parameter 'instantQuoteProductLocationSchema' is not null or undefined
            assertParamExists('updateInstantQuoteProductPricing', 'instantQuoteProductLocationSchema', instantQuoteProductLocationSchema)
            const localVarPath = `/admin/products/{product_id}/instant-quote/pricing`
                .replace(`{${"product_id"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Firebase-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-firebase-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(instantQuoteProductLocationSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload Instant Quote Csv
         * @param {File} file 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadInstantQuoteCsv: async (file: File, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadInstantQuoteCsv', 'file', file)
            const localVarPath = `/admin/instant-quote/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Firebase-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-firebase-token", configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InstantQuoteApi - functional programming interface
 * @export
 */
export const InstantQuoteApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InstantQuoteApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Instant Quote Product Pricing
         * @param {string} productId 
         * @param {InstantQuoteProductLocationSchema} instantQuoteProductLocationSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createInstantQuoteProductPricing(productId: string, instantQuoteProductLocationSchema: InstantQuoteProductLocationSchema, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createInstantQuoteProductPricing(productId, instantQuoteProductLocationSchema, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InstantQuoteApi.createInstantQuoteProductPricing']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get All Listed Products Csv
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllListedProductsCsv(requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllListedProductsCsv(requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InstantQuoteApi.getAllListedProductsCsv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Closest Instant Quote Location Items By Product Id
         * @param {string} productId 
         * @param {number} latitude 
         * @param {number} longitude 
         * @param {string} [searchType] 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClosestInstantQuoteLocationItemsByProductId(productId: string, latitude: number, longitude: number, searchType?: string, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClosestInstantQuoteLocationItemsByProductId(productId, latitude, longitude, searchType, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InstantQuoteApi.getClosestInstantQuoteLocationItemsByProductId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Instant Quote Locations For Product
         * @param {string} productId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInstantQuoteLocationsForProduct(productId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInstantQuoteLocationsForProduct(productId, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InstantQuoteApi.getInstantQuoteLocationsForProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Instant Quote Pricing Location Items
         * @param {string} locationId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInstantQuotePricingLocationItems(locationId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInstantQuotePricingLocationItems(locationId, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InstantQuoteApi.getInstantQuotePricingLocationItems']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Instant Quote Product Pricing
         * @param {string} productId 
         * @param {InstantQuoteProductLocationSchema} instantQuoteProductLocationSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateInstantQuoteProductPricing(productId: string, instantQuoteProductLocationSchema: InstantQuoteProductLocationSchema, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateInstantQuoteProductPricing(productId, instantQuoteProductLocationSchema, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InstantQuoteApi.updateInstantQuoteProductPricing']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload Instant Quote Csv
         * @param {File} file 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadInstantQuoteCsv(file: File, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadInstantQuoteCsv(file, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InstantQuoteApi.uploadInstantQuoteCsv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InstantQuoteApi - factory interface
 * @export
 */
export const InstantQuoteApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InstantQuoteApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Instant Quote Product Pricing
         * @param {string} productId 
         * @param {InstantQuoteProductLocationSchema} instantQuoteProductLocationSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInstantQuoteProductPricing(productId: string, instantQuoteProductLocationSchema: InstantQuoteProductLocationSchema, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.createInstantQuoteProductPricing(productId, instantQuoteProductLocationSchema, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get All Listed Products Csv
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllListedProductsCsv(requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getAllListedProductsCsv(requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Closest Instant Quote Location Items By Product Id
         * @param {string} productId 
         * @param {number} latitude 
         * @param {number} longitude 
         * @param {string} [searchType] 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClosestInstantQuoteLocationItemsByProductId(productId: string, latitude: number, longitude: number, searchType?: string, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getClosestInstantQuoteLocationItemsByProductId(productId, latitude, longitude, searchType, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Instant Quote Locations For Product
         * @param {string} productId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInstantQuoteLocationsForProduct(productId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getInstantQuoteLocationsForProduct(productId, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Instant Quote Pricing Location Items
         * @param {string} locationId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInstantQuotePricingLocationItems(locationId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getInstantQuotePricingLocationItems(locationId, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Instant Quote Product Pricing
         * @param {string} productId 
         * @param {InstantQuoteProductLocationSchema} instantQuoteProductLocationSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInstantQuoteProductPricing(productId: string, instantQuoteProductLocationSchema: InstantQuoteProductLocationSchema, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.updateInstantQuoteProductPricing(productId, instantQuoteProductLocationSchema, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload Instant Quote Csv
         * @param {File} file 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadInstantQuoteCsv(file: File, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.uploadInstantQuoteCsv(file, requestSource, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InstantQuoteApi - object-oriented interface
 * @export
 * @class InstantQuoteApi
 * @extends {BaseAPI}
 */
export class InstantQuoteApi extends BaseAPI {
    /**
     * 
     * @summary Create Instant Quote Product Pricing
     * @param {string} productId 
     * @param {InstantQuoteProductLocationSchema} instantQuoteProductLocationSchema 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InstantQuoteApi
     */
    public createInstantQuoteProductPricing(productId: string, instantQuoteProductLocationSchema: InstantQuoteProductLocationSchema, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return InstantQuoteApiFp(this.configuration).createInstantQuoteProductPricing(productId, instantQuoteProductLocationSchema, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get All Listed Products Csv
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InstantQuoteApi
     */
    public getAllListedProductsCsv(requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return InstantQuoteApiFp(this.configuration).getAllListedProductsCsv(requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Closest Instant Quote Location Items By Product Id
     * @param {string} productId 
     * @param {number} latitude 
     * @param {number} longitude 
     * @param {string} [searchType] 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InstantQuoteApi
     */
    public getClosestInstantQuoteLocationItemsByProductId(productId: string, latitude: number, longitude: number, searchType?: string, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return InstantQuoteApiFp(this.configuration).getClosestInstantQuoteLocationItemsByProductId(productId, latitude, longitude, searchType, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Instant Quote Locations For Product
     * @param {string} productId 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InstantQuoteApi
     */
    public getInstantQuoteLocationsForProduct(productId: string, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return InstantQuoteApiFp(this.configuration).getInstantQuoteLocationsForProduct(productId, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Instant Quote Pricing Location Items
     * @param {string} locationId 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InstantQuoteApi
     */
    public getInstantQuotePricingLocationItems(locationId: string, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return InstantQuoteApiFp(this.configuration).getInstantQuotePricingLocationItems(locationId, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Instant Quote Product Pricing
     * @param {string} productId 
     * @param {InstantQuoteProductLocationSchema} instantQuoteProductLocationSchema 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InstantQuoteApi
     */
    public updateInstantQuoteProductPricing(productId: string, instantQuoteProductLocationSchema: InstantQuoteProductLocationSchema, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return InstantQuoteApiFp(this.configuration).updateInstantQuoteProductPricing(productId, instantQuoteProductLocationSchema, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload Instant Quote Csv
     * @param {File} file 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InstantQuoteApi
     */
    public uploadInstantQuoteCsv(file: File, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return InstantQuoteApiFp(this.configuration).uploadInstantQuoteCsv(file, requestSource, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LeadsApi - axios parameter creator
 * @export
 */
export const LeadsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Check If Lead Exists
         * @param {boolean} [useUser] 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkIfLeadExists: async (useUser?: boolean, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/lead/exists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Firebase-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-firebase-token", configuration)

            if (useUser !== undefined) {
                localVarQueryParameter['use_user'] = useUser;
            }


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Lead
         * @param {CreateLeadSchema} createLeadSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLead: async (createLeadSchema: CreateLeadSchema, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createLeadSchema' is not null or undefined
            assertParamExists('createLead', 'createLeadSchema', createLeadSchema)
            const localVarPath = `/lead`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createLeadSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Waitlist Lead
         * @param {WaitlistLeadSchema} waitlistLeadSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWaitlistLead: async (waitlistLeadSchema: WaitlistLeadSchema, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'waitlistLeadSchema' is not null or undefined
            assertParamExists('createWaitlistLead', 'waitlistLeadSchema', waitlistLeadSchema)
            const localVarPath = `/lead/waitlist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(waitlistLeadSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Lead Questions
         * @param {UpdateLeadQuestionsSchema} updateLeadQuestionsSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLeadQuestions: async (updateLeadQuestionsSchema: UpdateLeadQuestionsSchema, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateLeadQuestionsSchema' is not null or undefined
            assertParamExists('updateLeadQuestions', 'updateLeadQuestionsSchema', updateLeadQuestionsSchema)
            const localVarPath = `/lead/update-questions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateLeadQuestionsSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Salesforce Lead
         * @param {PatchSalesforceLeadSchema} patchSalesforceLeadSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSalesforceLead: async (patchSalesforceLeadSchema: PatchSalesforceLeadSchema, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patchSalesforceLeadSchema' is not null or undefined
            assertParamExists('updateSalesforceLead', 'patchSalesforceLeadSchema', patchSalesforceLeadSchema)
            const localVarPath = `/lead/salesforce`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchSalesforceLeadSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LeadsApi - functional programming interface
 * @export
 */
export const LeadsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LeadsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Check If Lead Exists
         * @param {boolean} [useUser] 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkIfLeadExists(useUser?: boolean, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkIfLeadExists(useUser, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeadsApi.checkIfLeadExists']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Lead
         * @param {CreateLeadSchema} createLeadSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createLead(createLeadSchema: CreateLeadSchema, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLead(createLeadSchema, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeadsApi.createLead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Waitlist Lead
         * @param {WaitlistLeadSchema} waitlistLeadSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWaitlistLead(waitlistLeadSchema: WaitlistLeadSchema, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWaitlistLead(waitlistLeadSchema, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeadsApi.createWaitlistLead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Lead Questions
         * @param {UpdateLeadQuestionsSchema} updateLeadQuestionsSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLeadQuestions(updateLeadQuestionsSchema: UpdateLeadQuestionsSchema, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLeadQuestions(updateLeadQuestionsSchema, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeadsApi.updateLeadQuestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Salesforce Lead
         * @param {PatchSalesforceLeadSchema} patchSalesforceLeadSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSalesforceLead(patchSalesforceLeadSchema: PatchSalesforceLeadSchema, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSalesforceLead(patchSalesforceLeadSchema, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeadsApi.updateSalesforceLead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LeadsApi - factory interface
 * @export
 */
export const LeadsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LeadsApiFp(configuration)
    return {
        /**
         * 
         * @summary Check If Lead Exists
         * @param {boolean} [useUser] 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkIfLeadExists(useUser?: boolean, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.checkIfLeadExists(useUser, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Lead
         * @param {CreateLeadSchema} createLeadSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLead(createLeadSchema: CreateLeadSchema, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.createLead(createLeadSchema, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Waitlist Lead
         * @param {WaitlistLeadSchema} waitlistLeadSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWaitlistLead(waitlistLeadSchema: WaitlistLeadSchema, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.createWaitlistLead(waitlistLeadSchema, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Lead Questions
         * @param {UpdateLeadQuestionsSchema} updateLeadQuestionsSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLeadQuestions(updateLeadQuestionsSchema: UpdateLeadQuestionsSchema, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.updateLeadQuestions(updateLeadQuestionsSchema, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Salesforce Lead
         * @param {PatchSalesforceLeadSchema} patchSalesforceLeadSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSalesforceLead(patchSalesforceLeadSchema: PatchSalesforceLeadSchema, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.updateSalesforceLead(patchSalesforceLeadSchema, requestSource, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LeadsApi - object-oriented interface
 * @export
 * @class LeadsApi
 * @extends {BaseAPI}
 */
export class LeadsApi extends BaseAPI {
    /**
     * 
     * @summary Check If Lead Exists
     * @param {boolean} [useUser] 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadsApi
     */
    public checkIfLeadExists(useUser?: boolean, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return LeadsApiFp(this.configuration).checkIfLeadExists(useUser, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Lead
     * @param {CreateLeadSchema} createLeadSchema 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadsApi
     */
    public createLead(createLeadSchema: CreateLeadSchema, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return LeadsApiFp(this.configuration).createLead(createLeadSchema, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Waitlist Lead
     * @param {WaitlistLeadSchema} waitlistLeadSchema 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadsApi
     */
    public createWaitlistLead(waitlistLeadSchema: WaitlistLeadSchema, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return LeadsApiFp(this.configuration).createWaitlistLead(waitlistLeadSchema, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Lead Questions
     * @param {UpdateLeadQuestionsSchema} updateLeadQuestionsSchema 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadsApi
     */
    public updateLeadQuestions(updateLeadQuestionsSchema: UpdateLeadQuestionsSchema, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return LeadsApiFp(this.configuration).updateLeadQuestions(updateLeadQuestionsSchema, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Salesforce Lead
     * @param {PatchSalesforceLeadSchema} patchSalesforceLeadSchema 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadsApi
     */
    public updateSalesforceLead(patchSalesforceLeadSchema: PatchSalesforceLeadSchema, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return LeadsApiFp(this.configuration).updateSalesforceLead(patchSalesforceLeadSchema, requestSource, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MeApi - axios parameter creator
 * @export
 */
export const MeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Me
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMe: async (requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Firebase-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-firebase-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Me
         * @param {boolean} [createIfNotExists] 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMe: async (createIfNotExists?: boolean, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Firebase-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-firebase-token", configuration)

            if (createIfNotExists !== undefined) {
                localVarQueryParameter['create_if_not_exists'] = createIfNotExists;
            }


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get My Portfolios
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyPortfolios: async (requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/me/portfolios`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Firebase-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-firebase-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MeApi - functional programming interface
 * @export
 */
export const MeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MeApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Me
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMe(requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMe(requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeApi.createMe']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Me
         * @param {boolean} [createIfNotExists] 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMe(createIfNotExists?: boolean, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMe(createIfNotExists, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeApi.getMe']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get My Portfolios
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyPortfolios(requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyPortfolios(requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeApi.getMyPortfolios']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MeApi - factory interface
 * @export
 */
export const MeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MeApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Me
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMe(requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.createMe(requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Me
         * @param {boolean} [createIfNotExists] 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMe(createIfNotExists?: boolean, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getMe(createIfNotExists, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get My Portfolios
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyPortfolios(requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getMyPortfolios(requestSource, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MeApi - object-oriented interface
 * @export
 * @class MeApi
 * @extends {BaseAPI}
 */
export class MeApi extends BaseAPI {
    /**
     * 
     * @summary Create Me
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeApi
     */
    public createMe(requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return MeApiFp(this.configuration).createMe(requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Me
     * @param {boolean} [createIfNotExists] 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeApi
     */
    public getMe(createIfNotExists?: boolean, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return MeApiFp(this.configuration).getMe(createIfNotExists, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get My Portfolios
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeApi
     */
    public getMyPortfolios(requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return MeApiFp(this.configuration).getMyPortfolios(requestSource, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProjectsApi - axios parameter creator
 * @export
 */
export const ProjectsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Estimate
         * @param {string} projectId 
         * @param {CreateEstimateSchema} createEstimateSchema 
         * @param {boolean} [populateDefaults] 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEstimate: async (projectId: string, createEstimateSchema: CreateEstimateSchema, populateDefaults?: boolean, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('createEstimate', 'projectId', projectId)
            // verify required parameter 'createEstimateSchema' is not null or undefined
            assertParamExists('createEstimate', 'createEstimateSchema', createEstimateSchema)
            const localVarPath = `/projects/{project_id}/estimates`
                .replace(`{${"project_id"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Firebase-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-firebase-token", configuration)

            if (populateDefaults !== undefined) {
                localVarQueryParameter['populate_defaults'] = populateDefaults;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEstimateSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Project
         * @param {ProjectSchema} projectSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProject: async (projectSchema: ProjectSchema, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectSchema' is not null or undefined
            assertParamExists('createProject', 'projectSchema', projectSchema)
            const localVarPath = `/project`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Firebase-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-firebase-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Estimates By Project Id
         * @param {string} projectId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEstimatesByProjectId: async (projectId: string, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getEstimatesByProjectId', 'projectId', projectId)
            const localVarPath = `/projects/{project_id}/estimates`
                .replace(`{${"project_id"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Firebase-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-firebase-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Latest Estimate By Project Id
         * @param {string} projectId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestEstimateByProjectId: async (projectId: string, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getLatestEstimateByProjectId', 'projectId', projectId)
            const localVarPath = `/projects/{project_id}/estimates/latest`
                .replace(`{${"project_id"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Firebase-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-firebase-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Latest Estimated Project Range
         * @param {string} projectId 
         * @param {boolean} [disableCosts] 
         * @param {boolean} [disableMargin] 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestEstimatedProjectRange: async (projectId: string, disableCosts?: boolean, disableMargin?: boolean, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getLatestEstimatedProjectRange', 'projectId', projectId)
            const localVarPath = `/projects/{project_id}/estimates/latest/project-range`
                .replace(`{${"project_id"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Firebase-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-firebase-token", configuration)

            if (disableCosts !== undefined) {
                localVarQueryParameter['disable_costs'] = disableCosts;
            }

            if (disableMargin !== undefined) {
                localVarQueryParameter['disable_margin'] = disableMargin;
            }


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Project Portal Type
         * @param {string} projectId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectPortalType: async (projectId: string, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getProjectPortalType', 'projectId', projectId)
            const localVarPath = `/projects/{project_id}/portal-type`
                .replace(`{${"project_id"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Firebase-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-firebase-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProjectsApi - functional programming interface
 * @export
 */
export const ProjectsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProjectsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Estimate
         * @param {string} projectId 
         * @param {CreateEstimateSchema} createEstimateSchema 
         * @param {boolean} [populateDefaults] 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEstimate(projectId: string, createEstimateSchema: CreateEstimateSchema, populateDefaults?: boolean, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEstimate(projectId, createEstimateSchema, populateDefaults, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.createEstimate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Project
         * @param {ProjectSchema} projectSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProject(projectSchema: ProjectSchema, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProject(projectSchema, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.createProject']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Estimates By Project Id
         * @param {string} projectId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEstimatesByProjectId(projectId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEstimatesByProjectId(projectId, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.getEstimatesByProjectId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Latest Estimate By Project Id
         * @param {string} projectId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestEstimateByProjectId(projectId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestEstimateByProjectId(projectId, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.getLatestEstimateByProjectId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Latest Estimated Project Range
         * @param {string} projectId 
         * @param {boolean} [disableCosts] 
         * @param {boolean} [disableMargin] 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestEstimatedProjectRange(projectId: string, disableCosts?: boolean, disableMargin?: boolean, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestEstimatedProjectRange(projectId, disableCosts, disableMargin, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.getLatestEstimatedProjectRange']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Project Portal Type
         * @param {string} projectId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjectPortalType(projectId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProjectPortalType(projectId, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectsApi.getProjectPortalType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProjectsApi - factory interface
 * @export
 */
export const ProjectsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProjectsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Estimate
         * @param {string} projectId 
         * @param {CreateEstimateSchema} createEstimateSchema 
         * @param {boolean} [populateDefaults] 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEstimate(projectId: string, createEstimateSchema: CreateEstimateSchema, populateDefaults?: boolean, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.createEstimate(projectId, createEstimateSchema, populateDefaults, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Project
         * @param {ProjectSchema} projectSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProject(projectSchema: ProjectSchema, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.createProject(projectSchema, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Estimates By Project Id
         * @param {string} projectId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEstimatesByProjectId(projectId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getEstimatesByProjectId(projectId, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Latest Estimate By Project Id
         * @param {string} projectId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestEstimateByProjectId(projectId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getLatestEstimateByProjectId(projectId, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Latest Estimated Project Range
         * @param {string} projectId 
         * @param {boolean} [disableCosts] 
         * @param {boolean} [disableMargin] 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestEstimatedProjectRange(projectId: string, disableCosts?: boolean, disableMargin?: boolean, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getLatestEstimatedProjectRange(projectId, disableCosts, disableMargin, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Project Portal Type
         * @param {string} projectId 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectPortalType(projectId: string, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getProjectPortalType(projectId, requestSource, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProjectsApi - object-oriented interface
 * @export
 * @class ProjectsApi
 * @extends {BaseAPI}
 */
export class ProjectsApi extends BaseAPI {
    /**
     * 
     * @summary Create Estimate
     * @param {string} projectId 
     * @param {CreateEstimateSchema} createEstimateSchema 
     * @param {boolean} [populateDefaults] 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public createEstimate(projectId: string, createEstimateSchema: CreateEstimateSchema, populateDefaults?: boolean, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).createEstimate(projectId, createEstimateSchema, populateDefaults, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Project
     * @param {ProjectSchema} projectSchema 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public createProject(projectSchema: ProjectSchema, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).createProject(projectSchema, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Estimates By Project Id
     * @param {string} projectId 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public getEstimatesByProjectId(projectId: string, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).getEstimatesByProjectId(projectId, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Latest Estimate By Project Id
     * @param {string} projectId 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public getLatestEstimateByProjectId(projectId: string, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).getLatestEstimateByProjectId(projectId, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Latest Estimated Project Range
     * @param {string} projectId 
     * @param {boolean} [disableCosts] 
     * @param {boolean} [disableMargin] 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public getLatestEstimatedProjectRange(projectId: string, disableCosts?: boolean, disableMargin?: boolean, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).getLatestEstimatedProjectRange(projectId, disableCosts, disableMargin, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Project Portal Type
     * @param {string} projectId 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    public getProjectPortalType(projectId: string, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return ProjectsApiFp(this.configuration).getProjectPortalType(projectId, requestSource, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RbacApi - axios parameter creator
 * @export
 */
export const RbacApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new group with optional permissions
         * @summary Create Group
         * @param {CreateGroupRequest} createGroupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGroup: async (createGroupRequest: CreateGroupRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createGroupRequest' is not null or undefined
            assertParamExists('createGroup', 'createGroupRequest', createGroupRequest)
            const localVarPath = `/admin/employee/group`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createGroupRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new permission
         * @summary Create Permission
         * @param {CreatePermissionRequest} createPermissionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPermission: async (createPermissionRequest: CreatePermissionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createPermissionRequest' is not null or undefined
            assertParamExists('createPermission', 'createPermissionRequest', createPermissionRequest)
            const localVarPath = `/admin/employee/permission`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPermissionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a group and remove it from all employees
         * @summary Delete Group
         * @param {string} groupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGroup: async (groupId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('deleteGroup', 'groupId', groupId)
            const localVarPath = `/admin/employee/group/{group_id}`
                .replace(`{${"group_id"}}`, encodeURIComponent(String(groupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific employee with their groups and permissions
         * @summary Get Employee
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployee: async (employeeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('getEmployee', 'employeeId', employeeId)
            const localVarPath = `/admin/employee/{employee_id}`
                .replace(`{${"employee_id"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific group with its permissions
         * @summary Get Group
         * @param {string} groupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroup: async (groupId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('getGroup', 'groupId', groupId)
            const localVarPath = `/admin/employee/group/{group_id}`
                .replace(`{${"group_id"}}`, encodeURIComponent(String(groupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all groups in the system
         * @summary Get Groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroups: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/employee/groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all groups for the current user
         * @summary Get My Groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyGroups: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/employee/me/groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all permissions for the current user through their groups
         * @summary Get My Permissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyPermissions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/employee/me/permissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all employees with their groups and permissions
         * @summary List Employees
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEmployees: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/employees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all available permissions in the system
         * @summary List Permissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPermissions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/employee/permissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update which groups an employee belongs to
         * @summary Update Employee Groups
         * @param {string} employeeId 
         * @param {UpdateEmployeeGroupsRequest} updateEmployeeGroupsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmployeeGroups: async (employeeId: string, updateEmployeeGroupsRequest: UpdateEmployeeGroupsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('updateEmployeeGroups', 'employeeId', employeeId)
            // verify required parameter 'updateEmployeeGroupsRequest' is not null or undefined
            assertParamExists('updateEmployeeGroups', 'updateEmployeeGroupsRequest', updateEmployeeGroupsRequest)
            const localVarPath = `/admin/employee/{employee_id}/groups`
                .replace(`{${"employee_id"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmployeeGroupsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a group\'s name and/or description
         * @summary Update Group
         * @param {string} groupId 
         * @param {UpdateGroupRequest} updateGroupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGroup: async (groupId: string, updateGroupRequest: UpdateGroupRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('updateGroup', 'groupId', groupId)
            // verify required parameter 'updateGroupRequest' is not null or undefined
            assertParamExists('updateGroup', 'updateGroupRequest', updateGroupRequest)
            const localVarPath = `/admin/employee/group/{group_id}`
                .replace(`{${"group_id"}}`, encodeURIComponent(String(groupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateGroupRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update which permissions a group has
         * @summary Update Group Permissions
         * @param {string} groupId 
         * @param {UpdateGroupPermissionsRequest} updateGroupPermissionsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGroupPermissions: async (groupId: string, updateGroupPermissionsRequest: UpdateGroupPermissionsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('updateGroupPermissions', 'groupId', groupId)
            // verify required parameter 'updateGroupPermissionsRequest' is not null or undefined
            assertParamExists('updateGroupPermissions', 'updateGroupPermissionsRequest', updateGroupPermissionsRequest)
            const localVarPath = `/admin/employee/group/{group_id}/permissions`
                .replace(`{${"group_id"}}`, encodeURIComponent(String(groupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateGroupPermissionsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RbacApi - functional programming interface
 * @export
 */
export const RbacApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RbacApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new group with optional permissions
         * @summary Create Group
         * @param {CreateGroupRequest} createGroupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createGroup(createGroupRequest: CreateGroupRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createGroup(createGroupRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RbacApi.createGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new permission
         * @summary Create Permission
         * @param {CreatePermissionRequest} createPermissionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPermission(createPermissionRequest: CreatePermissionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PermissionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPermission(createPermissionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RbacApi.createPermission']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a group and remove it from all employees
         * @summary Delete Group
         * @param {string} groupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteGroup(groupId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteGroup(groupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RbacApi.deleteGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a specific employee with their groups and permissions
         * @summary Get Employee
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmployee(employeeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmployee(employeeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RbacApi.getEmployee']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a specific group with its permissions
         * @summary Get Group
         * @param {string} groupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGroup(groupId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGroup(groupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RbacApi.getGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all groups in the system
         * @summary Get Groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGroups(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GroupResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGroups(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RbacApi.getGroups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all groups for the current user
         * @summary Get My Groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyGroups(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GroupResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyGroups(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RbacApi.getMyGroups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all permissions for the current user through their groups
         * @summary Get My Permissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyPermissions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyPermissions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RbacApi.getMyPermissions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all employees with their groups and permissions
         * @summary List Employees
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listEmployees(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmployeeResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listEmployees(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RbacApi.listEmployees']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all available permissions in the system
         * @summary List Permissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPermissions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PermissionResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPermissions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RbacApi.listPermissions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update which groups an employee belongs to
         * @summary Update Employee Groups
         * @param {string} employeeId 
         * @param {UpdateEmployeeGroupsRequest} updateEmployeeGroupsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEmployeeGroups(employeeId: string, updateEmployeeGroupsRequest: UpdateEmployeeGroupsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEmployeeGroups(employeeId, updateEmployeeGroupsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RbacApi.updateEmployeeGroups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a group\'s name and/or description
         * @summary Update Group
         * @param {string} groupId 
         * @param {UpdateGroupRequest} updateGroupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateGroup(groupId: string, updateGroupRequest: UpdateGroupRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateGroup(groupId, updateGroupRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RbacApi.updateGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update which permissions a group has
         * @summary Update Group Permissions
         * @param {string} groupId 
         * @param {UpdateGroupPermissionsRequest} updateGroupPermissionsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateGroupPermissions(groupId: string, updateGroupPermissionsRequest: UpdateGroupPermissionsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateGroupPermissions(groupId, updateGroupPermissionsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RbacApi.updateGroupPermissions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RbacApi - factory interface
 * @export
 */
export const RbacApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RbacApiFp(configuration)
    return {
        /**
         * Create a new group with optional permissions
         * @summary Create Group
         * @param {CreateGroupRequest} createGroupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGroup(createGroupRequest: CreateGroupRequest, options?: RawAxiosRequestConfig): AxiosPromise<GroupResponse> {
            return localVarFp.createGroup(createGroupRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new permission
         * @summary Create Permission
         * @param {CreatePermissionRequest} createPermissionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPermission(createPermissionRequest: CreatePermissionRequest, options?: RawAxiosRequestConfig): AxiosPromise<PermissionResponse> {
            return localVarFp.createPermission(createPermissionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a group and remove it from all employees
         * @summary Delete Group
         * @param {string} groupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGroup(groupId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteGroup(groupId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific employee with their groups and permissions
         * @summary Get Employee
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployee(employeeId: string, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeResponse> {
            return localVarFp.getEmployee(employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific group with its permissions
         * @summary Get Group
         * @param {string} groupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroup(groupId: string, options?: RawAxiosRequestConfig): AxiosPromise<GroupResponse> {
            return localVarFp.getGroup(groupId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all groups in the system
         * @summary Get Groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroups(options?: RawAxiosRequestConfig): AxiosPromise<Array<GroupResponse>> {
            return localVarFp.getGroups(options).then((request) => request(axios, basePath));
        },
        /**
         * Get all groups for the current user
         * @summary Get My Groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyGroups(options?: RawAxiosRequestConfig): AxiosPromise<Array<GroupResponse>> {
            return localVarFp.getMyGroups(options).then((request) => request(axios, basePath));
        },
        /**
         * Get all permissions for the current user through their groups
         * @summary Get My Permissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyPermissions(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.getMyPermissions(options).then((request) => request(axios, basePath));
        },
        /**
         * Get all employees with their groups and permissions
         * @summary List Employees
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEmployees(options?: RawAxiosRequestConfig): AxiosPromise<Array<EmployeeResponse>> {
            return localVarFp.listEmployees(options).then((request) => request(axios, basePath));
        },
        /**
         * Get all available permissions in the system
         * @summary List Permissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPermissions(options?: RawAxiosRequestConfig): AxiosPromise<Array<PermissionResponse>> {
            return localVarFp.listPermissions(options).then((request) => request(axios, basePath));
        },
        /**
         * Update which groups an employee belongs to
         * @summary Update Employee Groups
         * @param {string} employeeId 
         * @param {UpdateEmployeeGroupsRequest} updateEmployeeGroupsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmployeeGroups(employeeId: string, updateEmployeeGroupsRequest: UpdateEmployeeGroupsRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.updateEmployeeGroups(employeeId, updateEmployeeGroupsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a group\'s name and/or description
         * @summary Update Group
         * @param {string} groupId 
         * @param {UpdateGroupRequest} updateGroupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGroup(groupId: string, updateGroupRequest: UpdateGroupRequest, options?: RawAxiosRequestConfig): AxiosPromise<GroupResponse> {
            return localVarFp.updateGroup(groupId, updateGroupRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update which permissions a group has
         * @summary Update Group Permissions
         * @param {string} groupId 
         * @param {UpdateGroupPermissionsRequest} updateGroupPermissionsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGroupPermissions(groupId: string, updateGroupPermissionsRequest: UpdateGroupPermissionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.updateGroupPermissions(groupId, updateGroupPermissionsRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RbacApi - object-oriented interface
 * @export
 * @class RbacApi
 * @extends {BaseAPI}
 */
export class RbacApi extends BaseAPI {
    /**
     * Create a new group with optional permissions
     * @summary Create Group
     * @param {CreateGroupRequest} createGroupRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RbacApi
     */
    public createGroup(createGroupRequest: CreateGroupRequest, options?: RawAxiosRequestConfig) {
        return RbacApiFp(this.configuration).createGroup(createGroupRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new permission
     * @summary Create Permission
     * @param {CreatePermissionRequest} createPermissionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RbacApi
     */
    public createPermission(createPermissionRequest: CreatePermissionRequest, options?: RawAxiosRequestConfig) {
        return RbacApiFp(this.configuration).createPermission(createPermissionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a group and remove it from all employees
     * @summary Delete Group
     * @param {string} groupId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RbacApi
     */
    public deleteGroup(groupId: string, options?: RawAxiosRequestConfig) {
        return RbacApiFp(this.configuration).deleteGroup(groupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific employee with their groups and permissions
     * @summary Get Employee
     * @param {string} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RbacApi
     */
    public getEmployee(employeeId: string, options?: RawAxiosRequestConfig) {
        return RbacApiFp(this.configuration).getEmployee(employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific group with its permissions
     * @summary Get Group
     * @param {string} groupId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RbacApi
     */
    public getGroup(groupId: string, options?: RawAxiosRequestConfig) {
        return RbacApiFp(this.configuration).getGroup(groupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all groups in the system
     * @summary Get Groups
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RbacApi
     */
    public getGroups(options?: RawAxiosRequestConfig) {
        return RbacApiFp(this.configuration).getGroups(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all groups for the current user
     * @summary Get My Groups
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RbacApi
     */
    public getMyGroups(options?: RawAxiosRequestConfig) {
        return RbacApiFp(this.configuration).getMyGroups(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all permissions for the current user through their groups
     * @summary Get My Permissions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RbacApi
     */
    public getMyPermissions(options?: RawAxiosRequestConfig) {
        return RbacApiFp(this.configuration).getMyPermissions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all employees with their groups and permissions
     * @summary List Employees
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RbacApi
     */
    public listEmployees(options?: RawAxiosRequestConfig) {
        return RbacApiFp(this.configuration).listEmployees(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all available permissions in the system
     * @summary List Permissions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RbacApi
     */
    public listPermissions(options?: RawAxiosRequestConfig) {
        return RbacApiFp(this.configuration).listPermissions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update which groups an employee belongs to
     * @summary Update Employee Groups
     * @param {string} employeeId 
     * @param {UpdateEmployeeGroupsRequest} updateEmployeeGroupsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RbacApi
     */
    public updateEmployeeGroups(employeeId: string, updateEmployeeGroupsRequest: UpdateEmployeeGroupsRequest, options?: RawAxiosRequestConfig) {
        return RbacApiFp(this.configuration).updateEmployeeGroups(employeeId, updateEmployeeGroupsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a group\'s name and/or description
     * @summary Update Group
     * @param {string} groupId 
     * @param {UpdateGroupRequest} updateGroupRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RbacApi
     */
    public updateGroup(groupId: string, updateGroupRequest: UpdateGroupRequest, options?: RawAxiosRequestConfig) {
        return RbacApiFp(this.configuration).updateGroup(groupId, updateGroupRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update which permissions a group has
     * @summary Update Group Permissions
     * @param {string} groupId 
     * @param {UpdateGroupPermissionsRequest} updateGroupPermissionsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RbacApi
     */
    public updateGroupPermissions(groupId: string, updateGroupPermissionsRequest: UpdateGroupPermissionsRequest, options?: RawAxiosRequestConfig) {
        return RbacApiFp(this.configuration).updateGroupPermissions(groupId, updateGroupPermissionsRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SalesforceApi - axios parameter creator
 * @export
 */
export const SalesforceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Feasibility By Zip Code
         * @param {string} leadZipcode 
         * @param {string | null} [customerSegment] 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeasibilityByZipCode: async (leadZipcode: string, customerSegment?: string | null, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'leadZipcode' is not null or undefined
            assertParamExists('getFeasibilityByZipCode', 'leadZipcode', leadZipcode)
            const localVarPath = `/salesforce/feasibility/zipcode/{lead_zipcode}`
                .replace(`{${"lead_zipcode"}}`, encodeURIComponent(String(leadZipcode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Salesforce required
            await setApiKeyToObject(localVarHeaderParameter, "x-salesforce-token", configuration)

            if (customerSegment !== undefined) {
                localVarQueryParameter['customer_segment'] = customerSegment;
            }


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Zipcode Info
         * @param {string} leadZipcode 
         * @param {string | null} [customerSegment] 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZipcodeInfo: async (leadZipcode: string, customerSegment?: string | null, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'leadZipcode' is not null or undefined
            assertParamExists('getZipcodeInfo', 'leadZipcode', leadZipcode)
            const localVarPath = `/salesforce/zipcode-info/{lead_zipcode}`
                .replace(`{${"lead_zipcode"}}`, encodeURIComponent(String(leadZipcode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Salesforce required
            await setApiKeyToObject(localVarHeaderParameter, "x-salesforce-token", configuration)

            if (customerSegment !== undefined) {
                localVarQueryParameter['customer_segment'] = customerSegment;
            }


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Receive Salesforce Event
         * @param {EventbridgeEventSchema} eventbridgeEventSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receiveSalesforceEvent: async (eventbridgeEventSchema: EventbridgeEventSchema, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventbridgeEventSchema' is not null or undefined
            assertParamExists('receiveSalesforceEvent', 'eventbridgeEventSchema', eventbridgeEventSchema)
            const localVarPath = `/salesforce/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Salesforce required
            await setApiKeyToObject(localVarHeaderParameter, "x-salesforce-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eventbridgeEventSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Salesforce Check If Lead Is Test
         * @param {string} firstName 
         * @param {string} lastName 
         * @param {string} email 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesforceCheckIfLeadIsTest: async (firstName: string, lastName: string, email: string, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firstName' is not null or undefined
            assertParamExists('salesforceCheckIfLeadIsTest', 'firstName', firstName)
            // verify required parameter 'lastName' is not null or undefined
            assertParamExists('salesforceCheckIfLeadIsTest', 'lastName', lastName)
            // verify required parameter 'email' is not null or undefined
            assertParamExists('salesforceCheckIfLeadIsTest', 'email', email)
            const localVarPath = `/salesforce/lead/check-is-test`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Salesforce required
            await setApiKeyToObject(localVarHeaderParameter, "x-salesforce-token", configuration)

            if (firstName !== undefined) {
                localVarQueryParameter['first_name'] = firstName;
            }

            if (lastName !== undefined) {
                localVarQueryParameter['last_name'] = lastName;
            }

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Test Event
         * @param {{ [key: string]: any; }} requestBody 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testEvent: async (requestBody: { [key: string]: any; }, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('testEvent', 'requestBody', requestBody)
            const localVarPath = `/admin/salesforce/test-event`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Firebase-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-firebase-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SalesforceApi - functional programming interface
 * @export
 */
export const SalesforceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SalesforceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Feasibility By Zip Code
         * @param {string} leadZipcode 
         * @param {string | null} [customerSegment] 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFeasibilityByZipCode(leadZipcode: string, customerSegment?: string | null, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFeasibilityByZipCode(leadZipcode, customerSegment, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesforceApi.getFeasibilityByZipCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Zipcode Info
         * @param {string} leadZipcode 
         * @param {string | null} [customerSegment] 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getZipcodeInfo(leadZipcode: string, customerSegment?: string | null, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getZipcodeInfo(leadZipcode, customerSegment, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesforceApi.getZipcodeInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Receive Salesforce Event
         * @param {EventbridgeEventSchema} eventbridgeEventSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receiveSalesforceEvent(eventbridgeEventSchema: EventbridgeEventSchema, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receiveSalesforceEvent(eventbridgeEventSchema, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesforceApi.receiveSalesforceEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Salesforce Check If Lead Is Test
         * @param {string} firstName 
         * @param {string} lastName 
         * @param {string} email 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async salesforceCheckIfLeadIsTest(firstName: string, lastName: string, email: string, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.salesforceCheckIfLeadIsTest(firstName, lastName, email, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesforceApi.salesforceCheckIfLeadIsTest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Test Event
         * @param {{ [key: string]: any; }} requestBody 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async testEvent(requestBody: { [key: string]: any; }, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.testEvent(requestBody, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesforceApi.testEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SalesforceApi - factory interface
 * @export
 */
export const SalesforceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SalesforceApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Feasibility By Zip Code
         * @param {string} leadZipcode 
         * @param {string | null} [customerSegment] 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeasibilityByZipCode(leadZipcode: string, customerSegment?: string | null, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getFeasibilityByZipCode(leadZipcode, customerSegment, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Zipcode Info
         * @param {string} leadZipcode 
         * @param {string | null} [customerSegment] 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZipcodeInfo(leadZipcode: string, customerSegment?: string | null, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getZipcodeInfo(leadZipcode, customerSegment, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Receive Salesforce Event
         * @param {EventbridgeEventSchema} eventbridgeEventSchema 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receiveSalesforceEvent(eventbridgeEventSchema: EventbridgeEventSchema, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.receiveSalesforceEvent(eventbridgeEventSchema, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Salesforce Check If Lead Is Test
         * @param {string} firstName 
         * @param {string} lastName 
         * @param {string} email 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        salesforceCheckIfLeadIsTest(firstName: string, lastName: string, email: string, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.salesforceCheckIfLeadIsTest(firstName, lastName, email, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Test Event
         * @param {{ [key: string]: any; }} requestBody 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testEvent(requestBody: { [key: string]: any; }, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.testEvent(requestBody, requestSource, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SalesforceApi - object-oriented interface
 * @export
 * @class SalesforceApi
 * @extends {BaseAPI}
 */
export class SalesforceApi extends BaseAPI {
    /**
     * 
     * @summary Get Feasibility By Zip Code
     * @param {string} leadZipcode 
     * @param {string | null} [customerSegment] 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesforceApi
     */
    public getFeasibilityByZipCode(leadZipcode: string, customerSegment?: string | null, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return SalesforceApiFp(this.configuration).getFeasibilityByZipCode(leadZipcode, customerSegment, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Zipcode Info
     * @param {string} leadZipcode 
     * @param {string | null} [customerSegment] 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesforceApi
     */
    public getZipcodeInfo(leadZipcode: string, customerSegment?: string | null, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return SalesforceApiFp(this.configuration).getZipcodeInfo(leadZipcode, customerSegment, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Receive Salesforce Event
     * @param {EventbridgeEventSchema} eventbridgeEventSchema 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesforceApi
     */
    public receiveSalesforceEvent(eventbridgeEventSchema: EventbridgeEventSchema, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return SalesforceApiFp(this.configuration).receiveSalesforceEvent(eventbridgeEventSchema, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Salesforce Check If Lead Is Test
     * @param {string} firstName 
     * @param {string} lastName 
     * @param {string} email 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesforceApi
     */
    public salesforceCheckIfLeadIsTest(firstName: string, lastName: string, email: string, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return SalesforceApiFp(this.configuration).salesforceCheckIfLeadIsTest(firstName, lastName, email, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Test Event
     * @param {{ [key: string]: any; }} requestBody 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesforceApi
     */
    public testEvent(requestBody: { [key: string]: any; }, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return SalesforceApiFp(this.configuration).testEvent(requestBody, requestSource, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SalesforceReportingApi - axios parameter creator
 * @export
 */
export const SalesforceReportingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves the count of total and D2C leads created per month from Salesforce. Optionally filters for a specific month or a range of months using query parameters. - If neither start_month nor end_month is provided, returns all months. - If only one is provided, filters for that specific month. - If both are provided, filters for the inclusive range.
         * @summary Get Number of Leads Created by Month
         * @param {string | null} [startMonth] Filter results starting from this month (YYYY-MM). If only start_month is provided, filters for this specific month.
         * @param {string | null} [endMonth] Filter results ending at this month (YYYY-MM, inclusive). If only end_month is provided, filters for this specific month.
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNumberOfLeadsCreatedByMonth: async (startMonth?: string | null, endMonth?: string | null, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/salesforce/reporting/cohorts/leads-by-month`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)

            if (startMonth !== undefined) {
                localVarQueryParameter['start_month'] = startMonth;
            }

            if (endMonth !== undefined) {
                localVarQueryParameter['end_month'] = endMonth;
            }


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the count of total and D2C leads created per month from Salesforce. Optionally filters for a specific month or a range of months using query parameters. - If neither start_month nor end_month is provided, returns all months. - If only one is provided, filters for that specific month. - If both are provided, filters for the inclusive range.
         * @summary Get Number of Leads Created by Month
         * @param {string | null} [startMonth] Filter results starting from this month (YYYY-MM). If only start_month is provided, filters for this specific month.
         * @param {string | null} [endMonth] Filter results ending at this month (YYYY-MM, inclusive). If only end_month is provided, filters for this specific month.
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNumberOfLeadsCreatedByMonth_1: async (startMonth?: string | null, endMonth?: string | null, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/salesforce/reporting/cohorts/leads-by-month`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)

            if (startMonth !== undefined) {
                localVarQueryParameter['start_month'] = startMonth;
            }

            if (endMonth !== undefined) {
                localVarQueryParameter['end_month'] = endMonth;
            }


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Placeholder Salesforce Reporting Endpoint
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placeholderSalesforceReportingEndpoint: async (requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/salesforce/reporting/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Google-ID-Token required
            await setApiKeyToObject(localVarHeaderParameter, "x-google-id-token", configuration)


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SalesforceReportingApi - functional programming interface
 * @export
 */
export const SalesforceReportingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SalesforceReportingApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves the count of total and D2C leads created per month from Salesforce. Optionally filters for a specific month or a range of months using query parameters. - If neither start_month nor end_month is provided, returns all months. - If only one is provided, filters for that specific month. - If both are provided, filters for the inclusive range.
         * @summary Get Number of Leads Created by Month
         * @param {string | null} [startMonth] Filter results starting from this month (YYYY-MM). If only start_month is provided, filters for this specific month.
         * @param {string | null} [endMonth] Filter results ending at this month (YYYY-MM, inclusive). If only end_month is provided, filters for this specific month.
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNumberOfLeadsCreatedByMonth(startMonth?: string | null, endMonth?: string | null, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LeadsByMonthResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNumberOfLeadsCreatedByMonth(startMonth, endMonth, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesforceReportingApi.getNumberOfLeadsCreatedByMonth']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the count of total and D2C leads created per month from Salesforce. Optionally filters for a specific month or a range of months using query parameters. - If neither start_month nor end_month is provided, returns all months. - If only one is provided, filters for that specific month. - If both are provided, filters for the inclusive range.
         * @summary Get Number of Leads Created by Month
         * @param {string | null} [startMonth] Filter results starting from this month (YYYY-MM). If only start_month is provided, filters for this specific month.
         * @param {string | null} [endMonth] Filter results ending at this month (YYYY-MM, inclusive). If only end_month is provided, filters for this specific month.
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNumberOfLeadsCreatedByMonth_1(startMonth?: string | null, endMonth?: string | null, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LeadsByMonthResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNumberOfLeadsCreatedByMonth_1(startMonth, endMonth, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesforceReportingApi.getNumberOfLeadsCreatedByMonth_1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Placeholder Salesforce Reporting Endpoint
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async placeholderSalesforceReportingEndpoint(requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.placeholderSalesforceReportingEndpoint(requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SalesforceReportingApi.placeholderSalesforceReportingEndpoint']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SalesforceReportingApi - factory interface
 * @export
 */
export const SalesforceReportingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SalesforceReportingApiFp(configuration)
    return {
        /**
         * Retrieves the count of total and D2C leads created per month from Salesforce. Optionally filters for a specific month or a range of months using query parameters. - If neither start_month nor end_month is provided, returns all months. - If only one is provided, filters for that specific month. - If both are provided, filters for the inclusive range.
         * @summary Get Number of Leads Created by Month
         * @param {string | null} [startMonth] Filter results starting from this month (YYYY-MM). If only start_month is provided, filters for this specific month.
         * @param {string | null} [endMonth] Filter results ending at this month (YYYY-MM, inclusive). If only end_month is provided, filters for this specific month.
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNumberOfLeadsCreatedByMonth(startMonth?: string | null, endMonth?: string | null, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<LeadsByMonthResponse> {
            return localVarFp.getNumberOfLeadsCreatedByMonth(startMonth, endMonth, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the count of total and D2C leads created per month from Salesforce. Optionally filters for a specific month or a range of months using query parameters. - If neither start_month nor end_month is provided, returns all months. - If only one is provided, filters for that specific month. - If both are provided, filters for the inclusive range.
         * @summary Get Number of Leads Created by Month
         * @param {string | null} [startMonth] Filter results starting from this month (YYYY-MM). If only start_month is provided, filters for this specific month.
         * @param {string | null} [endMonth] Filter results ending at this month (YYYY-MM, inclusive). If only end_month is provided, filters for this specific month.
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNumberOfLeadsCreatedByMonth_1(startMonth?: string | null, endMonth?: string | null, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<LeadsByMonthResponse> {
            return localVarFp.getNumberOfLeadsCreatedByMonth_1(startMonth, endMonth, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Placeholder Salesforce Reporting Endpoint
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placeholderSalesforceReportingEndpoint(requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.placeholderSalesforceReportingEndpoint(requestSource, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SalesforceReportingApi - object-oriented interface
 * @export
 * @class SalesforceReportingApi
 * @extends {BaseAPI}
 */
export class SalesforceReportingApi extends BaseAPI {
    /**
     * Retrieves the count of total and D2C leads created per month from Salesforce. Optionally filters for a specific month or a range of months using query parameters. - If neither start_month nor end_month is provided, returns all months. - If only one is provided, filters for that specific month. - If both are provided, filters for the inclusive range.
     * @summary Get Number of Leads Created by Month
     * @param {string | null} [startMonth] Filter results starting from this month (YYYY-MM). If only start_month is provided, filters for this specific month.
     * @param {string | null} [endMonth] Filter results ending at this month (YYYY-MM, inclusive). If only end_month is provided, filters for this specific month.
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesforceReportingApi
     */
    public getNumberOfLeadsCreatedByMonth(startMonth?: string | null, endMonth?: string | null, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return SalesforceReportingApiFp(this.configuration).getNumberOfLeadsCreatedByMonth(startMonth, endMonth, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the count of total and D2C leads created per month from Salesforce. Optionally filters for a specific month or a range of months using query parameters. - If neither start_month nor end_month is provided, returns all months. - If only one is provided, filters for that specific month. - If both are provided, filters for the inclusive range.
     * @summary Get Number of Leads Created by Month
     * @param {string | null} [startMonth] Filter results starting from this month (YYYY-MM). If only start_month is provided, filters for this specific month.
     * @param {string | null} [endMonth] Filter results ending at this month (YYYY-MM, inclusive). If only end_month is provided, filters for this specific month.
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesforceReportingApi
     */
    public getNumberOfLeadsCreatedByMonth_1(startMonth?: string | null, endMonth?: string | null, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return SalesforceReportingApiFp(this.configuration).getNumberOfLeadsCreatedByMonth_1(startMonth, endMonth, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Placeholder Salesforce Reporting Endpoint
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesforceReportingApi
     */
    public placeholderSalesforceReportingEndpoint(requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return SalesforceReportingApiFp(this.configuration).placeholderSalesforceReportingEndpoint(requestSource, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SlackApi - axios parameter creator
 * @export
 */
export const SlackApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Handle Slack events.
         * @summary Slack Event Controller
         * @param {Request} request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        slackEventController: async (request: Request, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'request' is not null or undefined
            assertParamExists('slackEventController', 'request', request)
            const localVarPath = `/slack/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Handle Slack interactive components.
         * @summary Slack Interactive Controller
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        slackInteractiveController: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/slack/interactive-endpoint`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SlackApi - functional programming interface
 * @export
 */
export const SlackApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SlackApiAxiosParamCreator(configuration)
    return {
        /**
         * Handle Slack events.
         * @summary Slack Event Controller
         * @param {Request} request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async slackEventController(request: Request, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.slackEventController(request, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SlackApi.slackEventController']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Handle Slack interactive components.
         * @summary Slack Interactive Controller
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async slackInteractiveController(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.slackInteractiveController(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SlackApi.slackInteractiveController']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SlackApi - factory interface
 * @export
 */
export const SlackApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SlackApiFp(configuration)
    return {
        /**
         * Handle Slack events.
         * @summary Slack Event Controller
         * @param {Request} request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        slackEventController(request: Request, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.slackEventController(request, options).then((request) => request(axios, basePath));
        },
        /**
         * Handle Slack interactive components.
         * @summary Slack Interactive Controller
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        slackInteractiveController(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.slackInteractiveController(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SlackApi - object-oriented interface
 * @export
 * @class SlackApi
 * @extends {BaseAPI}
 */
export class SlackApi extends BaseAPI {
    /**
     * Handle Slack events.
     * @summary Slack Event Controller
     * @param {Request} request 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SlackApi
     */
    public slackEventController(request: Request, options?: RawAxiosRequestConfig) {
        return SlackApiFp(this.configuration).slackEventController(request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Handle Slack interactive components.
     * @summary Slack Interactive Controller
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SlackApi
     */
    public slackInteractiveController(options?: RawAxiosRequestConfig) {
        return SlackApiFp(this.configuration).slackInteractiveController(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TeamApi - axios parameter creator
 * @export
 */
export const TeamApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Team Member Photo
         * @param {string} email 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamMemberPhoto: async (email: string, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('getTeamMemberPhoto', 'email', email)
            const localVarPath = `/team/member/photo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TeamApi - functional programming interface
 * @export
 */
export const TeamApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TeamApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Team Member Photo
         * @param {string} email 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeamMemberPhoto(email: string, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeamMemberPhoto(email, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.getTeamMemberPhoto']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TeamApi - factory interface
 * @export
 */
export const TeamApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TeamApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Team Member Photo
         * @param {string} email 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamMemberPhoto(email: string, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getTeamMemberPhoto(email, requestSource, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TeamApi - object-oriented interface
 * @export
 * @class TeamApi
 * @extends {BaseAPI}
 */
export class TeamApi extends BaseAPI {
    /**
     * 
     * @summary Get Team Member Photo
     * @param {string} email 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public getTeamMemberPhoto(email: string, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).getTeamMemberPhoto(email, requestSource, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VillabotApi - axios parameter creator
 * @export
 */
export const VillabotApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Handles chat requests via POST and streams responses using SSE. Accepts a JSON body with \'question\'.
         * @summary Chat Cost Code Endpoint
         * @param {CostCodeRequest} costCodeRequest 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatCostCodeEndpoint: async (costCodeRequest: CostCodeRequest, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'costCodeRequest' is not null or undefined
            assertParamExists('chatCostCodeEndpoint', 'costCodeRequest', costCodeRequest)
            const localVarPath = `/villabot/cost-code`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication API-Key required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(costCodeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Handles chat requests via POST and streams responses using SSE. Accepts a JSON body with \'prompt\' and optional \'chat_history\'.
         * @summary Chat Sse Endpoint
         * @param {ChatRequest} chatRequest 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatSseEndpoint: async (chatRequest: ChatRequest, requestSource?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatRequest' is not null or undefined
            assertParamExists('chatSseEndpoint', 'chatRequest', chatRequest)
            const localVarPath = `/villabot/chat-sse`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication API-Key required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (requestSource != null) {
                localVarHeaderParameter['request-source'] = String(requestSource);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chatRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VillabotApi - functional programming interface
 * @export
 */
export const VillabotApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VillabotApiAxiosParamCreator(configuration)
    return {
        /**
         * Handles chat requests via POST and streams responses using SSE. Accepts a JSON body with \'question\'.
         * @summary Chat Cost Code Endpoint
         * @param {CostCodeRequest} costCodeRequest 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatCostCodeEndpoint(costCodeRequest: CostCodeRequest, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatCostCodeEndpoint(costCodeRequest, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VillabotApi.chatCostCodeEndpoint']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Handles chat requests via POST and streams responses using SSE. Accepts a JSON body with \'prompt\' and optional \'chat_history\'.
         * @summary Chat Sse Endpoint
         * @param {ChatRequest} chatRequest 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatSseEndpoint(chatRequest: ChatRequest, requestSource?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatSseEndpoint(chatRequest, requestSource, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VillabotApi.chatSseEndpoint']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VillabotApi - factory interface
 * @export
 */
export const VillabotApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VillabotApiFp(configuration)
    return {
        /**
         * Handles chat requests via POST and streams responses using SSE. Accepts a JSON body with \'question\'.
         * @summary Chat Cost Code Endpoint
         * @param {CostCodeRequest} costCodeRequest 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatCostCodeEndpoint(costCodeRequest: CostCodeRequest, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.chatCostCodeEndpoint(costCodeRequest, requestSource, options).then((request) => request(axios, basePath));
        },
        /**
         * Handles chat requests via POST and streams responses using SSE. Accepts a JSON body with \'prompt\' and optional \'chat_history\'.
         * @summary Chat Sse Endpoint
         * @param {ChatRequest} chatRequest 
         * @param {string | null} [requestSource] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatSseEndpoint(chatRequest: ChatRequest, requestSource?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.chatSseEndpoint(chatRequest, requestSource, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VillabotApi - object-oriented interface
 * @export
 * @class VillabotApi
 * @extends {BaseAPI}
 */
export class VillabotApi extends BaseAPI {
    /**
     * Handles chat requests via POST and streams responses using SSE. Accepts a JSON body with \'question\'.
     * @summary Chat Cost Code Endpoint
     * @param {CostCodeRequest} costCodeRequest 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VillabotApi
     */
    public chatCostCodeEndpoint(costCodeRequest: CostCodeRequest, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return VillabotApiFp(this.configuration).chatCostCodeEndpoint(costCodeRequest, requestSource, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Handles chat requests via POST and streams responses using SSE. Accepts a JSON body with \'prompt\' and optional \'chat_history\'.
     * @summary Chat Sse Endpoint
     * @param {ChatRequest} chatRequest 
     * @param {string | null} [requestSource] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VillabotApi
     */
    public chatSseEndpoint(chatRequest: ChatRequest, requestSource?: string | null, options?: RawAxiosRequestConfig) {
        return VillabotApiFp(this.configuration).chatSseEndpoint(chatRequest, requestSource, options).then((request) => request(this.axios, this.basePath));
    }
}



